import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "content-panel step-three-panel" }
const _hoisted_2 = { class: "panel-header" }
const _hoisted_3 = { class: "panel-icon" }
const _hoisted_4 = { class: "panel-header-actions" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "panel-body" }
const _hoisted_8 = {
  key: 0,
  class: "confirmed-notice-banner"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 3,
  class: "data-table-container"
}
const _hoisted_11 = { class: "table-scroll-wrapper" }
const _hoisted_12 = { class: "data-table" }
const _hoisted_13 = {
  key: 0,
  class: "main-row"
}
const _hoisted_14 = { class: "merged-cell caregiver-info" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "total-cell number-cell" }
const _hoisted_18 = { class: "total-cell number-cell" }
const _hoisted_19 = { class: "input-cell pension-cell" }
const _hoisted_20 = { class: "pension-input-wrapper" }
const _hoisted_21 = ["onUpdate:modelValue", "onChange", "disabled"]
const _hoisted_22 = ["onUpdate:modelValue", "onInput", "onBlur", "onFocus", "disabled"]
const _hoisted_23 = { class: "checkbox-cell" }
const _hoisted_24 = ["onUpdate:modelValue", "disabled"]
const _hoisted_25 = { class: "checkbox-cell employment-checkbox-cell" }
const _hoisted_26 = ["checked", "onClick", "disabled"]
const _hoisted_27 = {
  key: 0,
  class: "unemployment-only-badge",
  title: "실업급여만 적용"
}
const _hoisted_28 = { class: "checkbox-cell" }
const _hoisted_29 = ["onUpdate:modelValue", "disabled"]
const _hoisted_30 = { class: "checkbox-cell" }
const _hoisted_31 = ["onUpdate:modelValue", "disabled"]
const _hoisted_32 = { class: "checkbox-cell" }
const _hoisted_33 = ["onUpdate:modelValue", "disabled"]
const _hoisted_34 = { class: "checkbox-cell" }
const _hoisted_35 = ["onUpdate:modelValue", "disabled"]
const _hoisted_36 = { class: "input-cell pension-cell" }
const _hoisted_37 = { class: "pension-input-wrapper" }
const _hoisted_38 = ["onUpdate:modelValue", "onChange", "disabled"]
const _hoisted_39 = ["onUpdate:modelValue", "onInput", "onBlur", "onFocus", "disabled"]
const _hoisted_40 = { class: "input-cell pension-cell" }
const _hoisted_41 = { class: "pension-input-wrapper" }
const _hoisted_42 = ["onUpdate:modelValue", "onChange", "disabled"]
const _hoisted_43 = ["onUpdate:modelValue", "onInput", "onBlur", "onFocus", "onClick", "disabled"]
const _hoisted_44 = { class: "input-cell pension-cell" }
const _hoisted_45 = { class: "pension-input-wrapper" }
const _hoisted_46 = ["onUpdate:modelValue", "onChange", "disabled"]
const _hoisted_47 = ["onUpdate:modelValue", "onInput", "onBlur", "onFocus", "disabled"]
const _hoisted_48 = {
  key: 1,
  class: "detail-row time-pay-detail"
}
const _hoisted_49 = {
  colspan: "15",
  class: "detail-content-cell"
}
const _hoisted_50 = { class: "time-pay-details" }
const _hoisted_51 = { class: "time-pay-content-wrapper" }
const _hoisted_52 = { class: "time-pay-left" }
const _hoisted_53 = { class: "time-pay-header-text" }
const _hoisted_54 = ["onClick", "disabled"]
const _hoisted_55 = { class: "time-pay-list" }
const _hoisted_56 = { class: "item-left" }
const _hoisted_57 = { class: "patient-name" }
const _hoisted_58 = { class: "suga-name" }
const _hoisted_59 = { class: "item-center" }
const _hoisted_60 = { class: "service-badge" }
const _hoisted_61 = ["onClick", "disabled"]
const _hoisted_62 = { class: "hours-value" }
const _hoisted_63 = ["onClick", "disabled"]
const _hoisted_64 = ["onClick", "disabled"]
const _hoisted_65 = { class: "item-right" }
const _hoisted_66 = ["value", "onInput", "onBlur", "onFocus", "disabled"]
const _hoisted_67 = { class: "employee-summary-section" }
const _hoisted_68 = { class: "time-pay-header-text" }
const _hoisted_69 = { class: "employee-summary" }
const _hoisted_70 = { class: "summary-quick-info" }
const _hoisted_71 = { class: "quick-info-item" }
const _hoisted_72 = { class: "quick-info-item" }
const _hoisted_73 = ["onClick"]
const _hoisted_74 = {
  key: 1,
  class: "quick-info-item boss-badge"
}
const _hoisted_75 = ["onClick"]
const _hoisted_76 = {
  key: 0,
  class: "employee-features-detailed"
}
const _hoisted_77 = {
  key: 0,
  class: "payroll-details-tab"
}
const _hoisted_78 = { class: "payroll-section-compact" }
const _hoisted_79 = { class: "section-header-compact" }
const _hoisted_80 = { class: "payroll-grid-compact" }
const _hoisted_81 = {
  key: 0,
  class: "payroll-item-compact full-width"
}
const _hoisted_82 = { class: "value" }
const _hoisted_83 = { class: "payroll-item-compact" }
const _hoisted_84 = { class: "value" }
const _hoisted_85 = { class: "payroll-item-compact" }
const _hoisted_86 = { class: "value" }
const _hoisted_87 = { class: "payroll-item-compact" }
const _hoisted_88 = { class: "value" }
const _hoisted_89 = { class: "payroll-item-compact" }
const _hoisted_90 = { class: "value" }
const _hoisted_91 = { class: "payroll-item-compact subtotal" }
const _hoisted_92 = { class: "value" }
const _hoisted_93 = { class: "payroll-row-flex" }
const _hoisted_94 = { class: "payroll-section-compact" }
const _hoisted_95 = { class: "section-header-compact" }
const _hoisted_96 = { class: "payroll-grid-compact" }
const _hoisted_97 = { class: "payroll-item-compact" }
const _hoisted_98 = { class: "value" }
const _hoisted_99 = { class: "payroll-item-compact" }
const _hoisted_100 = { class: "value" }
const _hoisted_101 = { class: "payroll-item-compact" }
const _hoisted_102 = { class: "value" }
const _hoisted_103 = { class: "payroll-item-compact" }
const _hoisted_104 = { class: "value" }
const _hoisted_105 = { class: "payroll-item-compact subtotal" }
const _hoisted_106 = { class: "value" }
const _hoisted_107 = { class: "payroll-row-flex" }
const _hoisted_108 = {
  key: 0,
  class: "payroll-section-compact tax-savings-card"
}
const _hoisted_109 = { class: "section-header-compact" }
const _hoisted_110 = { class: "payroll-grid-compact" }
const _hoisted_111 = { class: "payroll-item-compact" }
const _hoisted_112 = { class: "value highlight" }
const _hoisted_113 = { class: "payroll-item-compact savings-item" }
const _hoisted_114 = { class: "label" }
const _hoisted_115 = { class: "value text-blue" }
const _hoisted_116 = { class: "payroll-item-compact savings-item" }
const _hoisted_117 = { class: "label" }
const _hoisted_118 = { class: "value text-green" }
const _hoisted_119 = { class: "payroll-total-compact" }
const _hoisted_120 = { class: "value" }
const _hoisted_121 = { class: "payroll-section-compact" }
const _hoisted_122 = { class: "section-header-compact" }
const _hoisted_123 = { class: "payroll-grid-compact" }
const _hoisted_124 = { class: "payroll-item-compact" }
const _hoisted_125 = { class: "value" }
const _hoisted_126 = { class: "payroll-item-compact" }
const _hoisted_127 = { class: "value" }
const _hoisted_128 = { class: "value" }
const _hoisted_129 = { class: "payroll-item-compact retirement-cumulative" }
const _hoisted_130 = { class: "value" }
const _hoisted_131 = { class: "payroll-section-compact" }
const _hoisted_132 = { class: "section-header-compact" }
const _hoisted_133 = { class: "payroll-grid-compact" }
const _hoisted_134 = ["title"]
const _hoisted_135 = { class: "value" }
const _hoisted_136 = ["title"]
const _hoisted_137 = { class: "value" }
const _hoisted_138 = ["title"]
const _hoisted_139 = { class: "value" }
const _hoisted_140 = ["title"]
const _hoisted_141 = { class: "value" }
const _hoisted_142 = ["title"]
const _hoisted_143 = { class: "value" }
const _hoisted_144 = ["title"]
const _hoisted_145 = { class: "value" }
const _hoisted_146 = ["title"]
const _hoisted_147 = { class: "value" }
const _hoisted_148 = ["title"]
const _hoisted_149 = { class: "value" }
const _hoisted_150 = ["title"]
const _hoisted_151 = { class: "value" }
const _hoisted_152 = ["title"]
const _hoisted_153 = { class: "value" }
const _hoisted_154 = { class: "payroll-section-compact" }
const _hoisted_155 = { class: "section-header-compact" }
const _hoisted_156 = { class: "payroll-grid-compact" }
const _hoisted_157 = ["title"]
const _hoisted_158 = { class: "value" }
const _hoisted_159 = ["title"]
const _hoisted_160 = { class: "value" }
const _hoisted_161 = ["title"]
const _hoisted_162 = { class: "value" }
const _hoisted_163 = ["title"]
const _hoisted_164 = { class: "value" }
const _hoisted_165 = ["title"]
const _hoisted_166 = { class: "value" }
const _hoisted_167 = ["title"]
const _hoisted_168 = { class: "value" }
const _hoisted_169 = ["title"]
const _hoisted_170 = { class: "value" }
const _hoisted_171 = ["title"]
const _hoisted_172 = { class: "value" }
const _hoisted_173 = { class: "payroll-net-pay-compact" }
const _hoisted_174 = { class: "value" }
const _hoisted_175 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_176 = { class: "features-columns" }
const _hoisted_177 = { class: "features-column info-column" }
const _hoisted_178 = { class: "column-header" }
const _hoisted_179 = { class: "features-list" }
const _hoisted_180 = { class: "features-column restriction-column" }
const _hoisted_181 = { class: "column-header" }
const _hoisted_182 = { class: "features-list" }
const _hoisted_183 = ["onClick"]
const _hoisted_184 = {
  key: 1,
  class: "no-restrictions"
}
const _hoisted_185 = { class: "service-details-tab" }
const _hoisted_186 = {
  key: 0,
  class: "service-table-wrapper"
}
const _hoisted_187 = { class: "service-table-compact" }
const _hoisted_188 = { class: "date-with-badge" }
const _hoisted_189 = {
  key: 0,
  class: "sunday-badge-sm"
}
const _hoisted_190 = {
  key: 1,
  class: "holiday-badge-sm"
}
const _hoisted_191 = {
  key: 0,
  class: "meal-badge-sm"
}
const _hoisted_192 = { class: "amount-cell" }
const _hoisted_193 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_194 = { class: "weekly-details-tab" }
const _hoisted_195 = {
  key: 0,
  class: "service-table-wrapper"
}
const _hoisted_196 = { class: "weekly-table-compact" }
const _hoisted_197 = ["rowspan"]
const _hoisted_198 = { class: "week-badge-sm" }
const _hoisted_199 = { class: "date-cell" }
const _hoisted_200 = { class: "date-with-badge" }
const _hoisted_201 = {
  key: 0,
  class: "sunday-badge-sm"
}
const _hoisted_202 = {
  key: 1,
  class: "holiday-badge-sm"
}
const _hoisted_203 = ["rowspan"]
const _hoisted_204 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_205 = {
  key: 4,
  class: "member-info-loading"
}
const _hoisted_206 = {
  key: 5,
  class: "member-info-empty"
}
const _hoisted_207 = { class: "confirm-dialog-header" }
const _hoisted_208 = { class: "confirm-dialog-footer" }
const _hoisted_209 = { class: "confirm-dialog-header warning" }
const _hoisted_210 = { class: "confirm-dialog-footer" }
const _hoisted_211 = { class: "confirm-dialog-header" }
const _hoisted_212 = { class: "confirm-dialog-body" }
const _hoisted_213 = { class: "bonin-pay-info" }
const _hoisted_214 = { class: "info-row" }
const _hoisted_215 = { class: "info-value" }
const _hoisted_216 = { class: "info-row" }
const _hoisted_217 = { class: "info-value highlight" }
const _hoisted_218 = { class: "bonin-pay-options" }
const _hoisted_219 = { class: "option-buttons" }
const _hoisted_220 = { class: "amount" }
const _hoisted_221 = { class: "amount" }
const _hoisted_222 = { class: "amount" }
const _hoisted_223 = { class: "confirm-dialog-footer" }
const _hoisted_224 = ["disabled"]
const _hoisted_225 = { class: "confirm-dialog-header" }
const _hoisted_226 = { class: "confirm-dialog-body" }
const _hoisted_227 = { class: "employment-info" }
const _hoisted_228 = { class: "info-row" }
const _hoisted_229 = { class: "info-value" }
const _hoisted_230 = { class: "info-row" }
const _hoisted_231 = {
  key: 0,
  class: "age-note"
}
const _hoisted_232 = { class: "employment-options" }
const _hoisted_233 = { class: "option-icon" }
const _hoisted_234 = { class: "option-check" }
const _hoisted_235 = { class: "option-icon" }
const _hoisted_236 = { class: "option-check" }
const _hoisted_237 = { class: "option-icon" }
const _hoisted_238 = { class: "option-check" }
const _hoisted_239 = { class: "confirm-dialog-footer" }
const _hoisted_240 = ["disabled"]
const _hoisted_241 = { class: "confirm-dialog-header" }
const _hoisted_242 = { class: "confirm-dialog-body" }
const _hoisted_243 = { class: "suga-hours-info" }
const _hoisted_244 = { class: "info-row" }
const _hoisted_245 = { class: "info-value" }
const _hoisted_246 = { class: "info-row" }
const _hoisted_247 = { class: "info-value" }
const _hoisted_248 = { class: "info-row" }
const _hoisted_249 = { class: "info-value original" }
const _hoisted_250 = { class: "suga-hours-selector" }
const _hoisted_251 = { class: "hours-control" }
const _hoisted_252 = ["disabled"]
const _hoisted_253 = { class: "hours-display" }
const _hoisted_254 = { class: "hours-value" }
const _hoisted_255 = ["disabled"]
const _hoisted_256 = { class: "hours-presets" }
const _hoisted_257 = ["onClick"]
const _hoisted_258 = ["disabled"]
const _hoisted_259 = { class: "confirm-dialog-footer" }

import { ref, computed, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';
import SetModal from '@/components/wage/SetModal.vue';
import WageWholeVersion from '@/components/wage/WageWholeVersion.vue';
import WageEmployeeList from './WageEmployeeList.vue';
import WageEmployeeModal from './WageEmployeeModal.vue';
import WageEmployeeCalendar from './WageEmployeeCalendar.vue';
import {
  shouldShowAdminDeductionTooltip,
  buildDeductionTooltip,
  buildCenterTooltip,
} from './payrollTooltipUtils';

interface PatientInfo {
  patientCode: string;
  patientName: string;
  sugaCode: string;
  sugaName: string;
  sugaMinutesKey: number | null;  // 270분초과 수가의 경우 수가시간(30분 단위)
  timePay: string;
  serviceDays: number;
  sugaHours: number;
  totalSugaMoney: number;
  lunchTimeCount: number;
}

interface GroupedMember {
  empCode: string;  // hh_emp 테이블의 emp_code
  name: string;
  birth: string;
  gender: string;
  license: string;
  workStartDate: string;
  workEndDate: string;
  patients: PatientInfo[];
  originalItems: any[];
  totalSugaMoney: number;
  totalLunchTimeCount: number;
  isBoss: boolean;
}

interface SettingsItem {
  applyNationalPension: boolean;
  yeonPay: string;
  applyBoninPay: boolean;
  boninPay: string;
  applyHealthInsurance: boolean;
  applyEmploymentInsurance: boolean;
  applyUnemployment: boolean;
  applyRetirement: boolean;
  applyHoliday: boolean;
  applyOvertime: boolean;
  applyMeal: boolean;
  applyLongServicePay: boolean;
  longServicePay: string;
  applyEtcAllowance: boolean;
  etcAllowance: string;
  applyBosuEduPay: boolean;
  bosuEduPay: string;
  applyEmpEtc: boolean;
  empEtc: string;
  timePays: Record<string, Record<string, string>>;
  customSugaHours: Record<string, Record<string, number>>;
  sugaHoursChanged: boolean;
  _hasYeonPaySetting?: boolean;  // DB에 국민연금 설정이 저장된 적이 있는지 플래그
}


export default /*@__PURE__*/_defineComponent({
  __name: 'StepThree',
  props: {
    stepCompleted: { type: Boolean },
    isConfirmed: { type: Boolean },
    isConfirming: { type: Boolean },
    yearMonth: {}
  },
  emits: ["open-settings", "confirm", "release"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useStore();

const isConfirmed = computed(() => !!props.isConfirmed);
const isConfirming = computed(() => !!props.isConfirming);

const showAdminDeductionTooltip = computed(() =>
  shouldShowAdminDeductionTooltip(store.getters.isAdmin, store.getters.isImpersonating)
);

const deductionTooltip = (groupIndex: number, field: string): string => {
  if (!showAdminDeductionTooltip.value) return '';
  return buildDeductionTooltip(field, payrollDetails.value[groupIndex], settingsData.value[groupIndex]);
};

const centerTooltip = (groupIndex: number, field: string): string => {
  if (!showAdminDeductionTooltip.value) return '';
  return buildCenterTooltip(field, payrollDetails.value[groupIndex], settingsData.value[groupIndex]);
};

// 확정 가능 여부 계산 (내부 로직)
const stepCompleted = computed(() => {
  // props로 전달된 값이 있으면 우선 사용 (DB 확정 상태)
  if (props.stepCompleted) return true;
  
  // 데이터가 없으면 false
  if (!memberInfoData.value || memberInfoData.value.length === 0) {
    return false;
  }
  
  // 모든 요양보호사의 모든 수급자에 대해 시급이 입력되어 있는지 확인
  for (let groupIndex = 0; groupIndex < groupedMemberData.value.length; groupIndex++) {
    const group = groupedMemberData.value[groupIndex];
    const settings = settingsData.value[groupIndex];
    
    if (!settings || !settings.timePays) {
      return false;
    }
    
    // 각 수급자별로 시급이 입력되어 있는지 확인
    for (const patient of group.patients) {
      // getSugaKey 함수와 동일한 로직 사용 (hoursKey 포함)
      const hoursKey = patient.sugaHours ? `_h${patient.sugaHours}` : '';
      const sugaKey = patient.sugaMinutesKey != null 
        ? `${patient.sugaCode}_${patient.sugaMinutesKey}${hoursKey}` 
        : `${patient.sugaCode}${hoursKey}`;
      
      const timePay = settings.timePays[patient.patientCode]?.[sugaKey];
      if (!timePay || !String(timePay).trim()) {
        return false;
      }
      
      // 시급이 0보다 큰지 확인
      const numericTimePay = parseFloat(String(timePay).replace(/[^\d]/g, '')) || 0;
      if (numericTimePay <= 0) {
        return false;
      }
    }
  }
  
  return true;
});

// 확정/해제 확인 다이얼로그 상태
const showConfirmDialog = ref(false);
const showReleaseDialog = ref(false);

// 본인부담금공제 모달 상태
const showBoninPayModal = ref(false);
const currentBoninPayGroupIndex = ref<number | null>(null);
const currentBoninPayCaregiver = ref<{ name: string; familySugaMoney: number } | null>(null);
const selectedBoninRate = ref<number | null>(null);

// 고용보험 모달 상태
const showEmploymentModal = ref(false);
const currentEmploymentGroupIndex = ref<number | null>(null);
const currentEmploymentCaregiver = ref<{ name: string; age: number } | null>(null);
const selectedEmploymentOption = ref<'both' | 'unemployment-only' | 'none' | null>(null);

// 수가시간 조정 모달 상태
const showSugaHoursModal = ref(false);
const currentSugaHoursGroupIndex = ref<number | null>(null);
const currentSugaHoursPatient = ref<{
  patientCode: string;
  patientName: string;
  sugaKey: string;
  sugaName: string;
  originalHours: number;
} | null>(null);
const selectedSugaHours = ref<number>(0);

// 수가시간 인라인 드롭다운 상태 (groupIndex_patientCode_sugaKey 형태로 저장)
const openSugaHoursDropdown = ref<string | null>(null);

// 일괄 설정 모달 상태
const showSetModal = ref(false);

// 전체급여상세 표시 상태
const showWholeVersion = ref(false);

// 사원 상세 모달 상태 (WageEmployeeModal용)
const showEmployeeModal = ref(false);
const selectedEmployeeIndex = ref(0);
const selectedEmployee = ref<GroupedMember | null>(null);

// Member Info 데이터
const memberInfoData = ref<any[]>([]);
const memberJoinDetailData = ref<any[]>([]); // 중증수급자 가산 포함 데이터
const isLoadingMemberInfo = ref(false);
const isSaving = ref(false);

// 펼쳐진 시급 행 관리
const expandedTimePay = ref(new Set<number>());

// 제한사항 상세 펼침 관리
const expandedRestrictions = ref<Record<number, Set<number>>>({});

// 직원 급여 상세 정보 펼침 관리
const expandedEmployeeInfo = ref(new Set<number>());

// 급여 상세 정보 탭 관리
const detailTab = ref<Record<number, string>>({});

// 서비스 내역 데이터
const individualServices = ref<Record<number, any[]>>({});

// 중증수급자 가산 일자별 데이터
const severeCareAdditionDaily = ref<Record<number, any[]>>({});

// 주차별 근무내역 데이터
const combinedWeeklyServices = ref<Record<number, any[]>>({});

// 급여 상세 데이터
const payrollDetails = ref<Record<number, any>>({});

// 누적 퇴직금 데이터 (직원명 기준)
const cumulativeRetirement = ref<Record<string, number>>({});

// 설정 데이터
const settingsData = ref<Record<number, SettingsItem>>({});

// 세액 및 최저시급 데이터
const taxData = ref<any>({});

// 소득세 간이세액표 데이터
const sojiData = ref<any[]>([]);

// 공휴일 데이터
const holidaysData = ref<Record<string, string>>({});

// 저장되지 않은 변경사항 추적
const hasUnsavedChanges = ref(false);

// 원래 설정 데이터 (변경사항 비교용)
const originalSettingsData = ref<Record<number, string>>({});

// 변경사항 확인 함수
const checkUnsavedChanges = () => {
  let hasChanges = false;
  for (const groupIndex of Object.keys(settingsData.value)) {
    const idx = Number(groupIndex);
    const current = JSON.stringify(settingsData.value[idx]);
    const original = originalSettingsData.value[idx];
    if (current !== original) {
      hasChanges = true;
      break;
    }
  }
  hasUnsavedChanges.value = hasChanges;
};

// 원래 설정 저장
const saveOriginalSettings = () => {
  for (const groupIndex of Object.keys(settingsData.value)) {
    const idx = Number(groupIndex);
    originalSettingsData.value[idx] = JSON.stringify(settingsData.value[idx]);
  }
};

// 시급 행 펼치기/접기
const toggleTimePay = (index: number) => {
  if (expandedTimePay.value.has(index)) {
    expandedTimePay.value.delete(index);
  } else {
    expandedTimePay.value.add(index);
  }
};

// 시급 행이 펼쳐져 있는지 확인
const isTimePayExpanded = (index: number) => {
  return expandedTimePay.value.has(index);
};

// 제한사항 상세 토글
const toggleRestrictionDetail = (groupIndex: number, restrictionIndex: number) => {
  if (!expandedRestrictions.value[groupIndex]) {
    expandedRestrictions.value[groupIndex] = new Set();
  }
  
  if (expandedRestrictions.value[groupIndex].has(restrictionIndex)) {
    expandedRestrictions.value[groupIndex].delete(restrictionIndex);
  } else {
    expandedRestrictions.value[groupIndex].add(restrictionIndex);
  }
};

// 직원 급여 상세 정보 토글
const toggleEmployeeInfo = (groupIndex: number) => {
  if (expandedEmployeeInfo.value.has(groupIndex)) {
    expandedEmployeeInfo.value.delete(groupIndex);
  } else {
    expandedEmployeeInfo.value.add(groupIndex);
    // 탭 초기값 설정 (급여 상세가 기본)
    if (!detailTab.value[groupIndex]) {
      detailTab.value[groupIndex] = 'payroll';
    }
  }
};

// 직원 급여 상세 정보가 펼쳐져 있는지 확인
const isEmployeeInfoExpanded = (groupIndex: number) => {
  return expandedEmployeeInfo.value.has(groupIndex);
};

// 시급 미입력 여부 확인
const hasMissingTimePay = (groupIndex: number) => {
  const settings = settingsData.value[groupIndex];
  const group = groupedMemberData.value[groupIndex];

  if (!settings || !group) return true;

  return group.patients.some((patient) => {
    // 270분초과의 경우 수가시간별 키 사용
    const sugaKey = getSugaKey(patient);
    const value = settings.timePays?.[patient.patientCode]?.[sugaKey];
    return !value || !String(value).trim();
  });
};

// 제한사항 탭 열기 (클릭 시 급여 상세 정보 열고 직원 정보 탭으로 이동)
const openRestrictionsTab = (groupIndex: number) => {
  // 급여 상세 정보가 닫혀있으면 열기
  if (!expandedEmployeeInfo.value.has(groupIndex)) {
    expandedEmployeeInfo.value.add(groupIndex);
  }
  // 직원 정보 탭으로 이동
  detailTab.value[groupIndex] = 'info';
};

// 사원별로 그룹화된 데이터
const groupedMemberData = computed<GroupedMember[]>(() => {
  if (!memberInfoData.value || memberInfoData.value.length === 0) return [];

  const groups: Record<string, GroupedMember> = {};

  memberInfoData.value.forEach((item) => {
    const key = `${item.lemi_name}_${item.lemi_birth}`;
    
    if (!groups[key]) {
      groups[key] = {
        empCode: item.emp_code || '',  // hh_emp 테이블의 emp_code
        name: item.lemi_name,
        birth: item.lemi_birth,
        gender: item.lemi_gender,
        license: item.lemi_license,
        workStartDate: item.lemi_work_start_date,
        workEndDate: item.lemi_work_end_date,
        patients: [],
        originalItems: [],
        totalSugaMoney: 0,
        totalLunchTimeCount: 0,
        isBoss: item.lem_isboss === 'Y'
      };
    }

    // 수가 금액 누적
    const sugaMoney = parseFloat(String(item.total_suga_money || 0).replace(/[^\d]/g, '')) || 0;
    groups[key].totalSugaMoney += sugaMoney;
    
    // 식대 카운트 누적 (12:00 ~ 13:00 사이 근무한 일수)
    const lunchCount = Number(item.lunch_time_count) || 0;
    groups[key].totalLunchTimeCount += lunchCount;

    // 270분초과 수가의 경우 수가시간(30분 단위)별로 분리된 키 사용
    const sugaMinutesKey = item.suga_minutes_key != null ? Number(item.suga_minutes_key) : null;
    
    groups[key].patients.push({
      patientCode: item.lemi_patient_code,
      patientName: item.patient_name || item.lemi_patient_code,
      sugaCode: item.lemi_suga_code,
      sugaName: item.suga_name || '-',
      sugaMinutesKey: sugaMinutesKey,
      timePay: item.lemi_time_pay || '',
      serviceDays: item.service_days || 0,
      sugaHours: parseFloat(String(item.suga_hours || 0).replace(/[^\d.-]/g, '')) || 0,
      totalSugaMoney: sugaMoney,
      lunchTimeCount: lunchCount
    });
    groups[key].originalItems.push(item);
  });

  const result = Object.values(groups);
  

  return result;
});

// 수가 키 생성 함수 (원래 수가시간도 포함하여 같은 수급자/수가코드라도 구분)
const getSugaKey = (patient: PatientInfo): string => {
  // 원래 수가시간을 키에 포함하여 중복 카드 구분
  const hoursKey = patient.sugaHours ? `_h${patient.sugaHours}` : '';
  
  if (patient.sugaMinutesKey != null) {
    return `${patient.sugaCode}_${patient.sugaMinutesKey}${hoursKey}`;
  }
  return `${patient.sugaCode}${hoursKey}`;
};

// 수가명 표시 (270분초과의 경우 수가시간도 표시)
const getDisplaySugaName = (patient: PatientInfo): string => {
  if (patient.sugaMinutesKey != null && patient.sugaName?.includes('270분초과')) {
    const hours = patient.sugaMinutesKey / 60;
    const displayHours = hours % 1 === 0 ? `${hours}시간` : `${hours.toFixed(1)}시간`;
    return `${patient.sugaName} (${displayHours})`;
  }
  return patient.sugaName || '-';
};

// 설정 데이터 초기화
const initializeSettingsData = () => {
  groupedMemberData.value.forEach((group, index) => {
    if (!settingsData.value[index]) {
      const firstItem = group.originalItems[0];
      
      // 수급자별 시급 초기화 (270분초과는 수가시간별로 구분)
      const timePays: Record<string, Record<string, string>> = {};
      group.patients.forEach((patient) => {
        if (!timePays[patient.patientCode]) {
          timePays[patient.patientCode] = {};
        }
        // 기존 시급 값 포맷팅
        let timePay = patient.timePay || '';
        if (timePay) {
          const numericValue = parseFloat(String(timePay).replace(/[^\d]/g, '')) || 0;
          if (numericValue > 0) {
            timePay = new Intl.NumberFormat('ko-KR').format(numericValue);
          }
        }
        // 270분초과의 경우 수가시간별 키 사용
        const sugaKey = getSugaKey(patient);
        timePays[patient.patientCode][sugaKey] = timePay;
      });

      // 장기근속수당 포맷팅
      let longServicePay = firstItem?.lemi_long_service_pay || '';
      let applyLongServicePay = false;
      if (longServicePay) {
        const numericValue = parseFloat(String(longServicePay).replace(/[^\d]/g, '')) || 0;
        if (numericValue > 0) {
          longServicePay = new Intl.NumberFormat('ko-KR').format(numericValue);
          applyLongServicePay = true;
        }
      }

      // 국민연금 포맷팅
      // DB에 lemi_yeon_pay 필드가 존재하면 (빈 문자열이든 값이 있든) 이미 저장된 적이 있음
      // lemi_yeon_pay가 undefined가 아니면 이미 한번 저장된 설정임
      const hasYeonPaySetting = firstItem?.lemi_yeon_pay !== undefined && firstItem?.lemi_yeon_pay !== null;
      let yeonPay = firstItem?.lemi_yeon_pay || '';
      let applyNationalPension = false;
      if (yeonPay) {
        const numericValue = parseFloat(String(yeonPay).replace(/[^\d]/g, '')) || 0;
        if (numericValue > 0) {
          yeonPay = new Intl.NumberFormat('ko-KR').format(numericValue);
          applyNationalPension = true;
        }
      }

      // 본인부담금공제 포맷팅
      let boninPay = firstItem?.lemi_bonin_pay || '';
      let applyBoninPay = false;
      if (boninPay) {
        const numericValue = parseFloat(String(boninPay).replace(/[^\d]/g, '')) || 0;
        if (numericValue > 0) {
          boninPay = new Intl.NumberFormat('ko-KR').format(numericValue);
          applyBoninPay = true;
        }
      }

      // 기타공제 포맷팅
      let empEtc = firstItem?.lemi_emp_etc || '';
      let applyEmpEtc = false;
      if (empEtc) {
        const numericValue = parseFloat(String(empEtc).replace(/[^\d]/g, '')) || 0;
        if (numericValue > 0) {
          empEtc = new Intl.NumberFormat('ko-KR').format(numericValue);
          applyEmpEtc = true;
        }
      }

      // 기타수당 포맷팅
      let etcAllowance = firstItem?.lemi_etc_allowance || '';
      let applyEtcAllowance = false;
      if (etcAllowance) {
        const numericValue = parseFloat(String(etcAllowance).replace(/[^\d]/g, '')) || 0;
        if (numericValue > 0) {
          etcAllowance = new Intl.NumberFormat('ko-KR').format(numericValue);
          applyEtcAllowance = true;
        }
      }

      // 실업급여 적용 여부 확인 (lemi_sil_pay에 값이 있으면 적용)
      const silPay = firstItem?.lemi_sil_pay || '';
      const hasSilPay = silPay && parseFloat(String(silPay).replace(/[^\d]/g, '')) > 0;
      // 고용보험 적용 시 실업급여도 기본 적용, 또는 lemi_sil_pay에 값이 있으면 적용
      const applyUnemployment = (firstItem?.lemi_apply_go === 'Y') || hasSilPay;
      
      // DB에서 수동 조정된 수가시간 복원 (JSON 파싱)
      let customSugaHours: Record<string, Record<string, number>> = {};
      let sugaHoursChanged = false;
      if (firstItem?.lemi_custom_suga_hours) {
        try {
          customSugaHours = JSON.parse(firstItem.lemi_custom_suga_hours);
          sugaHoursChanged = Object.keys(customSugaHours).length > 0;
        } catch (e) {
          console.warn('customSugaHours 파싱 실패:', e);
          customSugaHours = {};
        }
      }
      
      // DB에 저장된 값을 그대로 사용 (Step2 확정 시 디폴트 값이 설정됨)
      settingsData.value[index] = {
        applyNationalPension: applyNationalPension,
        yeonPay: yeonPay,
        applyBoninPay: applyBoninPay,
        boninPay: boninPay,
        applyHealthInsurance: firstItem?.lemi_apply_gun === 'Y',
        applyEmploymentInsurance: firstItem?.lemi_apply_go === 'Y',
        applyUnemployment: applyUnemployment,
        applyRetirement: firstItem?.lemi_apply_out_pay === 'Y',
        applyHoliday: firstItem?.lemi_apply_holiday_pay === 'Y',
        applyOvertime: firstItem?.lemi_apply_overtime_pay === 'Y',
        applyMeal: firstItem?.lemi_apply_lunch_pay === 'Y',
        applyLongServicePay: applyLongServicePay,
        longServicePay: longServicePay,
        applyEtcAllowance: applyEtcAllowance,
        etcAllowance: etcAllowance,
        applyBosuEduPay: false,
        bosuEduPay: '',
        applyEmpEtc: applyEmpEtc,
        empEtc: empEtc,
        timePays: timePays,
        customSugaHours: customSugaHours,
        sugaHoursChanged: sugaHoursChanged,
        _hasYeonPaySetting: hasYeonPaySetting  // DB에 국민연금 설정이 저장된 적이 있는지 플래그
      };

      // 가족요양만 진행하는 요양보호사의 경우, 수가시간 60시간 미만이면 체크박스 자동 해제
      // 단, DB에 이미 설정된 값이 있으면 사용자 선택을 존중하여 유지
      const isFamilyOnly = isAllFamilyCaregiver(group);
      const totalSugaHours = getTotalSugaHours(group, index);
      
      // DB에 저장된 값이 없는 경우에만 자동 해제 (첫 로드 시)
      const hasExistingYeonPay = firstItem?.lemi_yeon_pay && parseFloat(String(firstItem.lemi_yeon_pay).replace(/[^\d]/g, '')) > 0;
      const hasExistingHealthInsurance = firstItem?.lemi_apply_gun === 'Y';
      const hasExistingMeal = firstItem?.lemi_apply_lunch_pay === 'Y';
      
      if (isFamilyOnly && totalSugaHours < 60) {
        // DB에 저장된 값이 없는 경우에만 기본값으로 해제
        if (!hasExistingYeonPay) {
          settingsData.value[index].applyNationalPension = false;
          settingsData.value[index].yeonPay = '';
        }
        if (!hasExistingHealthInsurance) {
          settingsData.value[index].applyHealthInsurance = false;
        }
        if (!hasExistingMeal) {
          settingsData.value[index].applyMeal = false;
        }
      }

      // 대표자인 경우, 고용보험과 퇴직금 체크박스 자동 해제
      // 단, DB에 이미 설정된 값이 있으면 사용자 선택을 존중하여 유지
      const isBoss = firstItem?.lem_isboss === 'Y';
      const hasExistingEmploymentInsurance = firstItem?.lemi_apply_go === 'Y';
      const hasExistingRetirement = firstItem?.lemi_apply_out_pay === 'Y';
      
      if (isBoss) {
        // DB에 저장된 값이 없는 경우에만 기본값으로 해제
        if (!hasExistingEmploymentInsurance) {
          settingsData.value[index].applyEmploymentInsurance = false;
        }
        if (!hasExistingRetirement) {
          settingsData.value[index].applyRetirement = false;
        }
      }
    }
  });
};

// 시급 입력 이벤트
const onTimePayInput = (event: Event, groupIndex: number, patientCode: string, sugaCode: string) => {
  const input = event.target as HTMLInputElement;
  let value = input.value;
  value = value.replace(/[^\d]/g, '');
  if (value.length > 9) {
    value = value.slice(0, 9);
  }
  input.value = value;
  
  if (!settingsData.value[groupIndex].timePays[patientCode]) {
    settingsData.value[groupIndex].timePays[patientCode] = {};
  }
  settingsData.value[groupIndex].timePays[patientCode][sugaCode] = value;
  checkUnsavedChanges();
};

const onTimePayFocus = (event: FocusEvent, groupIndex: number, patientCode: string, sugaCode: string) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  const numericValue = value.replace(/,/g, '');
  input.value = numericValue;
};

const onTimePayBlur = (event: FocusEvent, groupIndex: number, patientCode: string, sugaCode: string) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  const numericValue = value.replace(/[^\d]/g, '');
  
  if (numericValue) {
    const formattedValue = new Intl.NumberFormat('ko-KR').format(parseInt(numericValue));
    input.value = formattedValue;
    
    if (!settingsData.value[groupIndex].timePays[patientCode]) {
      settingsData.value[groupIndex].timePays[patientCode] = {};
    }
    settingsData.value[groupIndex].timePays[patientCode][sugaCode] = formattedValue;
  } else {
    input.value = '';
    if (settingsData.value[groupIndex].timePays[patientCode]) {
      settingsData.value[groupIndex].timePays[patientCode][sugaCode] = '';
    }
  }
  checkUnsavedChanges();
};

// 장기근속수당 체크박스 토글
const onLongServicePayToggle = (groupIndex: number) => {
  const settings = settingsData.value[groupIndex];
  if (!settings) return;
  
  if (settings.applyLongServicePay) {
    // 체크박스 활성화 시 값 초기화
    settings.longServicePay = '0';
  } else {
    // 체크박스 비활성화 시 값 초기화
    settings.longServicePay = '';
  }
  checkUnsavedChanges();
};

// 장기근속수당 입력 이벤트
const onLongServiceInput = (event: Event, groupIndex: number) => {
  const input = event.target as HTMLInputElement;
  let value = input.value;
  value = value.replace(/[^\d]/g, '');
  if (value.length > 9) {
    value = value.slice(0, 9);
  }
  input.value = value;
  settingsData.value[groupIndex].longServicePay = value;
  checkUnsavedChanges();
};

const onLongServiceFocus = (event: FocusEvent, groupIndex: number) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  const numericValue = value.replace(/,/g, '');
  // 값이 0이면 빈 문자열로 표시
  input.value = numericValue === '0' ? '' : numericValue;
};

const onLongServiceBlur = (event: FocusEvent, groupIndex: number) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  const numericValue = value.replace(/[^\d]/g, '');
  
  if (numericValue) {
    const formattedValue = new Intl.NumberFormat('ko-KR').format(parseInt(numericValue));
    input.value = formattedValue;
    settingsData.value[groupIndex].longServicePay = formattedValue;
  } else {
    input.value = '';
    settingsData.value[groupIndex].longServicePay = '';
  }
  checkUnsavedChanges();
};

// 국민연금 입력 이벤트
const onYeonPayInput = (event: Event, groupIndex: number) => {
  const input = event.target as HTMLInputElement;
  let value = input.value;
  value = value.replace(/[^\d]/g, '');
  if (value.length > 9) {
    value = value.slice(0, 9);
  }
  input.value = value;
  settingsData.value[groupIndex].yeonPay = value;
  checkUnsavedChanges();
};

const onYeonPayFocus = (event: FocusEvent, groupIndex: number) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  const numericValue = value.replace(/,/g, '');
  // 값이 0이면 빈 문자열로 표시
  input.value = numericValue === '0' ? '' : numericValue;
};

const onYeonPayBlur = (event: FocusEvent, groupIndex: number) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  const numericValue = value.replace(/[^\d]/g, '');
  
  if (numericValue) {
    const formattedValue = new Intl.NumberFormat('ko-KR').format(parseInt(numericValue));
    input.value = formattedValue;
    settingsData.value[groupIndex].yeonPay = formattedValue;
  } else {
    input.value = '';
    settingsData.value[groupIndex].yeonPay = '';
  }
  checkUnsavedChanges();
};

// 국민연금 체크박스 토글
const onNationalPensionToggle = (groupIndex: number) => {
  const settings = settingsData.value[groupIndex];
  if (!settings) return;
  
  if (settings.applyNationalPension) {
    // 체크박스 활성화 시 국민연금 자동 계산
    const payroll = payrollDetails.value[groupIndex];
    if (payroll && payroll.suggestedNationalPension > 0) {
      settings.yeonPay = new Intl.NumberFormat('ko-KR').format(payroll.suggestedNationalPension);
    } else {
      settings.yeonPay = '0';
    }
  } else {
    // 체크박스 비활성화 시 값 초기화
    settings.yeonPay = '';
  }
  checkUnsavedChanges();
};

// 본인부담금공제 입력 이벤트
const onBoninPayInput = (event: Event, groupIndex: number) => {
  const input = event.target as HTMLInputElement;
  let value = input.value;
  value = value.replace(/[^\d]/g, '');
  if (value.length > 9) {
    value = value.slice(0, 9);
  }
  input.value = value;
  settingsData.value[groupIndex].boninPay = value;
  checkUnsavedChanges();
};

const onBoninPayFocus = (event: FocusEvent, groupIndex: number) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  const numericValue = value.replace(/,/g, '');
  // 값이 0이면 빈 문자열로 표시
  input.value = numericValue === '0' ? '' : numericValue;
};

const onBoninPayBlur = (event: FocusEvent, groupIndex: number) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  const numericValue = value.replace(/[^\d]/g, '');
  
  if (numericValue) {
    const formattedValue = new Intl.NumberFormat('ko-KR').format(parseInt(numericValue));
    input.value = formattedValue;
    settingsData.value[groupIndex].boninPay = formattedValue;
  } else {
    input.value = '';
    settingsData.value[groupIndex].boninPay = '';
  }
  checkUnsavedChanges();
};

// 본인부담금공제 체크박스 토글
const onBoninPayToggle = (groupIndex: number) => {
  const settings = settingsData.value[groupIndex];
  if (!settings) return;
  
  if (settings.applyBoninPay) {
    // 체크박스 활성화 시 모달 열기
    openBoninPayModal(groupIndex);
  } else {
    // 체크박스 비활성화 시 값 초기화
    settings.boninPay = '';
  }
  checkUnsavedChanges();
};

// 가족요양 수가금액 계산
const getFamilySugaMoney = (groupIndex: number): number => {
  const group = groupedMemberData.value[groupIndex];
  if (!group) return 0;
  
  let familySugaMoney = 0;
  group.patients.forEach((patient) => {
    // 가족요양인 경우만 수가금액 합산
    if (patient.sugaName && patient.sugaName.includes('가족')) {
      familySugaMoney += patient.totalSugaMoney || 0;
    }
  });
  
  return familySugaMoney;
};

// 본인부담금공제 모달 열기
const openBoninPayModal = (groupIndex: number) => {
  const group = groupedMemberData.value[groupIndex];
  if (!group) return;
  
  const familySugaMoney = getFamilySugaMoney(groupIndex);
  
  currentBoninPayGroupIndex.value = groupIndex;
  currentBoninPayCaregiver.value = {
    name: group.name,
    familySugaMoney: familySugaMoney
  };
  selectedBoninRate.value = null;
  showBoninPayModal.value = true;
};

// 본인부담금 계산 (원단위 절삭)
const calculateBoninAmount = (rate: number): number => {
  if (!currentBoninPayCaregiver.value) return 0;
  const amount = currentBoninPayCaregiver.value.familySugaMoney * rate / 100;
  return Math.floor(amount / 10) * 10; // 원단위 절삭
};

// 본인부담금 비율 선택
const selectBoninRate = (rate: number) => {
  selectedBoninRate.value = rate;
};

// 본인부담금 비율 적용
const applyBoninPayRate = () => {
  if (currentBoninPayGroupIndex.value === null || selectedBoninRate.value === null) return;
  
  const settings = settingsData.value[currentBoninPayGroupIndex.value];
  
  if (settings) {
    if (selectedBoninRate.value === 0) {
      // 0% 선택 시 공제 안 함
      settings.applyBoninPay = false;
      settings.boninPay = '';
    } else {
      const amount = calculateBoninAmount(selectedBoninRate.value);
      settings.applyBoninPay = true;
      settings.boninPay = new Intl.NumberFormat('ko-KR').format(amount);
    }
  }
  
  showBoninPayModal.value = false;
  checkUnsavedChanges();
};

// 기타공제 입력 이벤트
const onEmpEtcInput = (event: Event, groupIndex: number) => {
  const input = event.target as HTMLInputElement;
  let value = input.value;
  value = value.replace(/[^\d]/g, '');
  if (value.length > 9) {
    value = value.slice(0, 9);
  }
  input.value = value;
  settingsData.value[groupIndex].empEtc = value;
  checkUnsavedChanges();
};

const onEmpEtcFocus = (event: FocusEvent, groupIndex: number) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  const numericValue = value.replace(/,/g, '');
  // 값이 0이면 빈 문자열로 표시
  input.value = numericValue === '0' ? '' : numericValue;
};

const onEmpEtcBlur = (event: FocusEvent, groupIndex: number) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  const numericValue = value.replace(/[^\d]/g, '');
  
  if (numericValue) {
    const formattedValue = new Intl.NumberFormat('ko-KR').format(parseInt(numericValue));
    input.value = formattedValue;
    settingsData.value[groupIndex].empEtc = formattedValue;
  } else {
    input.value = '';
    settingsData.value[groupIndex].empEtc = '';
  }
  checkUnsavedChanges();
};

// 기타공제 체크박스 토글
const onEmpEtcToggle = (groupIndex: number) => {
  const settings = settingsData.value[groupIndex];
  if (!settings) return;
  
  if (settings.applyEmpEtc) {
    settings.empEtc = '0';
  } else {
    settings.empEtc = '';
  }
  checkUnsavedChanges();
};

// 고용보험 모달 열기 (체크박스 클릭 시)
const openEmploymentModal = (groupIndex: number) => {
  const settings = settingsData.value[groupIndex];
  const group = groupedMemberData.value[groupIndex];
  if (!settings || !group) return;
  
  const age = calculateAge(group.birth, props.yearMonth || '');
  
  currentEmploymentGroupIndex.value = groupIndex;
  currentEmploymentCaregiver.value = {
    name: group.name,
    age: age
  };
  
  // 현재 설정에 따라 옵션 초기화
  if (settings.applyEmploymentInsurance && settings.applyUnemployment) {
    selectedEmploymentOption.value = 'both';
  } else if (!settings.applyEmploymentInsurance && settings.applyUnemployment) {
    selectedEmploymentOption.value = 'unemployment-only';
  } else if (settings.applyEmploymentInsurance && !settings.applyUnemployment) {
    selectedEmploymentOption.value = 'both';
  } else {
    selectedEmploymentOption.value = 'none';
  }
  
  showEmploymentModal.value = true;
};

// 고용보험 모달 취소 (상태 변경 없이 그냥 닫기)
const cancelEmploymentModal = () => {
  showEmploymentModal.value = false;
  currentEmploymentGroupIndex.value = null;
  currentEmploymentCaregiver.value = null;
  selectedEmploymentOption.value = null;
};

// 고용보험 적용 확인
const applyEmploymentInsurance = () => {
  if (currentEmploymentGroupIndex.value === null || !selectedEmploymentOption.value) return;
  
  const settings = settingsData.value[currentEmploymentGroupIndex.value];
  if (!settings) return;
  
  switch (selectedEmploymentOption.value) {
    case 'both':
      // 고용보험 + 실업급여 모두 적용
      settings.applyEmploymentInsurance = true;
      settings.applyUnemployment = true;
      break;
    case 'unemployment-only':
      // 실업급여만 적용 (고용보험 미적용)
      settings.applyEmploymentInsurance = false;
      settings.applyUnemployment = true;
      break;
    case 'none':
      // 모두 미적용
      settings.applyEmploymentInsurance = false;
      settings.applyUnemployment = false;
      break;
  }
  
  showEmploymentModal.value = false;
  currentEmploymentGroupIndex.value = null;
  currentEmploymentCaregiver.value = null;
  selectedEmploymentOption.value = null;
  checkUnsavedChanges();
};

// 평균 시급 계산 (가중평균)
const getAverageTimePay = (group: GroupedMember) => {
  const groupIndex = groupedMemberData.value.indexOf(group);
  const settings = settingsData.value[groupIndex];
  
  if (!settings || !settings.timePays) return '-';
  
  let totalWeightedPay = 0;
  let totalHours = 0;
  
  group.patients.forEach((patient) => {
    const sugaKey = getSugaKey(patient);
    const timePay = settings.timePays[patient.patientCode]?.[sugaKey];
    if (timePay) {
      const numericPay = parseFloat(String(timePay).replace(/[^\d]/g, '')) || 0;
      const sugaHours = (patient.serviceDays || 0) * (patient.sugaHours || 0);
      
      if (numericPay > 0 && sugaHours > 0) {
        totalWeightedPay += numericPay * sugaHours;
        totalHours += sugaHours;
      }
    }
  });
  
  if (totalHours === 0) return '-';
  
  const average = Math.round(totalWeightedPay / totalHours);
  return new Intl.NumberFormat('ko-KR').format(average) + '원';
};

// 월급여 계산 (요보웨이지 로직 참고)
const calculateMonthlyPay = (group: GroupedMember) => {
  const groupIndex = groupedMemberData.value.indexOf(group);
  const settings = settingsData.value[groupIndex];
  
  if (!settings || !settings.timePays) return 0;
  
  let totalMonthlyPay = 0;
  
  group.patients.forEach((patient) => {
    const sugaKey = getSugaKey(patient);
    const timePay = settings.timePays[patient.patientCode]?.[sugaKey];
    if (timePay) {
      const numericPay = parseFloat(String(timePay).replace(/[^\d]/g, '')) || 0;
      const serviceDays = patient.serviceDays || 0;
      
      // 수동 조정된 시간이 있으면 사용, 없으면 휴게시간 적용된 시간 사용
      let sugaHours: number;
      if (settings.customSugaHours?.[patient.patientCode]?.[sugaKey] !== undefined) {
        sugaHours = settings.customSugaHours[patient.patientCode][sugaKey];
      } else {
        sugaHours = getPatientSugaHours(patient);  // 270분초과는 휴게시간 적용
      }
      const totalHours = serviceDays * sugaHours;
      
      totalMonthlyPay += numericPay * totalHours;
    }
  });
  
  return totalMonthlyPay;
};

// 기관 수익 계산 (총수가 - (월급여 + 기관공제))
// 월급여 = 총급여 = 기본급 + 수당
const calculateCenterProfit = (group: GroupedMember, groupIndex: number) => {
  const payroll = payrollDetails.value[groupIndex];
  if (!payroll) return 0;
  
  const totalSugaMoney = group.totalSugaMoney || 0;
  const monthlyPay = payroll.totalPay || 0; // 수가시간 × 시급 + 모든 수당
  const centerDeduction = payroll.totalCenterDeduction || 0;
  
  return totalSugaMoney - monthlyPay - centerDeduction;
};

// 금액 포맷팅
const formatMoney = (amount: number) => {
  if (!amount) return '0';
  return new Intl.NumberFormat('ko-KR').format(amount);
};

// 만 나이 계산
const calculateAge = (birthDateStr: string, baseYm: string) => {
  if (!birthDateStr || !baseYm) return 0;

  const birthDate = new Date(birthDateStr);
  const baseYear = parseInt(baseYm.substring(0, 4));
  const baseMonth = parseInt(baseYm.substring(4, 6));

  // 기준일 설정 (해당 월의 마지막 날)
  const baseDate = new Date(baseYear, baseMonth, 0);

  // 만 나이 계산
  let age = baseDate.getFullYear() - birthDate.getFullYear();

  // 생일이 지나지 않았으면 1살 빼기
  if (
    baseDate.getMonth() < birthDate.getMonth() ||
    (baseDate.getMonth() === birthDate.getMonth() && baseDate.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age;
};

// 근속년수 계산
const calculateWorkPeriod = (startDateStr: string, baseYm: string) => {
  if (!startDateStr || !baseYm) return { years: 0, months: 0 };

  const workStartDate = new Date(startDateStr);
  const baseYear = parseInt(baseYm.substring(0, 4));
  const baseMonth = parseInt(baseYm.substring(4, 6));
  const baseDate = new Date(baseYear, baseMonth - 1, 1);

  let years = baseDate.getFullYear() - workStartDate.getFullYear();
  let months = baseDate.getMonth() - workStartDate.getMonth();

  if (months < 0) {
    years--;
    months += 12;
  }

  return { years, months };
};

// 연차 일수 테이블 (TabYoboWage 로직 동일)
const vacationYearOptions = [
  { value: 1, label: '1년차', days: 11 },
  { value: 2, label: '2년차', days: 15 },
  { value: 3, label: '3년차', days: 15 },
  { value: 4, label: '4년차', days: 16 },
  { value: 5, label: '5년차', days: 16 },
  { value: 6, label: '6년차', days: 17 },
  { value: 7, label: '7년차', days: 17 },
  { value: 8, label: '8년차', days: 18 },
  { value: 9, label: '9년차', days: 18 },
  { value: 10, label: '10년차', days: 19 },
  { value: 11, label: '11년차', days: 19 },
  { value: 12, label: '12년차', days: 20 },
  { value: 13, label: '13년차', days: 20 },
  { value: 14, label: '14년차', days: 21 },
  { value: 15, label: '15년차', days: 21 },
  { value: 16, label: '16년차', days: 22 },
  { value: 17, label: '17년차', days: 22 },
  { value: 18, label: '18년차', days: 23 },
  { value: 19, label: '19년차', days: 23 },
  { value: 20, label: '20년차', days: 24 },
  { value: 21, label: '21년차이상', days: 25 },
];

// 근속연수에 따른 연차 일수 계산 함수 (TabYoboWage 로직 동일)
// 12개월 미만 -> 1년차, 12개월 이상 -> 2년차, 24개월 이상 -> 3년차
const getAnnualLeaveDays = (startDateStr: string) => {
  if (!startDateStr || !props.yearMonth) return 11; // 기본값: 1년차(11일)
  
  const period = calculateWorkPeriod(startDateStr, props.yearMonth);
  
  // 근속기간을 총 개월수로 변환
  const totalMonths = period.years * 12 + period.months;
  
  // 12개월 미만이면 1년차(11일)로 취급
  if (totalMonths < 12) {
    return 11;
  }
  
  // 년차 계산: 12개월 이상 -> 2년차, 24개월 이상 -> 3년차...
  const yearLevel = Math.floor(totalMonths / 12) + 1;
  
  // 21년차 이상은 25일
  if (yearLevel >= 21) {
    return 25;
  }
  
  // 년차에 따른 연차 일수 찾기
  const option = vacationYearOptions.find(opt => opt.value === yearLevel);
  
  return option ? option.days : 11; // fallback: 1년차(11일)
};

// 총 수가시간 계산 (서비스횟수 × 수가시간)
// 270분초과 수가는 30분 휴게시간 적용 (수동 조정되지 않은 경우)
// 수동 조정된 시간이 있으면 해당 값 사용
const getTotalSugaHours = (group: GroupedMember, groupIndex?: number) => {
  let totalHours = 0;
  group.patients.forEach((patient) => {
    let sugaHours: number;
    
    if (groupIndex !== undefined) {
      const settings = settingsData.value[groupIndex];
      const sugaKey = getSugaKey(patient);
      
      // 수동 조정된 시간이 있으면 그 값 사용
      if (settings?.customSugaHours?.[patient.patientCode]?.[sugaKey] !== undefined) {
        sugaHours = settings.customSugaHours[patient.patientCode][sugaKey];
      } else {
        // 수동 조정이 없으면 휴게시간 적용된 시간 사용
        sugaHours = getPatientSugaHours(patient);
      }
    } else {
      // groupIndex가 없으면 휴게시간 적용된 시간 사용
      sugaHours = getPatientSugaHours(patient);
    }
    
    totalHours += (patient.serviceDays || 0) * sugaHours;
  });
  return totalHours;
};

// 총 서비스 횟수 계산
const getTotalServiceDays = (group: GroupedMember) => {
  let totalDays = 0;
  group.patients.forEach((patient) => {
    totalDays += patient.serviceDays || 0;
  });
  return totalDays;
};

// 실제 근무일수 계산 (주차별 데이터에서 고유한 서비스일 개수)
const getActualWorkDays = (groupIndex: number) => {
  const weeklyData = combinedWeeklyServices.value[groupIndex];
  if (!weeklyData || weeklyData.length === 0) return 0;
  
  const uniqueDates = new Set<string>();
  weeklyData.forEach((weekGroup: any) => {
    weekGroup.daily_items?.forEach((daily: any) => {
      if (daily.service_date) {
        uniqueDates.add(daily.service_date);
      }
    });
  });
  
  return uniqueDates.size;
};

// 270분초과 수가인지 확인
const is270MinutesOverSuga = (patient: { sugaName?: string; sugaMinutesKey?: number | null }) => {
  return patient.sugaMinutesKey != null || (patient.sugaName && patient.sugaName.includes('270분초과'));
};

// 환자별 수가시간 가져오기 (270분초과 수가는 30분 휴게시간 적용)
// 270분초과 수가는 백엔드에서 실제 근무시간을 30분 단위로 끊어서 계산한 값 사용
// 단, 8시간 이상 시에는 휴게시간 차감 없음
const getPatientSugaHours = (patient: { sugaName?: string; sugaHours?: number; sugaMinutesKey?: number | null }) => {
  const baseHours = patient.sugaHours || 0;
  
  // 270분초과 수가인 경우 30분(0.5시간) 휴게시간 차감
  // 단, 8시간 이상 시에는 휴게시간 차감하지 않음
  if (is270MinutesOverSuga(patient)) {
    if (baseHours >= 8) {
      return baseHours;
    }
    return Math.max(0, baseHours - 0.5);
  }
  
  return baseHours;
};

// 수동 조정된 수가시간이 있으면 그 값을, 없으면 휴게시간 적용된 수가시간 반환
const getEffectiveSugaHours = (groupIndex: number, patient: PatientInfo) => {
  const settings = settingsData.value[groupIndex];
  const sugaKey = getSugaKey(patient);
  
  // 수동 조정된 값이 있으면 그대로 사용 (이미 사용자가 조정한 값)
  if (settings?.customSugaHours?.[patient.patientCode]?.[sugaKey] !== undefined) {
    return settings.customSugaHours[patient.patientCode][sugaKey];
  }
  
  // 270분초과 수가인 경우 30분 휴게시간 적용
  return getPatientSugaHours(patient);
};

// 수가시간이 수동으로 변경되었는지 확인
const isSugaHoursManuallyChanged = (groupIndex: number, patientCode: string, sugaKey: string) => {
  const settings = settingsData.value[groupIndex];
  return settings?.customSugaHours?.[patientCode]?.[sugaKey] !== undefined;
};

// 수가시간 조정 모달 열기
const openSugaHoursModal = (groupIndex: number, patient: PatientInfo) => {
  if (isConfirmed.value) return;
  
  const sugaKey = getSugaKey(patient);
  const effectiveHours = getEffectiveSugaHours(groupIndex, patient);
  
  // 원래 시간도 휴게시간이 적용된 값 (270분초과의 경우 -0.5시간)
  const originalHoursWithBreak = getPatientSugaHours(patient);
  
  currentSugaHoursGroupIndex.value = groupIndex;
  currentSugaHoursPatient.value = {
    patientCode: patient.patientCode,
    patientName: patient.patientName,
    sugaKey: sugaKey,
    sugaName: getDisplaySugaName(patient),
    originalHours: originalHoursWithBreak  // 휴게시간 적용된 원래 시간
  };
  selectedSugaHours.value = effectiveHours;
  showSugaHoursModal.value = true;
};

// 수가시간 조정 (+/- 0.5시간)
const adjustSugaHours = (delta: number) => {
  const newValue = selectedSugaHours.value + delta;
  if (newValue >= 0.5 && newValue <= 24) {
    selectedSugaHours.value = Math.round(newValue * 2) / 2; // 0.5 단위로 반올림
  }
};

// 수가시간 변경 적용
const applySugaHoursChange = () => {
  if (currentSugaHoursGroupIndex.value === null || !currentSugaHoursPatient.value) return;
  
  const groupIndex = currentSugaHoursGroupIndex.value;
  const { patientCode, sugaKey, originalHours } = currentSugaHoursPatient.value;
  const settings = settingsData.value[groupIndex];
  
  if (!settings) return;
  
  // customSugaHours 초기화
  if (!settings.customSugaHours) {
    settings.customSugaHours = {};
  }
  
  // 원래 값과 다르면 수동 변경으로 저장, 같으면 삭제 (원래 값 복원)
  if (selectedSugaHours.value !== originalHours) {
    // 새 값 설정 - 불변성 유지
    settings.customSugaHours = {
      ...settings.customSugaHours,
      [patientCode]: {
        ...(settings.customSugaHours[patientCode] || {}),
        [sugaKey]: selectedSugaHours.value
      }
    };
    settings.sugaHoursChanged = true;
  } else {
    // Vue 반응성을 위해 새 객체로 재할당
    if (settings.customSugaHours[patientCode]) {
      const { [sugaKey]: removed, ...restSugaKeys } = settings.customSugaHours[patientCode];
      
      if (Object.keys(restSugaKeys).length === 0) {
        // 해당 환자의 모든 수가시간이 원래 값이면 patientCode도 제거
        const { [patientCode]: removedPatient, ...restPatients } = settings.customSugaHours;
        settings.customSugaHours = restPatients;
      } else {
        settings.customSugaHours = {
          ...settings.customSugaHours,
          [patientCode]: restSugaKeys
        };
      }
      
      // 모든 수동 변경이 복원되었으면 sugaHoursChanged를 false로
      if (Object.keys(settings.customSugaHours).length === 0) {
        settings.sugaHoursChanged = false;
      }
    }
  }
  
  checkUnsavedChanges();
  showSugaHoursModal.value = false;
  
  // 급여 재계산
  const group = groupedMemberData.value[groupIndex];
  if (group) {
    payrollDetails.value[groupIndex] = calculatePayrollDetails(group, groupIndex);
  }
};

// 드롭다운 키 생성
const getSugaHoursDropdownKey = (groupIndex: number, patientCode: string, sugaKey: string) => {
  return `${groupIndex}_${patientCode}_${sugaKey}`;
};

// 드롭다운 열림 여부 확인
const isSugaHoursDropdownOpen = (groupIndex: number, patientCode: string, sugaKey: string) => {
  return openSugaHoursDropdown.value === getSugaHoursDropdownKey(groupIndex, patientCode, sugaKey);
};

// 드롭다운 토글
const toggleSugaHoursDropdown = (groupIndex: number, patient: PatientInfo) => {
  if (isConfirmed.value) return;
  
  const sugaKey = getSugaKey(patient);
  const key = getSugaHoursDropdownKey(groupIndex, patient.patientCode, sugaKey);
  
  if (openSugaHoursDropdown.value === key) {
    openSugaHoursDropdown.value = null;
  } else {
    openSugaHoursDropdown.value = key;
  }
};

// 인라인에서 수가시간 조정 (+/- 0.5시간)
const adjustSugaHoursInline = (groupIndex: number, patient: PatientInfo, delta: number) => {
  const sugaKey = getSugaKey(patient);
  const currentHours = getEffectiveSugaHours(groupIndex, patient);
  const newValue = Math.round((currentHours + delta) * 2) / 2; // 0.5 단위로 반올림
  
  if (newValue < 0.5 || newValue > 24) return;
  
  const settings = settingsData.value[groupIndex];
  if (!settings) return;
  
  // customSugaHours 초기화 - 새 객체로 할당하여 반응성 보장
  if (!settings.customSugaHours) {
    settings.customSugaHours = {};
  }
  
  // 원래 값(휴게시간 적용된 값)과 비교
  const originalHours = getPatientSugaHours(patient);
  
  if (newValue !== originalHours) {
    // 새 값 설정 - 불변성 유지
    settings.customSugaHours = {
      ...settings.customSugaHours,
      [patient.patientCode]: {
        ...(settings.customSugaHours[patient.patientCode] || {}),
        [sugaKey]: newValue
      }
    };
    settings.sugaHoursChanged = true;
  } else {
    // 원래 값으로 돌아가면 수동 변경 삭제 - Vue 반응성을 위해 새 객체로 재할당
    if (settings.customSugaHours[patient.patientCode]) {
      const { [sugaKey]: removed, ...restSugaKeys } = settings.customSugaHours[patient.patientCode];
      
      if (Object.keys(restSugaKeys).length === 0) {
        // 해당 patientCode의 모든 수가시간이 삭제되면 patientCode도 제거
        const { [patient.patientCode]: removedPatient, ...restPatients } = settings.customSugaHours;
        settings.customSugaHours = restPatients;
      } else {
        // 아직 다른 수가시간이 남아있으면 해당 sugaKey만 제거
        settings.customSugaHours = {
          ...settings.customSugaHours,
          [patient.patientCode]: restSugaKeys
        };
      }
      
      if (Object.keys(settings.customSugaHours).length === 0) {
        settings.sugaHoursChanged = false;
      }
    }
  }
  
  checkUnsavedChanges();
  
  // 급여 재계산
  const group = groupedMemberData.value[groupIndex];
  if (group) {
    payrollDetails.value[groupIndex] = calculatePayrollDetails(group, groupIndex);
  }
};

// 자동계산으로 변경 (수동 조정 취소)
const resetToAutoCalculation = async (groupIndex: number, patient: PatientInfo) => {
  const sugaKey = getSugaKey(patient);
  const settings = settingsData.value[groupIndex];
  
  if (!settings || !settings.customSugaHours) {
    return;
  }
  
  // 수동 변경 삭제 - Vue 반응성을 위해 새 객체로 재할당
  if (settings.customSugaHours[patient.patientCode]) {
    // 해당 sugaKey 제거한 새 객체 생성
    const { [sugaKey]: removed, ...restSugaKeys } = settings.customSugaHours[patient.patientCode];
    
    if (Object.keys(restSugaKeys).length === 0) {
      // 해당 patientCode의 모든 수가시간이 삭제되면 patientCode도 제거
      const { [patient.patientCode]: removedPatient, ...restPatients } = settings.customSugaHours;
      settings.customSugaHours = restPatients;
    } else {
      // 아직 다른 수가시간이 남아있으면 해당 sugaKey만 제거
      settings.customSugaHours = {
        ...settings.customSugaHours,
        [patient.patientCode]: restSugaKeys
      };
    }
    
    // 모든 수동 변경이 복원되었으면 sugaHoursChanged를 false로
    if (Object.keys(settings.customSugaHours).length === 0) {
      settings.sugaHoursChanged = false;
    }
  }
  
  checkUnsavedChanges();
  
  // 드롭다운 닫기
  openSugaHoursDropdown.value = null;
  
  // 급여 재계산
  const group = groupedMemberData.value[groupIndex];
  if (group) {
    payrollDetails.value[groupIndex] = calculatePayrollDetails(group, groupIndex);
  }
  
  store.commit('showSnackbar', { 
    text: '자동계산 시간으로 변경되었습니다.', 
    color: 'success' 
  });
};

// 수가시간 포맷팅
const formatSugaHours = (hours: number) => {
  if (!hours) return '0시간';
  if (hours % 1 === 0) {
    return `${hours}시간`;
  } else {
    return `${hours.toFixed(1)}시간`;
  }
};

// 사원 특징 추출 (일반 정보와 제한사항 분리)
const getEmployeeFeatures = (group: GroupedMember, groupIndex: number) => {
  const info: Array<{ text: string; type: string; icon: string; iconColor: string }> = [];
  const restrictions: Array<{ 
    text: string; 
    type: string; 
    icon: string; 
    iconColor: string;
    expandable?: boolean;
    expanded?: boolean;
    details?: Array<{ text: string; icon: string; iconColor: string }>;
  }> = [];
  const settings = settingsData.value[groupIndex];
  
  if (!props.yearMonth || !settings) return { info, restrictions };

  const age = calculateAge(group.birth, props.yearMonth);
  const totalSugaHours = getTotalSugaHours(group, groupIndex);
  const totalServiceDays = getTotalServiceDays(group);
  const workPeriod = calculateWorkPeriod(group.workStartDate, props.yearMonth);
  
  // === 왼쪽: 일반 정보 ===
  
  // 1. 나이
  info.push({
    text: `만 ${age}세`,
    type: 'info',
    icon: 'mdi-cake-variant',
    iconColor: '#3b82f6'
  });

  // 2. 근속 기간
  const periodText = workPeriod.years > 0 
    ? `${workPeriod.years}년 ${workPeriod.months}개월`
    : `${workPeriod.months}개월`;
  
  info.push({
    text: `근속 ${periodText}`,
    type: 'info',
    icon: 'mdi-calendar-clock',
    iconColor: '#3b82f6'
  });

  // 3. 서비스 횟수
  info.push({
    text: `서비스 횟수 ${totalServiceDays}회`,
    type: 'info',
    icon: 'mdi-counter',
    iconColor: '#3b82f6'
  });

  // 4. 서비스 시간 (수가시간)
  info.push({
    text: `서비스 시간 ${formatSugaHours(totalSugaHours)}`,
    type: totalSugaHours >= 60 ? 'success' : 'warning',
    icon: 'mdi-clock-outline',
    iconColor: totalSugaHours >= 60 ? '#10b981' : '#f59e0b'
  });

  // 5. 장기근속수당
  const longServicePay = settings.longServicePay ? String(settings.longServicePay).replace(/[^\d]/g, '') : '';
  if (longServicePay && parseInt(longServicePay) > 0) {
    info.push({
      text: `장기근속수당 ${new Intl.NumberFormat('ko-KR').format(parseInt(longServicePay))}원`,
      type: 'info',
      icon: 'mdi-gift',
      iconColor: '#8b5cf6'
    });
  }

  // 6. 가족 케어 여부
  const isFamilyCaregiver = group.patients.some(p => 
    p.sugaName && p.sugaName.includes('가족')
  );
  
  if (isFamilyCaregiver) {
    info.push({
      text: '가족 케어 포함',
      type: 'info',
      icon: 'mdi-home-heart',
      iconColor: '#8b5cf6'
    });
  }

  // === 오른쪽: 제한사항 ===

  // 60시간 미만일 때의 제약사항
  if (totalSugaHours < 60) {
    const isExpanded = expandedRestrictions.value[groupIndex]?.has(0) || false;
    const year = parseInt(props.yearMonth?.substring(0, 4) || '2026');
    
    // 2025년 이하에서만 근로자의날 수당 지급 불가 메시지 표시
    const details = [
      { text: '퇴직금 적립 불가', icon: 'mdi-close-circle', iconColor: '#ef4444' },
      { text: '휴일수당 지급 불가', icon: 'mdi-close-circle', iconColor: '#ef4444' },
      { text: '연장수당 지급 불가', icon: 'mdi-close-circle', iconColor: '#ef4444' },
      ...(year <= 2025 ? [{ text: '근로자의날 수당 지급 불가', icon: 'mdi-close-circle', iconColor: '#ef4444' }] : []),
      { text: '지원공제 중 퇴직금 부분(장기근속수당÷12) 제외', icon: 'mdi-close-circle', iconColor: '#ef4444' }
    ];
    
    restrictions.push({
      text: `⚠️ 월 수가시간 60시간 미만 (${totalSugaHours.toFixed(1)}시간)`,
      type: 'warning-header',
      icon: 'mdi-alert-circle',
      iconColor: '#f59e0b',
      expandable: true,
      expanded: isExpanded,
      details
    });
  }

  // 나이로 인한 제약
  let ageRestrictionIndex = restrictions.length;
  if (age >= 60) {
    restrictions.push({
      text: '⚠️ 만 60세 이상: 국민연금 미적용',
      type: 'warning',
      icon: 'mdi-shield-off',
      iconColor: '#f59e0b'
    });
  }

  if (age >= 65) {
    restrictions.push({
      text: '⚠️ 만 65세 이상: 고용보험 미적용',
      type: 'warning',
      icon: 'mdi-briefcase-off',
      iconColor: '#f59e0b'
    });
  }

  // 대표자인 경우 제약
  if (group.isBoss) {
    restrictions.push({
      text: '⚠️ 대표자: 고용보험, 산재보험, 퇴직금 미적용',
      type: 'warning',
      icon: 'mdi-account-star',
      iconColor: '#10b981'
    });
  }

  // 가족요양 전용 + 60시간 미만인 경우 제약
  const isFamilyOnly = isAllFamilyCaregiver(group);
  if (isFamilyOnly && totalSugaHours < 60) {
    restrictions.push({
      text: '⚠️ 가족요양 60시간 미만: 국민연금, 건강보험, 식대 미적용',
      type: 'warning',
      icon: 'mdi-home-heart',
      iconColor: '#8b5cf6'
    });
  }

  return { info, restrictions };
};

// 가족 케어 전용 여부 확인
const isAllFamilyCaregiver = (group: GroupedMember): boolean => {
  if (!group || !group.patients || group.patients.length === 0) {
    return false;
  }
  
  // 모든 수가명에 '가족'이 포함되어 있는지 확인
  return group.patients.every((patient) => {
    const sugaName = patient.sugaName || '';
    return sugaName.includes('가족');
  });
};

// 원단위 절삭 함수 (예: 51131 -> 51130)
const truncateToTen = (value: number) => Math.floor(value / 10) * 10;

// 소득세 계산 함수 (간이세액표 기반)
const calculateIncomeTax = (taxableIncome: number) => {
  if (!sojiData.value || sojiData.value.length === 0) {
    return 0;
  }

  // 소득세 데이터에서 해당 구간 찾기
  for (let i = 0; i < sojiData.value.length; i++) {
    const obj = sojiData.value[i];
    const minIncome = obj.income1 * 1000;
    const maxIncome = obj.income2 * 1000;

    if (taxableIncome >= minIncome && taxableIncome < maxIncome) {
      const result = Math.round(obj.depe_1);
      return result;
    }
  }

  return 0;
};

// 급여 상세 계산 (TabYoboWage 로직 완전 반영)
const calculatePayrollDetails = (group: GroupedMember, groupIndex: number) => {
  const settings = settingsData.value[groupIndex];
  if (!settings) return null;

  const totalSugaHours = getTotalSugaHours(group, groupIndex);  // 수동 조정된 시간 반영
  const serviceDays = getTotalServiceDays(group);

  // 평균 시급 계산 (가중평균) - 휴게시간 및 수동 조정된 시간 반영
  let totalWeightedPay = 0;
  let totalHours = 0;
  
  group.patients.forEach((patient) => {
    const sugaKey = getSugaKey(patient);
    const timePay = settings.timePays[patient.patientCode]?.[sugaKey];
    if (timePay) {
      const numericPay = parseFloat(String(timePay).replace(/[^\d]/g, '')) || 0;
      
      // 수동 조정된 수가시간이 있으면 사용, 없으면 휴게시간 적용된 시간 사용
      let patientSugaHours: number;
      if (settings.customSugaHours?.[patient.patientCode]?.[sugaKey] !== undefined) {
        patientSugaHours = settings.customSugaHours[patient.patientCode][sugaKey];
      } else {
        patientSugaHours = getPatientSugaHours(patient);  // 270분초과는 휴게시간 적용
      }
      const sugaHours = (patient.serviceDays || 0) * patientSugaHours;
      
      if (numericPay > 0 && sugaHours > 0) {
        totalWeightedPay += numericPay * sugaHours;
        totalHours += sugaHours;
      }
    }
  });

  const avgTimePay = totalHours > 0 ? Math.round(totalWeightedPay / totalHours) : 0;

  // 가족 케어 전용 여부 확인
  const isFamilyOnlyCaregiver = isAllFamilyCaregiver(group);
  
  // 월급여 (계산된 값: 시급 × 수가시간)
  const totalMonthlyPay = calculateMonthlyPay(group);
  
  // 장기근속수당
  const longServicePay = settings.longServicePay ? 
    parseFloat(String(settings.longServicePay).replace(/[^\d]/g, '')) || 0 : 0;
  
  // 기타수당
  const etcAllowance = settings.etcAllowance ? 
    parseFloat(String(settings.etcAllowance).replace(/[^\d]/g, '')) || 0 : 0;
  
  // 중증수급자가산 (자동 계산)
  const severeCareAddition = getSevereCareAdditionTotal(groupIndex);
  
  // 수당 계산 (60시간 이상일 때만)
  const canApplyAllowances = totalSugaHours >= 60;
  
  // 휴일수당: 실제 휴일(일요일+공휴일) 근무 시간 × 최저시급 × 0.5 (비과세)
  // 체크박스 상태가 제한사항보다 우선 (사용자가 체크하면 적용)
  const holidayAllowance = settings.applyHoliday ? 
    calculateHolidayAllowanceAmount(groupIndex) : 0;
  
  // 연장수당: 실제 연장 근무 시간(일일 8시간 초과) × 최저시급 × 0.5 (비과세)
  // 체크박스 상태가 제한사항보다 우선 (사용자가 체크하면 적용)
  const overtimeAllowance = settings.applyOvertime ? 
    calculateOvertimeAllowanceAmount(groupIndex) : 0;
  
  // 기본 급여 항목 계산
  let basicPay = 0;
  let holidayPay = 0;
  let vacationPay = 0;
  let actualMealAllowance = 0;
  
  if (isFamilyOnlyCaregiver) {
    // 가족 케어 전용: 월급여 전체가 기본급 (주휴수당, 연차수당, 식대 모두 포함)
    basicPay = totalMonthlyPay;
    holidayPay = 0;
    vacationPay = 0;
    actualMealAllowance = 0;
  } else {
    // 일반 요양: 최저시급 기반 계산
    const minWage = taxData.value?.tr_time_pay || 0;
    
    if (minWage > 0) {
      // 1. 기본급 = 최저시급 × 수가시간
      basicPay = minWage * totalSugaHours;
      
      // 2. 주휴수당 = 기본급 × 0.2
      holidayPay = Math.round(basicPay * 0.2);
      
      // 3. 연차수당 = 공식 계산 (고정값, 먼저 확보)
      // 실제 근무일수 사용 (서비스 횟수가 아닌 고유한 근무일 수)
      // fallback: 실제 근무일수가 0이면 서비스 횟수 사용
      const annualLeaveDays = getAnnualLeaveDays(group.workStartDate);
      const actualWorkDays = getActualWorkDays(groupIndex);
      const workDaysForCalc = actualWorkDays > 0 ? actualWorkDays : serviceDays;
      console.log(workDaysForCalc,'workDaysForCalc');
      vacationPay = workDaysForCalc > 0 
        ? Math.round((minWage * totalSugaHours / workDaysForCalc) * annualLeaveDays / 12) 
        : 0;
      
      // [60시간 미만] 시급 역산 및 급여 보정
      // 기본급+주휴수당+연차수당이 월급여(수급자별 시급×수가시간 합계)와 일치하도록 조정
      if (totalSugaHours < 60) {
        const basicPlusHoliday = basicPay + holidayPay;
        const currentTotal = basicPlusHoliday + vacationPay;
        
        if (currentTotal > totalMonthlyPay) {
          // 초과하는 경우: 연차수당 조정
          const adjustedVacationPay = Math.max(0, totalMonthlyPay - basicPlusHoliday);
          vacationPay = adjustedVacationPay;
        } else if (currentTotal < totalMonthlyPay) {
          // 미달하는 경우: 시급 역산하여 기본급/주휴수당/연차수당 모두 동일 시급으로 계산
          // 1. 연차수당까지 포함한 이론적 최대 시급 계산
          // 합계금액 = 시급 × 수가시간 × (1 + 0.2 + 연차일수/12/근무일수)
          const vacationRatio = workDaysForCalc > 0 ? (annualLeaveDays / 12) / workDaysForCalc : 0;
          const totalRatio = 1 + 0.2 + vacationRatio;
          const theoreticalMaxWage = totalMonthlyPay / (totalSugaHours * totalRatio);
          
          // 2. 10원 단위로 내림 (합계금액 미만 보장)
          const adjustedWage = Math.floor(theoreticalMaxWage / 10) * 10;
          
          // 3. 최저시급보다 높은 경우에만 역산 적용
          if (adjustedWage > minWage) {
            // 역산 시급으로 기본급, 주휴수당, 연차수당 모두 동일 시급으로 재계산
            basicPay = Math.round(adjustedWage * totalSugaHours);
            holidayPay = Math.round(basicPay * 0.2);
            vacationPay = workDaysForCalc > 0 
              ? Math.round((adjustedWage * totalSugaHours / workDaysForCalc) * annualLeaveDays / 12) 
              : 0;
          }
          
          // 4. 남은 차액을 연차수당에 추가
          const newTotal = basicPay + holidayPay + vacationPay;
          const difference = totalMonthlyPay - newTotal;
          if (difference > 0) {
            vacationPay += difference;
          }
        }
        
        // 60시간 미만이면 식대 없음
        actualMealAllowance = 0;
      } else {
        // [60시간 이상] 기존 로직: 남은 금액 계산 및 식대 처리
        // 4. 남은 금액 계산 (월급여 - 기본급 - 주휴수당 - 연차수당)
        const remainingAmount = Math.max(0, totalMonthlyPay - basicPay - holidayPay - vacationPay);
        
        // 5. 식대 계산 (남은 금액에서)
        if (settings.applyMeal && group.totalLunchTimeCount > 0) {
          // 요청 식대 계산 (일수 × 20,000원, 최대 200,000원)
          const requestedMealAllowance = Math.min(group.totalLunchTimeCount * 20000, 200000);
          
          // 실제 지급 가능한 금액 (둘 중 작은 값)
          const availableAmount = Math.min(requestedMealAllowance, remainingAmount);
          
          // 백원 단위로 내림
          const roundedAmount = Math.floor(availableAmount / 100) * 100;
          
          // 최소 5,000원 이상이면 식대 지급, 아니면 0원
          if (roundedAmount >= 5000) {
            actualMealAllowance = roundedAmount;
            // 식대 지급 후 남은 차액을 연차수당에 추가
            vacationPay += (remainingAmount - actualMealAllowance);
          } else {
            // 식대 기준치 미달 시, 남은 금액 전부를 연차수당에 추가
            actualMealAllowance = 0;
            vacationPay += remainingAmount;
          }
        } else {
          // 식대 미적용 시, 남은 금액 전부를 연차수당에 추가
          vacationPay += remainingAmount;
        }
      }
  } else {
    // taxData가 없으면 기존 방식대로 계산
    // 1. 기본급, 주휴수당 먼저 계산 (월급여 기준 비율)
    // fallback: 실제 근무일수가 0이면 서비스 횟수 사용
    const annualLeaveDays = getAnnualLeaveDays(group.workStartDate);
    const actualWorkDays = getActualWorkDays(groupIndex);
    const workDaysForCalc = actualWorkDays > 0 ? actualWorkDays : serviceDays;
    const vacationRatio = workDaysForCalc > 0 ? (annualLeaveDays / 12) / workDaysForCalc : 0;
    
    const totalRatio = 1 + 0.2 + vacationRatio;
    basicPay = Math.round(totalMonthlyPay / totalRatio);
    holidayPay = Math.round(basicPay * 0.2);
    
    // 2. 연차수당 = 공식 계산 (고정값, 먼저 확보)
    vacationPay = Math.round(basicPay * vacationRatio);
    
    // [60시간 미만] 연차수당 초과 방지
    if (totalSugaHours < 60) {
      const basicPlusHoliday = basicPay + holidayPay;
      const currentTotal = basicPlusHoliday + vacationPay;
      
      if (currentTotal > totalMonthlyPay) {
        const adjustedVacationPay = Math.max(0, totalMonthlyPay - basicPlusHoliday);
        vacationPay = adjustedVacationPay;
      }
      
      actualMealAllowance = 0;
    } else {
      // [60시간 이상] 기존 로직
      // 3. 남은 금액 계산 (월급여 - 기본급 - 주휴수당 - 연차수당)
      const remainingAmount = Math.max(0, totalMonthlyPay - basicPay - holidayPay - vacationPay);
      
      // 4. 식대 계산 (남은 금액에서)
      if (settings.applyMeal && group.totalLunchTimeCount > 0) {
        // 요청 식대 계산 (일수 × 20,000원, 최대 200,000원)
        const requestedMealAllowance = Math.min(group.totalLunchTimeCount * 20000, 200000);
        
        // 실제 지급 가능한 금액 (둘 중 작은 값)
        const availableAmount = Math.min(requestedMealAllowance, remainingAmount);
        
        // 백원 단위로 내림
        const roundedAmount = Math.floor(availableAmount / 100) * 100;
        
        // 최소 5,000원 이상이면 식대 지급, 아니면 0원
        if (roundedAmount >= 5000) {
          actualMealAllowance = roundedAmount;
          // 식대 지급 후 남은 차액을 연차수당에 추가
          vacationPay += (remainingAmount - actualMealAllowance);
        } else {
          // 식대 기준치 미달 시, 남은 금액 전부를 연차수당에 추가
          actualMealAllowance = 0;
          vacationPay += remainingAmount;
        }
      } else {
        // 식대 미적용 시, 남은 금액 전부를 연차수당에 추가
        vacationPay += remainingAmount;
      }
    }
  }
  }
  
  // 기본급 총합 계산 (TabYoboWage 로직 동일)
  let basicTotal;
  if (isFamilyOnlyCaregiver) {
    // 가족 케어 전용: 월급여 전체가 기본급 (주휴수당, 연차수당, 식대 모두 포함)
    basicTotal = totalMonthlyPay;
  } else {
    // 일반: 기본급 + 주휴수당 + 연차수당 + 식대
    basicTotal = basicPay + holidayPay + vacationPay + actualMealAllowance;
  }
  
  // 급여 소계 (비과세 조건 확인용) - basicTotal에 이미 식대 포함됨
  const salarySubtotal = basicTotal;
  
  // 총 급여 계산 (TabYoboWage 로직 동일)
  const totalPay = basicTotal + longServicePay + etcAllowance + severeCareAddition + holidayAllowance + overtimeAllowance;
  
  // 비과세 처리 조건: 수가시간 60시간 이상 && 급여 소계 210만원 이하
  const isSalaryUnder2_1M = salarySubtotal <= 2100000;
  
  // 휴일수당 + 연장수당 비과세 처리 (합계 20만원 한도)
  let nonTaxableHoliday = 0;
  let nonTaxableOvertime = 0;
  
  if (canApplyAllowances && isSalaryUnder2_1M) {
    const totalOvertimeHolidayAllowance = holidayAllowance + overtimeAllowance;
    
    if (totalOvertimeHolidayAllowance <= 200000) {
      // 합계가 20만원 이하면 전액 비과세
      nonTaxableHoliday = holidayAllowance;
      nonTaxableOvertime = overtimeAllowance;
    } else {
      // 합계가 20만원 초과면 비율로 배분
      const nonTaxableRatio = 200000 / totalOvertimeHolidayAllowance;
      nonTaxableHoliday = Math.round(holidayAllowance * nonTaxableRatio);
      nonTaxableOvertime = Math.round(overtimeAllowance * nonTaxableRatio);
      
      // 반올림으로 인한 오차 보정 (합계가 정확히 20만원이 되도록)
      const totalNonTaxable = nonTaxableHoliday + nonTaxableOvertime;
      if (totalNonTaxable !== 200000) {
        nonTaxableOvertime += (200000 - totalNonTaxable);
      }
    }
  }
  
  // 식대 비과세 한도 (20만원)
  const nonTaxableMeal = Math.min(actualMealAllowance, 200000);
  const taxableMeal = actualMealAllowance - nonTaxableMeal;
  
  // 과세 처리되는 휴일수당, 연장수당
  const taxableHoliday = holidayAllowance - nonTaxableHoliday;
  const taxableOvertime = overtimeAllowance - nonTaxableOvertime;
  
  // 과세/비과세 구분 (장기근속수당, 기타수당, 중증수급자가산은 과세)
  const taxableAmount = basicTotal + longServicePay + etcAllowance + severeCareAddition + taxableHoliday + taxableOvertime + taxableMeal - actualMealAllowance;
  const nonTaxableAmount = nonTaxableMeal + nonTaxableHoliday + nonTaxableOvertime;

  // 보험 요율 (taxData에서 동적으로 가져옴)
  const insuranceRates = {
    nationalPension: taxData.value?.tr_yeon || 0.045,
    healthInsurance: taxData.value?.tr_gun || 0.03545,
    longTermCare: taxData.value?.tr_jang || 0.1295,
    employmentInsurance: taxData.value?.tr_go || 0.009,
    unemployment: taxData.value?.tr_sil || 0.0025,
    industrialAccident: taxData.value?.tr_san || 0.0178
  };

  const age = calculateAge(group.birth, props.yearMonth || '');
  
  // 대표자 여부 확인 (대표자는 고용보험, 산재보험, 퇴직금 미적용)
  const isBoss = group.isBoss;
  
  // 국민연금 계산 (과세금액 × 국민연금 요율) - 나이와 상관없이 계산
  const suggestedNationalPension = truncateToTen(taxableAmount * insuranceRates.nationalPension);
  
  // 국민연금 금액 사용 (체크박스 활성화 + 입력값이 있으면 사용, 체크 해제 시 0)
  const yeonPayAmount = settings.applyNationalPension && settings.yeonPay ? 
    parseFloat(String(settings.yeonPay).replace(/[^\d]/g, '')) || 0 : 0;
  const canApplyPension = settings.applyNationalPension && yeonPayAmount > 0;
  // 고용보험 적용 여부 (체크박스 상태가 제한사항보다 우선)
  const canApplyEmployment = settings.applyEmploymentInsurance;

  // 근로자 공제 (원단위 절삭 적용)
  const employeeDeductions = {
    nationalPension: canApplyPension ? truncateToTen(yeonPayAmount) : 0, // 직접 입력한 금액도 원단위 절삭
    healthInsurance: settings.applyHealthInsurance ? truncateToTen(taxableAmount * insuranceRates.healthInsurance) : 0,
    longTermCare: 0,
    employmentInsurance: canApplyEmployment ? truncateToTen(taxableAmount * insuranceRates.employmentInsurance) : 0,
    incomeTax: truncateToTen(calculateIncomeTax(taxableAmount)), // 간이세액표 기반 + 원단위 절삭
    localTax: 0
  };
  
  employeeDeductions.longTermCare = truncateToTen(employeeDeductions.healthInsurance * insuranceRates.longTermCare);
  employeeDeductions.localTax = truncateToTen(employeeDeductions.incomeTax * 0.1);

  // 본인부담금공제 금액 가져오기
  const boninPayAmount = settings.applyBoninPay && settings.boninPay ? 
    parseFloat(String(settings.boninPay).replace(/[^\d]/g, '')) || 0 : 0;

  // 기타공제 금액 가져오기 (미리 계산)
  const empEtcAmountForCalc = settings.applyEmpEtc && settings.empEtc ? 
    parseFloat(String(settings.empEtc).replace(/[^\d]/g, '')) || 0 : 0;

  // 근로자 공제 합계 (본인부담금공제 + 기타공제 + 지원공제 포함) - 지원공제는 나중에 추가
  let totalEmployeeDeduction = 
    employeeDeductions.nationalPension +
    employeeDeductions.healthInsurance +
    employeeDeductions.longTermCare +
    employeeDeductions.employmentInsurance +
    employeeDeductions.incomeTax +
    employeeDeductions.localTax +
    boninPayAmount +
    empEtcAmountForCalc;

  // 실업급여 적용 여부 (65세 이상은 고용보험과 별도 관리)
  const canApplyUnemployment = settings.applyUnemployment;
  
  // 기관 공제 (체크박스 상태가 제한사항보다 우선, 원단위 절삭 적용)
  const centerDeductions = {
    nationalPension: employeeDeductions.nationalPension,
    healthInsurance: employeeDeductions.healthInsurance,
    longTermCare: employeeDeductions.longTermCare,
    employmentInsurance: employeeDeductions.employmentInsurance,
    unemployment: canApplyUnemployment ? truncateToTen(taxableAmount * insuranceRates.unemployment) : 0,
    industrialAccident: truncateToTen(taxableAmount * insuranceRates.industrialAccident),
    retirement: settings.applyRetirement ? truncateToTen(totalPay / 12) : 0
  };

  // 지원공제 계산 (장기근속수당+중증수급자가산에 대한 기관 공제 항목 합계)
  // 공식: (장기근속수당+중증수급자가산) × (국민연금율 + 건강보험율 + 장기요양보험율 + 고용보험율 + 실업급여율 + 산재보험율) + ((장기근속수당+중증수급자가산) ÷ 12)
  const supportDeductionBase = longServicePay + severeCareAddition;
  let supportDeduction = 0;
  
  // 지원공제 세부 항목 저장 (툴팁용)
  const supportDeductionDetails = {
    base: supportDeductionBase,
    longServicePay: longServicePay,
    severeCareAddition: severeCareAddition,
    nationalPension: 0,
    healthInsurance: 0,
    longTermCare: 0,
    employmentInsurance: 0,
    unemployment: 0,
    industrialAccident: 0,
    retirement: 0,
    rates: {
      nationalPension: insuranceRates.nationalPension,
      healthInsurance: insuranceRates.healthInsurance,
      longTermCare: insuranceRates.longTermCare,
      employmentInsurance: insuranceRates.employmentInsurance,
      unemployment: insuranceRates.unemployment,
      industrialAccident: insuranceRates.industrialAccident
    }
  };
  
  if (supportDeductionBase > 0) {
    // 국민연금 (근로자 부담) - 원단위 절삭 적용
    if (canApplyPension) {
      supportDeductionDetails.nationalPension = truncateToTen(supportDeductionBase * insuranceRates.nationalPension);
      supportDeduction += supportDeductionDetails.nationalPension;
    }

    // 건강보험 (근로자 부담) - 원단위 절삭 적용
    if (settings.applyHealthInsurance) {
      supportDeductionDetails.healthInsurance = truncateToTen(supportDeductionBase * insuranceRates.healthInsurance);
      supportDeduction += supportDeductionDetails.healthInsurance;
    }

    // 장기요양보험 (근로자 부담) - 건강보험의 12.95%, 원단위 절삭 적용
    if (settings.applyHealthInsurance) {
      supportDeductionDetails.longTermCare = truncateToTen(supportDeductionDetails.healthInsurance * insuranceRates.longTermCare);
      supportDeduction += supportDeductionDetails.longTermCare;
    }

    // 고용보험 (근로자 부담) - 체크박스 상태가 우선, 원단위 절삭 적용
    if (canApplyEmployment) {
      supportDeductionDetails.employmentInsurance = truncateToTen(supportDeductionBase * insuranceRates.employmentInsurance);
      supportDeduction += supportDeductionDetails.employmentInsurance;
    }

    // 실업급여 (사업주 부담) - 실업급여 체크박스 (65세 이상은 별도 선택 가능), 원단위 절삭 적용
    if (canApplyUnemployment) {
      supportDeductionDetails.unemployment = truncateToTen(supportDeductionBase * insuranceRates.unemployment);
      supportDeduction += supportDeductionDetails.unemployment;
    }

    // 산재보험 (사업주 부담) - 항상 적용, 원단위 절삭 적용
    supportDeductionDetails.industrialAccident = truncateToTen(supportDeductionBase * insuranceRates.industrialAccident);
    supportDeduction += supportDeductionDetails.industrialAccident;

    // 퇴직금 부분 ((장기근속수당 + 중증수급자가산) ÷ 12) - 체크박스 상태가 우선, 원단위 절삭 적용
    // 기관부담금의 퇴직금은 totalPay/12로 계산되므로, 지원공제에서도 동일하게 supportDeductionBase를 사용
    if (supportDeductionBase > 0 && settings.applyRetirement) {
      supportDeductionDetails.retirement = truncateToTen(supportDeductionBase / 12);
      supportDeduction += supportDeductionDetails.retirement;
    }
  }

  // 지원공제를 근로자 공제에 추가 (TabYoboWage.vue 로직과 동일)
  totalEmployeeDeduction += supportDeduction;

  const totalCenterDeduction =
    centerDeductions.nationalPension +
    centerDeductions.healthInsurance +
    centerDeductions.longTermCare +
    centerDeductions.employmentInsurance +
    centerDeductions.unemployment +
    centerDeductions.industrialAccident +
    centerDeductions.retirement;

  // 실수령액 (본인부담금공제, 기타공제 포함 - totalEmployeeDeduction에 이미 합산됨)
  const netPay = totalPay - totalEmployeeDeduction;

  // 비과세 효과 계산 (TabYoboWage.vue 로직과 동일하게 적용)
  let employeeTaxSavings = 0;
  let centerTaxSavings = 0;
  
  if (nonTaxableAmount > 0 && taxData.value) {
    // === 근로자 부담 절감액 (실수령액 증가액) ===
    // 1. 소득세, 지방세 절감 (비과세를 과세로 계산했을 경우와 비교)
    const taxableWithNonTax = taxableAmount + nonTaxableAmount;
    const incomeTaxWithNonTax = calculateIncomeTax(taxableWithNonTax);
    const localTaxWithNonTax = Math.round(incomeTaxWithNonTax * 0.1);
    let taxSavings = (incomeTaxWithNonTax + localTaxWithNonTax) - (employeeDeductions.incomeTax + employeeDeductions.localTax);
    
    // 세금 절약액이 0이거나 음수인 경우 최소 세율 적용
    if (taxSavings <= 0) {
      const estimatedTaxRate = 0.0726;
      taxSavings = Math.round(nonTaxableAmount * estimatedTaxRate);
    }
    
    // 2. 국민연금 절감 (근로자 부담분)
    const pensionSavings = canApplyPension ? truncateToTen(nonTaxableAmount * (taxData.value.tr_yeon || 0.045)) : 0;
    
    // 3. 건강보험 + 장기요양보험 절감 (근로자 부담분)
    const healthInsuranceSavings = settings.applyHealthInsurance ? truncateToTen(nonTaxableAmount * (taxData.value.tr_gun || 0.03545)) : 0;
    const longTermCareSavings = truncateToTen(healthInsuranceSavings * (taxData.value.tr_jang || 0.1295));
    
    // 4. 고용보험 절감 (근로자 부담분)
    const employmentInsuranceSavings = canApplyEmployment ? truncateToTen(nonTaxableAmount * (taxData.value.tr_go || 0.009)) : 0;
    
    // 근로자 부담 총 절감액 (실수령액 증가액)
    employeeTaxSavings = Math.max(0,
      taxSavings +
      pensionSavings +
      healthInsuranceSavings +
      longTermCareSavings +
      employmentInsuranceSavings
    );
    
    // === 기관 부담 절감액 (인건비 절감액) ===
    // 1. 국민연금 절감 (사업주 부담분) - 체크박스 활성화 시에만
    const centerPensionSavings = canApplyPension ? truncateToTen(nonTaxableAmount * (taxData.value.tr_yeon || 0.045)) : 0;
    
    // 2. 건강보험 + 장기요양보험 절감 (사업주 부담분) - 항상 적용
    const centerHealthSavings = truncateToTen(nonTaxableAmount * (taxData.value.tr_gun || 0.03545));
    const centerLongTermCareSavings = truncateToTen(centerHealthSavings * (taxData.value.tr_jang || 0.1295));
    
    // 3. 고용보험 절감 (사업주 부담분) - 65세 미만 & 적용 시에만
    const centerEmploymentSavings = canApplyEmployment ? truncateToTen(nonTaxableAmount * (taxData.value.tr_go || 0.009)) : 0;
    
    // 4. 실업급여 절감 (사업주 부담분) - 나이와 상관없이 항상 적용
    const unemploymentSavings = truncateToTen(nonTaxableAmount * (taxData.value.tr_sil || 0.0025));
    
    // 5. 산재보험 절감 (사업주 부담분) - 나이와 상관없이 항상 적용
    const industrialAccidentSavings = truncateToTen(nonTaxableAmount * (taxData.value.tr_san || 0.0178));
    
    centerTaxSavings = Math.max(0,
      centerPensionSavings +
      centerHealthSavings +
      centerLongTermCareSavings +
      centerEmploymentSavings +
      unemploymentSavings +
      industrialAccidentSavings
    );
  }

  // 툴팁에서 사용할 계산 정보
  const calcMinWage = taxData.value?.tr_time_pay || 0;
  const calcAnnualLeaveDays = getAnnualLeaveDays(group.workStartDate);
  const calcActualWorkDays = getActualWorkDays(groupIndex);
  const calcWorkDaysForCalc = calcActualWorkDays > 0 ? calcActualWorkDays : serviceDays;
  const calcBaseVacationPay = calcWorkDaysForCalc > 0 
    ? Math.round((calcMinWage * totalSugaHours / calcWorkDaysForCalc) * calcAnnualLeaveDays / 12) 
    : 0;
  
  // 60시간 미만 여부 및 연차수당 조정 정보
  const isUnder60Hours = totalSugaHours < 60 && !isFamilyOnlyCaregiver;
  const calcBasicPlusHoliday = basicPay + holidayPay;
  const maxAllowedForUnder60 = totalMonthlyPay;
  const wasVacationPayAdjusted = isUnder60Hours && (calcBasicPlusHoliday + calcBaseVacationPay > maxAllowedForUnder60);
  const adjustedVacationPayAmount = wasVacationPayAdjusted ? Math.max(0, maxAllowedForUnder60 - calcBasicPlusHoliday) : 0;
  
  // 60시간 미만 시급 역산 정보
  let adjustedHourlyWage = calcMinWage;
  let wasWageAdjusted = false;
  let adjustedBaseVacationPay = 0;  // 역산 시급으로 계산된 기본 연차수당
  let vacationPayDifference = 0;    // 추가된 차액
  
  if (isUnder60Hours && totalSugaHours > 0) {
    const minWageBasicPay = calcMinWage * totalSugaHours;
    const minWageHolidayPay = Math.round(minWageBasicPay * 0.2);
    const minWageVacationPay = calcWorkDaysForCalc > 0 
      ? Math.round((calcMinWage * totalSugaHours / calcWorkDaysForCalc) * calcAnnualLeaveDays / 12) 
      : 0;
    const minWageTotal = minWageBasicPay + minWageHolidayPay + minWageVacationPay;
    
    // 최저시급 기준 기본급+주휴수당+연차수당 < 합계금액인 경우 시급 역산 적용
    if (minWageTotal < totalMonthlyPay) {
      // 연차수당까지 포함한 역산 시급 계산
      const calcVacationRatio = calcWorkDaysForCalc > 0 ? (calcAnnualLeaveDays / 12) / calcWorkDaysForCalc : 0;
      const calcTotalRatio = 1 + 0.2 + calcVacationRatio;
      const theoreticalMaxWage = totalMonthlyPay / (totalSugaHours * calcTotalRatio);
      const calculatedAdjustedWage = Math.floor(theoreticalMaxWage / 10) * 10;
      
      if (calculatedAdjustedWage > calcMinWage) {
        adjustedHourlyWage = calculatedAdjustedWage;
        wasWageAdjusted = true;
        
        // 역산 시급으로 계산된 기본 연차수당
        adjustedBaseVacationPay = calcWorkDaysForCalc > 0 
          ? Math.round((calculatedAdjustedWage * totalSugaHours / calcWorkDaysForCalc) * calcAnnualLeaveDays / 12) 
          : 0;
        
        // 추가된 차액 = 최종 연차수당 - 역산 시급 기준 연차수당
        vacationPayDifference = vacationPay - adjustedBaseVacationPay;
      }
    }
  }
  
  const calcRemainingAmount = isUnder60Hours ? 0 : Math.max(0, totalMonthlyPay - (calcMinWage * totalSugaHours) - Math.round(calcMinWage * totalSugaHours * 0.2) - calcBaseVacationPay);
  const calcVacationPayAddition = isUnder60Hours ? 0 : (vacationPay - calcBaseVacationPay);
  
  // 근속 정보 계산
  const workPeriodForCalc = props.yearMonth ? calculateWorkPeriod(group.workStartDate, props.yearMonth) : { years: 0, months: 0 };
  const calcTotalMonthsWorked = workPeriodForCalc.years * 12 + workPeriodForCalc.months;
  const calcYearLevel = calcTotalMonthsWorked < 12 ? 1 : Math.floor(calcTotalMonthsWorked / 12) + 1;
  
  // 휴일/연장 근무 여부 및 시간
  const holidayMinutes = getHolidayTotalMinutes(groupIndex);
  const overtimeMinutes = getOvertimeTotalMinutes(groupIndex);
  const hasHolidayWork = calculateHolidayAllowanceAmount(groupIndex) > 0 || getHolidayCount(groupIndex) > 0;
  const hasOvertimeWork = calculateOvertimeAllowanceAmount(groupIndex) > 0;

  return {
    isFamilyOnlyCaregiver,
    avgTimePay,
    basicPay,
    holidayPay,
    vacationPay,
    mealAllowance: actualMealAllowance,
    basicTotal,
    longServicePay,
    etcAllowance,
    severeCareAddition,
    holidayAllowance,
    overtimeAllowance,
    totalPay,
    taxableAmount,
    nonTaxableAmount,
    employeeDeductions,
    centerDeductions,
    supportDeduction,
    boninPayAmount,
    empEtcAmount: empEtcAmountForCalc,
    totalEmployeeDeduction,
    totalCenterDeduction,
    netPay,
    employeeTaxSavings,
    centerTaxSavings,
    suggestedNationalPension,
    calcInfo: {
      minWage: calcMinWage,
      totalSugaHours,
      annualLeaveDays: calcAnnualLeaveDays,
      workDaysForCalc: calcWorkDaysForCalc,
      totalMonthlyPay,
      baseVacationPay: calcBaseVacationPay,
      remainingAmount: calcRemainingAmount,
      vacationPayAddition: calcVacationPayAddition,
      yearLevel: calcYearLevel,
      totalMonthsWorked: calcTotalMonthsWorked,
      mealAllowance: actualMealAllowance,
      hasHolidayWork,
      hasOvertimeWork,
      holidayMinutes,
      overtimeMinutes,
      supportDeductionDetails,
      isUnder60Hours,
      wasVacationPayAdjusted,
      adjustedVacationPayAmount,
      basicPlusHoliday: calcBasicPlusHoliday,
      adjustedHourlyWage,
      wasWageAdjusted,
      adjustedBaseVacationPay,
      vacationPayDifference
    }
  };
};

// 서비스 내역 조회
const fetchServiceData = async () => {
  const user = store.state.user;
  if (!user || !user.m_sisul_code || !props.yearMonth) {
    return;
  }

  try {
    const [individualRes, dailyRes, weeklyRes, severeCareRes] = await Promise.all([
      axios.get('/api/calc/caregiver-individual-services', {
        params: {
          sisulCode: user.m_sisul_code,
          lebYm: props.yearMonth
        },
        withCredentials: true
      }),
      axios.get('/api/calc/caregiver-daily-services', {
        params: {
          sisulCode: user.m_sisul_code,
          lebYm: props.yearMonth
        },
        withCredentials: true
      }),
      axios.get('/api/calc/caregiver-weekly-services', {
        params: {
          sisulCode: user.m_sisul_code,
          lebYm: props.yearMonth
        },
        withCredentials: true
      }),
      axios.get('/api/calc/severe-care-addition-daily', {
        params: {
          sisulCode: user.m_sisul_code,
          lebYm: props.yearMonth
        },
        withCredentials: true
      })
    ]);

    // 개별 서비스 데이터 그룹별로 분류
    const individualData = individualRes.data.data || [];
    const dailyData = dailyRes.data.data || [];
    const weeklyData = weeklyRes.data.data || [];
    const severeCareData = severeCareRes.data.data || [];

    groupedMemberData.value.forEach((group, groupIndex) => {
      // 개별 서비스 내역
      individualServices.value[groupIndex] = individualData.filter((service: any) =>
        service.caregiver_name === group.name &&
        service.caregiver_birth === group.birth
      );

      // 중증수급자 가산 일자별 데이터
      severeCareAdditionDaily.value[groupIndex] = severeCareData.filter((service: any) =>
        service.caregiver_name === group.name &&
        service.caregiver_birth === group.birth
      );

      // 주차별 근무내역 (일자별 + 주차별 통합)
      const dailyForGroup = dailyData.filter((service: any) =>
        service.caregiver_name === group.name &&
        service.caregiver_birth === group.birth
      );

      const weeklyForGroup = weeklyData.filter((service: any) =>
        service.caregiver_name === group.name &&
        service.caregiver_birth === group.birth
      );

      // 주차별로 그룹화
      const weeklyMap = new Map();
      weeklyForGroup.forEach((week: any) => {
        weeklyMap.set(week.service_week, {
          service_week: week.service_week,
          weekly_total_hours: week.weekly_total_hours,
          daily_items: []
        });
      });

      dailyForGroup.forEach((daily: any) => {
        if (weeklyMap.has(daily.service_week)) {
          weeklyMap.get(daily.service_week).daily_items.push(daily);
        }
      });

      combinedWeeklyServices.value[groupIndex] = Array.from(weeklyMap.values());

      // 급여 상세 계산
      payrollDetails.value[groupIndex] = calculatePayrollDetails(group, groupIndex);

      // 국민연금 자동 설정 (DB에 설정된 적이 없는 경우만)
      // _hasYeonPaySetting 플래그가 true이면 이미 DB에서 불러온 설정이 있으므로 자동 설정 안 함
      const settings = settingsData.value[groupIndex];
      const payroll = payrollDetails.value[groupIndex];
      if (settings && payroll && !settings.applyNationalPension && !settings._hasYeonPaySetting) {
        // 가족요양만 진행하는 요양보호사이면서 60시간 미만이면 자동 설정 안 함
        const isFamilyOnly = isAllFamilyCaregiver(group);
        const totalSugaHours = getTotalSugaHours(group, groupIndex);
        
        if (isFamilyOnly && totalSugaHours < 60) {
          // 가족요양 60시간 미만 - 국민연금 자동 설정 하지 않음
        } else {
          // 만 60세 미만일 때만 체크박스 자동 활성화 + 값 자동 설정
          const caregiverAge = calculateAge(group.birth, props.yearMonth || '');
          if (caregiverAge < 60 && payroll.suggestedNationalPension > 0) {
            settings.applyNationalPension = true;
            settings.yeonPay = new Intl.NumberFormat('ko-KR').format(payroll.suggestedNationalPension);
          }
        }
      }
    });
    
    // 원래 설정 저장 (변경사항 비교용)
    saveOriginalSettings();
  } catch (error) {
    console.error('서비스 데이터 조회 오류:', error);
  }
};

// Member Info 데이터 조회 (caregiver-member-join API 사용)
const fetchMemberInfo = async () => {
  const user = store.state.user;
  if (!user || !user.m_sisul_code || !props.yearMonth) {
    return;
  }

  try {
    isLoadingMemberInfo.value = true;
    
    // 최저시급 데이터 먼저 가져오기
    const year = props.yearMonth.slice(0, 4);
    const taxResponse = await axios.get(`/api/calc/tax/${year}`);
    if (taxResponse.data.success) {
      taxData.value = taxResponse.data.data.taxRate;
      sojiData.value = taxResponse.data.data.soji || [];
    }
    
    // 공휴일 데이터 로드
    await loadHolidays(year);
    
    // TabYoboWage와 동일한 API 사용 (중증수급자 가산 데이터 포함)
    const [response, detailResponse] = await Promise.all([
      axios.get('/api/calc/caregiver-member-join', {
        params: {
          sisulCode: user.m_sisul_code,
          lebYm: props.yearMonth
        },
        withCredentials: true
      }),
      axios.get('/api/calc/caregiver-member-join-detail', {
        params: {
          sisulCode: user.m_sisul_code,
          lebYm: props.yearMonth
        },
        withCredentials: true
      })
    ]);

    // 중증수급자 가산 데이터 저장
    if (detailResponse.data.success || detailResponse.data.data) {
      memberJoinDetailData.value = detailResponse.data.data || [];
    } else {
      memberJoinDetailData.value = [];
    }

    if (response.data.success || response.data.data) {
      const rawData = response.data.data || [];
      
      
      // caregiver-member-join API 데이터 구조에 맞게 매핑
      memberInfoData.value = rawData.map((item: any) => ({
        lemi_idx: item.lemi_idx,
        emp_code: item.emp_code || '',  // hh_emp 테이블의 emp_code 사용
        lemi_name: item.caregiver_name,
        lemi_birth: item.caregiver_birth,
        lemi_gender: item.lem_gender,
        lemi_license: item.lem_license,
        lemi_work_start_date: item.lem_work_start_date,
        lemi_work_end_date: item.lem_work_end_date,
        lemi_patient_code: item.leb_patient_code,
        lemi_suga_code: item.suga_code,
        lemi_time_pay: item.time_pay,
        lemi_yeon_pay: item.lemi_yeon_pay,
        lemi_bonin_pay: item.lemi_bonin_pay,
        lemi_emp_etc: item.lemi_emp_etc,
        lemi_apply_go: item.lemi_apply_go,
        lemi_apply_holiday_pay: item.lemi_apply_holiday_pay,
        lemi_apply_lunch_pay: item.lemi_apply_lunch_pay,
        lemi_apply_gun: item.lemi_apply_gun,
        lemi_apply_overtime_pay: item.lemi_apply_overtime_pay,
        lemi_apply_out_pay: item.lemi_apply_out_pay,
        lemi_apply_labor_day_pay: item.lemi_apply_labor_day_pay,
        lemi_long_service_pay: item.lemi_long_service_pay,
        lemi_etc_allowance: item.lemi_etc_allowance,  // 기타수당
        lemi_sil_pay: item.lemi_sil_pay,  // 실업급여 금액
        lemi_custom_suga_hours: item.lemi_custom_suga_hours,  // 수동 조정된 수가시간 (JSON)
        lem_isboss: item.lem_isboss,
        patient_name: item.leb_patient_name,
        suga_name: item.suga_name,
        service_days: item.service_days,
        suga_hours: item.suga_hours,
        total_suga_money: item.total_suga_money,
        lunch_time_count: item.lunch_time_count || 0
      }));
      
      initializeSettingsData();
      
      // 서비스 데이터 조회
      await fetchServiceData();
      
      // 누적 퇴직금 조회
      await fetchCumulativeRetirement();
    } else {
      memberInfoData.value = [];
    }
  } catch (error) {
    console.error('사원 급여 정보 조회 오류:', error);
    memberInfoData.value = [];
  } finally {
    isLoadingMemberInfo.value = false;
  }
};

// 날짜가 일요일인지 확인
const isSunday = (dateStr: string) => {
  if (!dateStr) return false;
  const date = new Date(dateStr);
  return date.getDay() === 0;
};

// 공휴일 이름 가져오기
const getHolidayName = (dateStr: string) => {
  if (!dateStr) return null;
  return holidaysData.value[dateStr] || null;
};

// 공휴일 데이터 불러오기
const loadHolidays = async (year: string) => {
  try {
    const response = await axios.get(`/api/calc/holidays/${year}`);
    if (response.data.success) {
      const holidayMap: Record<string, string> = {};
      response.data.data.forEach((holiday: any) => {
        holidayMap[holiday.hh_date.split('T')[0]] = holiday.hh_holiday_name;
      });
      holidaysData.value = holidayMap;
    }
  } catch (error) {
    console.error('공휴일 조회 오류:', error);
  }
};

// 누적 퇴직금 조회 (해당 년도 1월부터 현재 월까지의 퇴직금 합계)
const fetchCumulativeRetirement = async () => {
  const user = store.state.user;
  if (!user || !user.m_sisul_code || !props.yearMonth) {
    return;
  }

  // 그룹화된 멤버 데이터에서 고유한 직원명 추출
  const uniqueNames = [...new Set(groupedMemberData.value.map((group: any) => group.name))];

  if (uniqueNames.length === 0) {
    return;
  }

  try {
    const promises = uniqueNames.map((empName: string) =>
      axios.get('/api/calc/cumulative-retirement', {
        params: {
          sisulCode: user.m_sisul_code,
          yearMonth: props.yearMonth,
          empName: empName
        },
        withCredentials: true
      })
    );

    const results = await Promise.allSettled(promises);

    const retirementMap: Record<string, number> = {};
    results.forEach((result, index) => {
      if (result.status === 'fulfilled' && result.value.data.success) {
        retirementMap[uniqueNames[index]] = Number(result.value.data.data) || 0;
      }
    });

    // 반응성을 위해 개별적으로 할당
    Object.keys(retirementMap).forEach(key => {
      cumulativeRetirement.value[key] = retirementMap[key];
    });
  } catch (error) {
    console.error('누적 퇴직금 조회 오류:', error);
  }
};

// 중증수급자 가산 데이터 (그룹별로 매칭)
const getSevereCareAdditionForGroup = (groupIndex: number) => {
  if (!memberJoinDetailData.value || memberJoinDetailData.value.length === 0) return [];
  if (!groupedMemberData.value || !groupedMemberData.value[groupIndex]) return [];

  const group = groupedMemberData.value[groupIndex];
  const caregiverName = group.name;
  const caregiverBirth = group.birth;

  // 해당 요양보호사의 중증수급자 가산 데이터 필터링
  // suga_name이 '중증수급자 가산' 또는 '중증수급자가산'인 경우 모두 포함
  return memberJoinDetailData.value.filter((item: any) =>
    item.caregiver_name === caregiverName &&
    item.caregiver_birth === caregiverBirth &&
    (item.suga_name === '중증수급자 가산' || item.suga_name === '중증수급자가산' || 
     (item.suga_name && item.suga_name.includes('중증수급자')))
  );
};

// 그룹별 중증수급자 가산 총액 계산
const getSevereCareAdditionTotal = (groupIndex: number) => {
  const severeAdditions = getSevereCareAdditionForGroup(groupIndex);
  if (!severeAdditions || severeAdditions.length === 0) return 0;

  let total = 0;
  severeAdditions.forEach((item: any) => {
    total += parseFloat(item.total_suga_money || 0);
  });

  return total;
};

// 그룹별 휴일 근무 일수 계산
const getHolidayCount = (groupIndex: number) => {
  const services = individualServices.value[groupIndex];
  if (!services || services.length === 0) return 0;

  const settings = settingsData.value[groupIndex];
  if (!settings?.applyHoliday) return 0;

  const holidayDates = new Set<string>();
  const year = props.yearMonth?.substring(0, 4) || '';
  const yearNum = parseInt(year);
  
  // 2025년 이하: 근로자의 날(5/1) 제외, 2026년 이상: 일반 휴일로 포함
  const laborDay = `${year}-05-01`;
  const excludeLaborDay = yearNum <= 2025;

  services.forEach((service: any) => {
    const dateStr = service.service_date;
    // 2025년 이하에서는 근로자의날 제외
    if (excludeLaborDay && dateStr === laborDay) return;
    // 일요일이거나 공휴일인 경우
    if (isSunday(dateStr) || getHolidayName(dateStr)) {
      holidayDates.add(dateStr);
    }
  });

  return holidayDates.size;
};

// 수가명이 휴일가산 수가인지 확인 (공휴일가산, 일요일가산)
const isHolidaySugaName = (sugaName: string | null | undefined): boolean => {
  if (!sugaName) return false;
  const name = sugaName.replace(/\s/g, ''); // 공백 제거
  if (name.includes('공휴일가산')) return true;
  if (name.includes('공휴일') && name.includes('가산')) return true;
  if (name.includes('일요일가산')) return true;
  if (name.includes('일요일') && name.includes('가산')) return true;
  return false;
};

// 휴일수당 금액 계산 (휴일 근무 시간 × 최저시급 × 0.5)
const calculateHolidayAllowanceAmount = (groupIndex: number) => {
  const settings = settingsData.value[groupIndex];
  if (!settings?.applyHoliday) return 0;

  const totalMinutes = getHolidayTotalMinutes(groupIndex);
  if (totalMinutes === 0) return 0;

  const timePay = taxData.value?.tr_time_pay || 0;
  if (timePay === 0) return 0;

  const totalHours = totalMinutes / 60;
  return Math.round(totalHours * timePay * 0.5);
};

// 그룹별 휴일 근무 총 시간(분) 계산
const getHolidayTotalMinutes = (groupIndex: number) => {
  const settings = settingsData.value[groupIndex];
  if (!settings?.applyHoliday) return 0;

  const group = groupedMemberData.value[groupIndex];
  if (!group?.patients) return 0;

  let totalMinutes = 0;

  group.patients.forEach((patient: any) => {
    if (!isHolidaySugaName(patient.sugaName)) return;

    const sugaKey = getSugaKey(patient);
    const sugaHours = settings.customSugaHours?.[patient.patientCode]?.[sugaKey] ?? patient.sugaHours ?? 0;
    const serviceDays = patient.serviceDays || 0;
    totalMinutes += serviceDays * sugaHours * 60;
  });

  return totalMinutes;
};

// 그룹별 연장 근무 총 시간(분) 계산 (일일 8시간 초과분)
const getOvertimeTotalMinutes = (groupIndex: number) => {
  const dailyData = combinedWeeklyServices.value[groupIndex];
  if (!dailyData || dailyData.length === 0) return 0;

  const settings = settingsData.value[groupIndex];
  if (!settings?.applyOvertime) return 0;

  let totalOvertimeMinutes = 0;

  // 주차별 데이터에서 일자별 데이터 추출
  dailyData.forEach((weekGroup: any) => {
    weekGroup.daily_items?.forEach((daily: any) => {
      const dailyMinutes = (daily.daily_total_hours || 0) * 60;
      // 일일 8시간(480분) 초과분만 연장근무
      if (dailyMinutes > 480) {
        totalOvertimeMinutes += (dailyMinutes - 480);
      }
    });
  });

  return Math.round(totalOvertimeMinutes);
};

// 연장수당 금액 계산 (연장 근무 시간 × 최저시급 × 0.5)
const calculateOvertimeAllowanceAmount = (groupIndex: number) => {
  const settings = settingsData.value[groupIndex];
  if (!settings?.applyOvertime) return 0;

  const totalMinutes = getOvertimeTotalMinutes(groupIndex);
  if (totalMinutes === 0) return 0;

  const timePay = taxData.value?.tr_time_pay || 0;
  if (timePay === 0) return 0;

  const totalHours = totalMinutes / 60;
  return Math.round(totalHours * timePay * 0.5);
};

// 분을 시간으로 포맷팅
const formatTotalMinutes = (minutes: number) => {
  if (!minutes) return '0분';
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (hours > 0 && mins > 0) {
    return `${hours}시간 ${mins}분`;
  } else if (hours > 0) {
    return `${hours}시간`;
  } else {
    return `${mins}분`;
  }
};

// 설정 저장
const saveSettings = async () => {
  const user = store.state.user;
  if (!user || !user.m_sisul_code || !props.yearMonth) {
    store.commit('showSnackbar', { text: '사용자 정보를 확인할 수 없습니다.', color: 'error' });
    return;
  }

  try {
    isSaving.value = true;

    const saveData: any[] = [];
    
    groupedMemberData.value.forEach((group, groupIndex) => {
      const settings = settingsData.value[groupIndex];
      if (!settings) return;
      
      group.originalItems.forEach((item, itemIndex) => {
        const patientCode = item.lemi_patient_code;
        const sugaCode = item.lemi_suga_code;
        
        // patients 배열에서 같은 인덱스의 항목을 가져와서 getSugaKey 사용 (키 일관성 보장)
        const patient = group.patients[itemIndex];
        const sugaKey = patient ? getSugaKey(patient) : sugaCode;
        
        const timePay = settings.timePays[patientCode]?.[sugaKey] || '';
        const numericTimePay = timePay ? String(timePay).replace(/[^\d]/g, '') : '';
        
        // 퇴직금 금액 계산 (payrollDetails에서 가져옴)
        const payroll = payrollDetails.value[groupIndex];
        const retirementAmount = payroll?.centerDeductions?.retirement || 0;
        
        // 실업급여 금액 직접 계산 (settings.applyUnemployment 기준으로)
        let unemploymentAmount = 0;
        if (settings.applyUnemployment && payroll) {
          const taxableAmount = payroll.taxableAmount || 0;
          const unemploymentRate = taxData.value?.tr_sil || 0.0025;
          unemploymentAmount = Math.round(taxableAmount * unemploymentRate);
        }
        
        // 수동 조정된 수가시간을 JSON으로 변환 (해당 요양보호사의 전체 customSugaHours)
        const customSugaHoursJson = settings.customSugaHours && Object.keys(settings.customSugaHours).length > 0
          ? JSON.stringify(settings.customSugaHours)
          : null;
        
        saveData.push({
          m_sisul_code: user.m_sisul_code,
          lemi_ym: props.yearMonth,
          lemi_name: item.lemi_name,
          lemi_time_pay: numericTimePay,
          lemi_birth: item.lemi_birth,
          lemi_gender: item.lemi_gender,
          lemi_license: item.lemi_license,
          lemi_work_start_date: item.lemi_work_start_date,
          lemi_work_end_date: item.lemi_work_end_date,
          lemi_patient_code: patientCode,
          lemi_suga_code: sugaCode,
          lemi_yeon_pay: settings.applyNationalPension && settings.yeonPay ? String(settings.yeonPay).replace(/[^\d]/g, '') : '',
          lemi_bonin_pay: settings.applyBoninPay && settings.boninPay ? String(settings.boninPay).replace(/[^\d]/g, '') : '',
          lemi_emp_etc: settings.applyEmpEtc && settings.empEtc ? String(settings.empEtc).replace(/[^\d]/g, '') : '',
          lemi_apply_gun: settings.applyHealthInsurance ? 'Y' : 'N',
          lemi_apply_go: settings.applyEmploymentInsurance ? 'Y' : 'N',
          lemi_apply_holiday_pay: settings.applyHoliday ? 'Y' : 'N',
          lemi_apply_overtime_pay: settings.applyOvertime ? 'Y' : 'N',
          lemi_apply_lunch_pay: settings.applyMeal ? 'Y' : 'N',
          lemi_apply_out_pay: settings.applyRetirement ? 'Y' : 'N',
          lemi_out_pay: retirementAmount > 0 ? String(retirementAmount) : '',
          lemi_sil_pay: unemploymentAmount > 0 ? String(unemploymentAmount) : '', // 실업급여 금액
          lemi_apply_labor_day_pay: 'Y', // 근로자의날 수당은 기본 적용
          lemi_long_service_pay: settings.applyLongServicePay && settings.longServicePay ? String(settings.longServicePay).replace(/[^\d]/g, '') : '',
          lemi_etc_allowance: settings.applyEtcAllowance && settings.etcAllowance ? String(settings.etcAllowance).replace(/[^\d]/g, '') : '',
          lemi_custom_suga_hours: customSugaHoursJson  // 수동 조정된 수가시간 (JSON)
        });
      });
    });

    // 1. 기존 설정 데이터 저장 (hh_longterm_excel_member_info)
    const response = await axios.post('/api/calc/save-member-info', {
      sisulCode: user.m_sisul_code,
      lebYm: props.yearMonth,
      memberData: saveData
    }, { withCredentials: true });

    if (response.data.success) {
      // 2. 계산된 급여 데이터 저장 (hh_emp_sabok_work_info)
      const payrollDataList = groupedMemberData.value.map((group, groupIndex) => {
        const payroll = payrollDetails.value[groupIndex];
        const settings = settingsData.value[groupIndex];
        if (!payroll) return null;

        const totalSugaHours = getTotalSugaHours(group, groupIndex);  // 수동 조정된 시간 반영
        const serviceDays = getTotalServiceDays(group);
        const age = calculateAge(group.birth, props.yearMonth || '');
        
        // 기관수익 계산: 수가금액 - 총지급액 - 기관공제
        const centerProfit = (group.totalSugaMoney || 0) - (payroll.totalPay || 0) - (payroll.totalCenterDeduction || 0);
        
        // 수가시간 수동 변경 여부 확인
        const sugaHoursChanged = settings?.sugaHoursChanged || false;
        
        return {
          empCode: group.empCode || '',  // emp_code로 직원 식별
          sugaHours: totalSugaHours,
          sugaHoursChanged: sugaHoursChanged ? 'Y' : 'N',  // 수가시간 수동 변경 여부
          serviceDays: serviceDays,
          totalMinutes: Math.round(totalSugaHours * 60),
          lunchTimeCount: group.totalLunchTimeCount || 0,
          avgTimePay: payroll.avgTimePay || 0,
          isFamilyOnly: payroll.isFamilyOnlyCaregiver || false,
          isBoss: group.isBoss || false,
          monthlyPay: group.totalSugaMoney || 0,  // 월급여 (수가금액 합계)
          basicPay: payroll.basicPay || 0,
          holidayPay: payroll.holidayPay || 0,         // 주휴수당
          vacationPay: payroll.vacationPay || 0,       // 연차수당
          mealAllowance: payroll.mealAllowance || 0,
          holidayAllowance: payroll.holidayAllowance || 0, // 휴일수당
          overtimeAllowance: payroll.overtimeAllowance || 0,
          nightAllowance: 0,
          laborDayAllowance: 0,
          longServicePay: payroll.longServicePay || 0,
          etcAllowance: payroll.etcAllowance || 0,
          severeCareAddition: payroll.severeCareAddition || 0,
          otherPay: 0,
          totalPay: payroll.totalPay || 0,
          holidayMinutes: getHolidayTotalMinutes(groupIndex),
          overtimeMinutes: getOvertimeTotalMinutes(groupIndex),
          nightMinutes: 0,
          employeeDeductions: payroll.employeeDeductions || {},
          totalEmployeeDeduction: payroll.totalEmployeeDeduction || 0,
          centerDeductions: payroll.centerDeductions || {},
          totalCenterDeduction: payroll.totalCenterDeduction || 0,
          supportDeduction: payroll.supportDeduction || 0,
          boninPay: payroll.boninPayAmount || 0,  // 본인부담금공제
          empEtc: payroll.empEtcAmount || 0,      // 기타공제
          netPay: payroll.netPay || 0,
          taxableAmount: payroll.taxableAmount || 0,
          nonTaxableAmount: payroll.nonTaxableAmount || 0,
          employeeTaxSavings: payroll.employeeTaxSavings || 0,
          centerTaxSavings: payroll.centerTaxSavings || 0,
          centerProfit: centerProfit  // 기관수익
        };
      }).filter(item => item !== null);

      try {
        await axios.post('/api/calc/yobo-payroll', {
          sisulCode: user.m_sisul_code,
          yearMonth: props.yearMonth,
          payrollDataList
        }, { withCredentials: true });
      } catch (payrollError) {
        console.warn('급여 계산 결과 저장 실패 (무시됨):', payrollError);
      }

      store.commit('showSnackbar', { text: `✅ 설정이 저장되었습니다. (${response.data.savedCount}건)`, color: 'success' });
      hasUnsavedChanges.value = false;
      
      // customSugaHours 백업 (DB에 저장되지 않으므로 보존 필요)
      const customSugaHoursBackup: Record<number, { customSugaHours: Record<string, Record<string, number>>; sugaHoursChanged: boolean }> = {};
      Object.keys(settingsData.value).forEach((key) => {
        const idx = Number(key);
        if (settingsData.value[idx]?.customSugaHours && Object.keys(settingsData.value[idx].customSugaHours).length > 0) {
          customSugaHoursBackup[idx] = {
            customSugaHours: JSON.parse(JSON.stringify(settingsData.value[idx].customSugaHours)),
            sugaHoursChanged: settingsData.value[idx].sugaHoursChanged
          };
        }
      });
      
      // 설정 데이터 초기화 후 다시 로드 (새로운 DB 값 반영을 위해)
      settingsData.value = {};
      await fetchMemberInfo();
      
      // customSugaHours 복원
      Object.keys(customSugaHoursBackup).forEach((key) => {
        const idx = Number(key);
        if (settingsData.value[idx]) {
          settingsData.value[idx].customSugaHours = customSugaHoursBackup[idx].customSugaHours;
          settingsData.value[idx].sugaHoursChanged = customSugaHoursBackup[idx].sugaHoursChanged;
        }
      });
    } else {
      store.commit('showSnackbar', { text: '설정 저장에 실패했습니다.', color: 'error' });
    }
  } catch (error) {
    console.error('설정 저장 오류:', error);
    store.commit('showSnackbar', { text: '설정 저장 중 오류가 발생했습니다.', color: 'error' });
  } finally {
    isSaving.value = false;
  }
};

// 개별 요양보호사 저장
const saveSingleCaregiver = async (groupIndex: number) => {
  const user = store.state.user;
  if (!user || !user.m_sisul_code || !props.yearMonth) {
    store.commit('showSnackbar', { text: '사용자 정보를 확인할 수 없습니다.', color: 'error' });
    return;
  }

  const group = groupedMemberData.value[groupIndex];
  if (!group) {
    store.commit('showSnackbar', { text: '요양보호사 정보를 찾을 수 없습니다.', color: 'error' });
    return;
  }

  const settings = settingsData.value[groupIndex];
  if (!settings) {
    store.commit('showSnackbar', { text: '설정 정보를 찾을 수 없습니다.', color: 'error' });
    return;
  }

  try {
    isSaving.value = true;

    const saveData: any[] = [];
    
    // 퇴직금 금액 계산 (payrollDetails에서 가져옴)
    const payroll = payrollDetails.value[groupIndex];
    const retirementAmount = payroll?.centerDeductions?.retirement || 0;
    
    // 실업급여 금액 직접 계산 (settings.applyUnemployment 기준으로)
    let unemploymentAmount = 0;
    if (settings.applyUnemployment && payroll) {
      const taxableAmount = payroll.taxableAmount || 0;
      const unemploymentRate = taxData.value?.tr_sil || 0.0025;
      unemploymentAmount = Math.round(taxableAmount * unemploymentRate);
    }
    
    // 수동 조정된 수가시간을 JSON으로 변환 (해당 요양보호사의 전체 customSugaHours)
    const customSugaHoursJson = settings.customSugaHours && Object.keys(settings.customSugaHours).length > 0
      ? JSON.stringify(settings.customSugaHours)
      : null;
    
    group.originalItems.forEach((item, itemIndex) => {
      const patientCode = item.lemi_patient_code;
      const sugaCode = item.lemi_suga_code;
      
      // patients 배열에서 같은 인덱스의 항목을 가져와서 getSugaKey 사용 (키 일관성 보장)
      const patient = group.patients[itemIndex];
      const sugaKey = patient ? getSugaKey(patient) : sugaCode;
      
      const timePay = settings.timePays[patientCode]?.[sugaKey] || '';
      const numericTimePay = timePay ? String(timePay).replace(/[^\d]/g, '') : '';
      
      saveData.push({
        m_sisul_code: user.m_sisul_code,
        lemi_ym: props.yearMonth,
        lemi_name: item.lemi_name,
        lemi_time_pay: numericTimePay,
        lemi_birth: item.lemi_birth,
        lemi_gender: item.lemi_gender,
        lemi_license: item.lemi_license,
        lemi_work_start_date: item.lemi_work_start_date,
        lemi_work_end_date: item.lemi_work_end_date,
        lemi_patient_code: patientCode,
        lemi_suga_code: sugaCode,
        lemi_yeon_pay: settings.applyNationalPension && settings.yeonPay ? String(settings.yeonPay).replace(/[^\d]/g, '') : '',
        lemi_bonin_pay: settings.applyBoninPay && settings.boninPay ? String(settings.boninPay).replace(/[^\d]/g, '') : '',
        lemi_emp_etc: settings.applyEmpEtc && settings.empEtc ? String(settings.empEtc).replace(/[^\d]/g, '') : '',
        lemi_apply_gun: settings.applyHealthInsurance ? 'Y' : 'N',
        lemi_apply_go: settings.applyEmploymentInsurance ? 'Y' : 'N',
        lemi_apply_holiday_pay: settings.applyHoliday ? 'Y' : 'N',
        lemi_apply_overtime_pay: settings.applyOvertime ? 'Y' : 'N',
        lemi_apply_lunch_pay: settings.applyMeal ? 'Y' : 'N',
        lemi_apply_out_pay: settings.applyRetirement ? 'Y' : 'N',
        lemi_out_pay: retirementAmount > 0 ? String(retirementAmount) : '',
        lemi_sil_pay: unemploymentAmount > 0 ? String(unemploymentAmount) : '', // 실업급여 금액
        lemi_apply_labor_day_pay: 'Y',
        lemi_long_service_pay: settings.applyLongServicePay && settings.longServicePay ? String(settings.longServicePay).replace(/[^\d]/g, '') : '',
        lemi_etc_allowance: settings.applyEtcAllowance && settings.etcAllowance ? String(settings.etcAllowance).replace(/[^\d]/g, '') : '',
        lemi_custom_suga_hours: customSugaHoursJson  // 수동 조정된 수가시간 (JSON)
      });
    });

    const response = await axios.post('/api/calc/save-member-info', {
      sisulCode: user.m_sisul_code,
      lebYm: props.yearMonth,
      memberData: saveData
    }, { withCredentials: true });

    if (response.data.success) {
      store.commit('showSnackbar', { text: `✅ ${group.name} 요양보호사 설정이 저장되었습니다. (${response.data.savedCount}건)`, color: 'success' });
      saveOriginalSettings();
      hasUnsavedChanges.value = false;
    } else {
      store.commit('showSnackbar', { text: '설정 저장에 실패했습니다.', color: 'error' });
    }
  } catch (error) {
    console.error('개별 설정 저장 오류:', error);
    store.commit('showSnackbar', { text: '설정 저장 중 오류가 발생했습니다.', color: 'error' });
  } finally {
    isSaving.value = false;
  }
};

// 확정 버튼 클릭
const handleConfirm = () => {
  showConfirmDialog.value = true;
};

const proceedConfirm = async () => {
  showConfirmDialog.value = false;
  
  // StepThree 확정 시에는 마감 데이터를 생성하지 않고 emit만 수행
  store.commit('showSnackbar', { 
    text: '✅ 급여 설정이 확정되었습니다.', 
    color: 'success' 
  });
  emit('confirm');
};

// 해제 버튼 클릭
const handleRelease = () => {
  showReleaseDialog.value = true;
};

const proceedRelease = async () => {
  showReleaseDialog.value = false;
  
  const user = store.state.user;
  if (!user || !user.m_sisul_code || !props.yearMonth) {
    store.commit('showSnackbar', { text: '사용자 정보를 확인할 수 없습니다.', color: 'error' });
    return;
  }

  try {
    // 마감 해제 API 호출
    const response = await axios.put('/api/calc/wage-magam/release', {
      sisulCode: user.m_sisul_code,
      lebYm: props.yearMonth
    }, { withCredentials: true });

    if (response.data.success) {
      store.commit('showSnackbar', { 
        text: '✅ 급여 설정 확정이 해제되었습니다.', 
        color: 'success' 
      });
      emit('release');
    } else {
      store.commit('showSnackbar', { 
        text: '확정 해제에 실패했습니다.', 
        color: 'error' 
      });
    }
  } catch (error: any) {
    console.error('확정 해제 오류:', error);
    store.commit('showSnackbar', { 
      text: '확정 해제 중 오류가 발생했습니다: ' + (error.response?.data?.message || error.message), 
      color: 'error' 
    });
  }
};

// SetModal 이벤트 핸들러들
// 일괄 시급 적용 (일반)
const handleBulkTimePay = (value: string) => {
  const numericValue = value.replace(/[^\d]/g, '');
  
  groupedMemberData.value.forEach((group, groupIndex) => {
    group.patients.forEach((patient) => {
      // 가족 케어가 아닌 경우만 적용
      if (!patient.sugaName.includes('가족')) {
        if (!settingsData.value[groupIndex].timePays[patient.patientCode]) {
          settingsData.value[groupIndex].timePays[patient.patientCode] = {};
        }
        const sugaKey = getSugaKey(patient);
        settingsData.value[groupIndex].timePays[patient.patientCode][sugaKey] = 
          new Intl.NumberFormat('ko-KR').format(parseInt(numericValue));
      }
    });
  });
  
  checkUnsavedChanges();
  store.commit('showSnackbar', { text: '일반 시간당 임금이 일괄 적용되었습니다.', color: 'success' });
};

// 일괄 시급 적용 (가족)
const handleBulkTimePayFamily = (value: string) => {
  const numericValue = value.replace(/[^\d]/g, '');
  
  groupedMemberData.value.forEach((group, groupIndex) => {
    group.patients.forEach((patient) => {
      // 가족 케어인 경우만 적용
      if (patient.sugaName.includes('가족')) {
        if (!settingsData.value[groupIndex].timePays[patient.patientCode]) {
          settingsData.value[groupIndex].timePays[patient.patientCode] = {};
        }
        const sugaKey = getSugaKey(patient);
        settingsData.value[groupIndex].timePays[patient.patientCode][sugaKey] = 
          new Intl.NumberFormat('ko-KR').format(parseInt(numericValue));
      }
    });
  });
  
  checkUnsavedChanges();
  store.commit('showSnackbar', { text: '가족 케어 시간당 임금이 일괄 적용되었습니다.', color: 'success' });
};

// 일괄 시급 적용 (가족 60분)
const handleBulkTimePayFamily60 = (value: string) => {
  const numericValue = value.replace(/[^\d]/g, '');
  
  groupedMemberData.value.forEach((group, groupIndex) => {
    group.patients.forEach((patient) => {
      // 60분 + 가족 케어인 경우만 적용
      if (patient.sugaName.includes('60분') && patient.sugaName.includes('가족')) {
        if (!settingsData.value[groupIndex].timePays[patient.patientCode]) {
          settingsData.value[groupIndex].timePays[patient.patientCode] = {};
        }
        const sugaKey = getSugaKey(patient);
        settingsData.value[groupIndex].timePays[patient.patientCode][sugaKey] = 
          new Intl.NumberFormat('ko-KR').format(parseInt(numericValue));
      }
    });
  });
  
  checkUnsavedChanges();
  store.commit('showSnackbar', { text: '가족 60분 케어 시간당 임금이 일괄 적용되었습니다.', color: 'success' });
};

// 일괄 시급 적용 (가족 90분)
const handleBulkTimePayFamily90 = (value: string) => {
  const numericValue = value.replace(/[^\d]/g, '');
  
  groupedMemberData.value.forEach((group, groupIndex) => {
    group.patients.forEach((patient) => {
      // 90분 + 가족 케어인 경우만 적용
      if (patient.sugaName.includes('90분') && patient.sugaName.includes('가족')) {
        if (!settingsData.value[groupIndex].timePays[patient.patientCode]) {
          settingsData.value[groupIndex].timePays[patient.patientCode] = {};
        }
        const sugaKey = getSugaKey(patient);
        settingsData.value[groupIndex].timePays[patient.patientCode][sugaKey] = 
          new Intl.NumberFormat('ko-KR').format(parseInt(numericValue));
      }
    });
  });
  
  checkUnsavedChanges();
  store.commit('showSnackbar', { text: '가족 90분 케어 시간당 임금이 일괄 적용되었습니다.', color: 'success' });
};

// 일괄 휴일수당 적용
const handleBulkHolidayAllowance = (value: boolean) => {
  groupedMemberData.value.forEach((group, groupIndex) => {
    settingsData.value[groupIndex].applyHoliday = value;
  });
  
  const message = value ? '휴일수당이 일괄 지급으로 설정되었습니다.' : '휴일수당이 일괄 미지급으로 설정되었습니다.';
  store.commit('showSnackbar', { text: message, color: 'success' });
};

// 일괄 연장수당 적용
const handleBulkOvertimeAllowance = (value: boolean) => {
  groupedMemberData.value.forEach((group, groupIndex) => {
    settingsData.value[groupIndex].applyOvertime = value;
  });
  
  const message = value ? '연장수당이 일괄 지급으로 설정되었습니다.' : '연장수당이 일괄 미지급으로 설정되었습니다.';
  store.commit('showSnackbar', { text: message, color: 'success' });
};

// 일괄 퇴직금 적용
const handleBulkRetirement = (value: boolean) => {
  groupedMemberData.value.forEach((group, groupIndex) => {
    settingsData.value[groupIndex].applyRetirement = value;
  });
  
  const message = value ? '퇴직금이 일괄 적립으로 설정되었습니다.' : '퇴직금이 일괄 미적립으로 설정되었습니다.';
  store.commit('showSnackbar', { text: message, color: 'success' });
};

// 일괄 식대 적용
const handleBulkMealAllowance = (value: boolean) => {
  groupedMemberData.value.forEach((group, groupIndex) => {
    settingsData.value[groupIndex].applyMeal = value;
  });
  
  const message = value ? '식대가 일괄 지급으로 설정되었습니다.' : '식대가 일괄 미지급으로 설정되었습니다.';
  store.commit('showSnackbar', { text: message, color: 'success' });
};

// 장기근속수당 자동 계산
const handleBulkLongServiceAutoCalculate = () => {
  if (!props.yearMonth) return;
  
  groupedMemberData.value.forEach((group, groupIndex) => {
    const workPeriod = calculateWorkPeriod(group.workStartDate, props.yearMonth!);
    const totalMonths = workPeriod.years * 12 + workPeriod.months;
    
    let amount = 0;
    if (totalMonths >= 36) { // 3년 이상
      amount = 100000;
    } else if (totalMonths >= 24) { // 2년 이상
      amount = 50000;
    } else if (totalMonths >= 12) { // 1년 이상
      amount = 30000;
    }
    
    settingsData.value[groupIndex].longServicePay = amount > 0 
      ? new Intl.NumberFormat('ko-KR').format(amount) 
      : '';
  });
  
  store.commit('showSnackbar', { text: '장기근속수당이 자동 계산되었습니다.', color: 'success' });
};

// 장기근속수당 일괄 미지급
const handleBulkLongServiceClear = () => {
  groupedMemberData.value.forEach((group, groupIndex) => {
    settingsData.value[groupIndex].longServicePay = '';
  });
  
  store.commit('showSnackbar', { text: '장기근속수당이 일괄 미지급으로 설정되었습니다.', color: 'success' });
};

// 근로자의날 수당 적용 (5월만)
const handleBulkLaborDayAllowance = (value: boolean) => {
  // 현재는 DB에 lemi_apply_labor_day_pay 필드가 있지만 StepThree에서는 직접 관리하지 않음
  // 필요시 추가 구현
  const message = value ? '근로자의날 수당이 일괄 지급으로 설정되었습니다.' : '근로자의날 수당이 일괄 미지급으로 설정되었습니다.';
  store.commit('showSnackbar', { text: message, color: 'success' });
};

// WageEmployeeModal 열기 핸들러
const openEmployeeModal = (index: number) => {
  selectedEmployeeIndex.value = index;
  selectedEmployee.value = groupedMemberData.value[index];
  showEmployeeModal.value = true;
};

// WageEmployeeModal에서 설정 업데이트 핸들러
const handleUpdateSetting = (groupIndex: number, key: string, value: any) => {
  if (!settingsData.value[groupIndex]) return;
  (settingsData.value[groupIndex] as any)[key] = value;
  checkUnsavedChanges();
};

// WageEmployeeModal에서 시급 업데이트 핸들러
const handleUpdateTimepay = (groupIndex: number, patientCode: string, sugaKey: string, value: string) => {
  if (!settingsData.value[groupIndex]) return;
  if (!settingsData.value[groupIndex].timePays[patientCode]) {
    settingsData.value[groupIndex].timePays[patientCode] = {};
  }
  settingsData.value[groupIndex].timePays[patientCode][sugaKey] = value;
  checkUnsavedChanges();
};

// 수가시간 모달 열기 (WageEmployeeModal에서 호출)
const openSugaHoursModalFromModal = (groupIndex: number, patient: any) => {
  currentSugaHoursGroupIndex.value = groupIndex;
  const sugaKey = getSugaKey(patient);
  currentSugaHoursPatient.value = {
    patientCode: patient.patientCode,
    patientName: patient.patientName,
    sugaKey: sugaKey,
    sugaName: patient.sugaName,
    originalHours: patient.sugaHours || 0
  };
  selectedSugaHours.value = getEffectiveSugaHours(groupIndex, patient);
  showSugaHoursModal.value = true;
};

// 개별 요양보호사 설정 초기화
const resetSingleCaregiverSettings = (groupIndex: number) => {
  const settings = settingsData.value[groupIndex];
  const group = groupedMemberData.value[groupIndex];
  if (!settings || !group) return;
  
  // 모든 시급 초기화
  group.patients.forEach((patient) => {
    const sugaKey = getSugaKey(patient);
    if (settings.timePays[patient.patientCode]) {
      settings.timePays[patient.patientCode][sugaKey] = '';
    }
  });
  
  // 체크박스 및 입력값 초기화
  settings.applyNationalPension = false;
  settings.yeonPay = '';
  settings.applyLongServicePay = false;
  settings.longServicePay = '';
  settings.applyEtcAllowance = false;
  settings.etcAllowance = '';
  settings.applyBoninPay = false;
  settings.boninPay = '';
  settings.applyEmpEtc = false;
  settings.empEtc = '';
  settings.customSugaHours = {};
  settings.sugaHoursChanged = false;
  
  checkUnsavedChanges();
  store.commit('showSnackbar', { text: '설정이 초기화되었습니다.', color: 'info' });
};

// 과거 설정 불러오기 (개별)
const loadPreviousSettings = async (groupIndex: number) => {
  const user = store.state.user;
  if (!user || !user.m_sisul_code || !props.yearMonth) return;
  
  const group = groupedMemberData.value[groupIndex];
  if (!group) return;
  
  try {
    const response = await axios.get('/api/calc/previous-member-info', {
      params: {
        sisulCode: user.m_sisul_code,
        lebYm: props.yearMonth,
        caregiverName: group.name,
        caregiverBirth: group.birth
      },
      withCredentials: true
    });
    
    if (response.data.success && response.data.data && response.data.data.length > 0) {
      const prevData = response.data.data[0];
      const settings = settingsData.value[groupIndex];
      if (settings) {
        // 시급 적용
        group.patients.forEach((patient) => {
          const sugaKey = getSugaKey(patient);
          const matchingPrev = response.data.data.find((item: any) => 
            item.leb_patient_code === patient.patientCode && 
            item.suga_code === patient.sugaCode
          );
          if (matchingPrev && matchingPrev.time_pay) {
            if (!settings.timePays[patient.patientCode]) {
              settings.timePays[patient.patientCode] = {};
            }
            const numericValue = parseFloat(String(matchingPrev.time_pay).replace(/[^\d]/g, '')) || 0;
            settings.timePays[patient.patientCode][sugaKey] = numericValue > 0 
              ? new Intl.NumberFormat('ko-KR').format(numericValue) 
              : '';
          }
        });
        
        // 기타 설정 적용
        if (prevData.lemi_yeon_pay) {
          const numericValue = parseFloat(String(prevData.lemi_yeon_pay).replace(/[^\d]/g, '')) || 0;
          if (numericValue > 0) {
            settings.applyNationalPension = true;
            settings.yeonPay = new Intl.NumberFormat('ko-KR').format(numericValue);
          }
        }
        if (prevData.lemi_long_service_pay) {
          const numericValue = parseFloat(String(prevData.lemi_long_service_pay).replace(/[^\d]/g, '')) || 0;
          if (numericValue > 0) {
            settings.applyLongServicePay = true;
            settings.longServicePay = new Intl.NumberFormat('ko-KR').format(numericValue);
          }
        }
        
        checkUnsavedChanges();
        store.commit('showSnackbar', { text: '과거 설정을 불러왔습니다.', color: 'success' });
      }
    } else {
      store.commit('showSnackbar', { text: '과거 데이터가 없습니다.', color: 'warning' });
    }
  } catch (error) {
    console.error('과거 설정 불러오기 오류:', error);
    store.commit('showSnackbar', { text: '과거 설정 불러오기 중 오류가 발생했습니다.', color: 'error' });
  }
};

// 입사일/퇴사일 변경 핸들러
const handleStartDateUpdated = async (groupIndex: number, newStartDate: string, newEndDate: string | null = null) => {
  // 데이터 다시 로드
  await fetchMemberInfo();
};

// 직원 정보 아이템 생성 (WageEmployeeModal용)
const getEmployeeInfoItems = (group: GroupedMember, groupIndex: number) => {
  const items: { icon: string; color: string; text: string }[] = [];
  const age = calculateAge(group.birth, props.yearMonth || '');
  const totalHours = getTotalSugaHours(group, groupIndex);
  const totalDays = getTotalServiceDays(group);
  
  items.push({ icon: 'mdi-cake-variant', color: '#6b7280', text: `만 ${age}세` });
  items.push({ icon: 'mdi-clock-outline', color: '#6b7280', text: `${formatSugaHours(totalHours)} 근무` });
  items.push({ icon: 'mdi-counter', color: '#6b7280', text: `${totalDays}회 서비스` });
  
  if (group.workStartDate) {
    const startDate = group.workStartDate.replace(/[^0-9]/g, '');
    if (startDate.length >= 8) {
      items.push({ icon: 'mdi-calendar-start', color: '#6b7280', text: `입사일: ${startDate.slice(0, 4)}-${startDate.slice(4, 6)}-${startDate.slice(6, 8)}` });
    }
  }
  
  if (group.isBoss) {
    items.push({ icon: 'mdi-account-star', color: '#10b981', text: '대표자' });
  }
  
  return items;
};

// 제한사항 아이템 생성 (WageEmployeeModal용)
const getRestrictionItems = (group: GroupedMember, groupIndex: number) => {
  const items: { icon: string; color: string; text: string }[] = [];
  const age = calculateAge(group.birth, props.yearMonth || '');
  const totalHours = getTotalSugaHours(group, groupIndex);
  const isFamilyOnly = isAllFamilyCaregiver(group);
  
  if (age >= 65) {
    items.push({ icon: 'mdi-alert', color: '#f59e0b', text: '65세 이상 - 고용보험 납부의무 없음' });
  }
  if (age >= 60) {
    items.push({ icon: 'mdi-alert', color: '#f59e0b', text: '60세 이상 - 국민연금 납부의무 없음' });
  }
  if (isFamilyOnly && totalHours < 60) {
    items.push({ icon: 'mdi-alert', color: '#f59e0b', text: '가족요양 60시간 미만 - 4대보험 가입불가' });
  }
  if (group.isBoss) {
    items.push({ icon: 'mdi-alert', color: '#f59e0b', text: '대표자 - 고용보험/퇴직금 적용불가' });
  }
  
  return items;
};

// 모든 설정 초기화
const handleResetAllSettings = () => {
  groupedMemberData.value.forEach((group, groupIndex) => {
    const settings = settingsData.value[groupIndex];
    if (!settings) return;
    
    // 모든 시급 초기화
    group.patients.forEach((patient) => {
      const sugaKey = getSugaKey(patient);
      if (settings.timePays[patient.patientCode]) {
        settings.timePays[patient.patientCode][sugaKey] = '';
      }
    });
    
    // 모든 체크박스 해제
    settings.applyNationalPension = false;
    settings.yeonPay = '';
    settings.applyHealthInsurance = false;
    settings.applyEmploymentInsurance = false;
    settings.applyUnemployment = false;
    settings.applyRetirement = false;
    settings.applyHoliday = false;
    settings.applyOvertime = false;
    settings.applyMeal = false;
    settings.applyLongServicePay = false;
    settings.longServicePay = '';
    settings.applyEtcAllowance = false;
    settings.etcAllowance = '';
    settings.applyBoninPay = false;
    settings.boninPay = '';
    settings.applyEmpEtc = false;
    settings.empEtc = '';
    
    // 수가시간 수동 조정 초기화
    settings.customSugaHours = {};
    settings.sugaHoursChanged = false;
  });
  
  checkUnsavedChanges();
  store.commit('showSnackbar', { text: '⚠️ 모든 급여 설정이 초기화되었습니다. 저장하지 않으면 적용되지 않습니다.', color: 'warning' });
};

// 모든 과거 설정 불러오기
const handleApplyAllPreviousSettings = (data: { allData: Array<{ lebYm: string; data: any[] }>; recentData: { lebYm: string; data: any[] } }) => {
  const { allData, recentData } = data;
  
  if ((!allData || allData.length === 0) && !recentData) {
    store.commit('showSnackbar', { text: '과거 데이터가 없습니다.', color: 'warning' });
    return;
  }
  
  let appliedCount = 0;
  let timePayAppliedCount = 0;
  
  // 현재 데이터의 각 요양보호사에 대해
  groupedMemberData.value.forEach((group, groupIndex) => {
    const caregiverName = group.name;
    const caregiverBirth = group.birth;
    let foundAnyTimePay = false;
    
    // 시간당 임금: 여러 달 데이터에서 찾기 (최신순)
    // 각 수급자별로 독립적으로 시급 찾기 (모든 월 데이터 순회)
    if (allData && allData.length > 0) {
      group.patients.forEach((patient) => {
        // 270분초과의 경우 수가시간별 키 사용
        const sugaKey = getSugaKey(patient);
        
        // 이미 시급이 설정되어 있으면 스킵
        const currentTimePay = settingsData.value[groupIndex]?.timePays?.[patient.patientCode]?.[sugaKey];
        if (currentTimePay && parseFloat(String(currentTimePay).replace(/[^\d]/g, '')) > 0) {
          return;
        }
        
        // 각 월 데이터에서 해당 수급자의 시급 찾기 (최신순)
        for (const monthData of allData) {
          const matchingPrevious = monthData.data.find((item: any) =>
            item.caregiver_name === caregiverName &&
            item.caregiver_birth === caregiverBirth &&
            item.leb_patient_code === patient.patientCode &&
            item.suga_code === patient.sugaCode &&
            item.time_pay
          );
          
          if (matchingPrevious && matchingPrevious.time_pay) {
            if (!settingsData.value[groupIndex].timePays[patient.patientCode]) {
              settingsData.value[groupIndex].timePays[patient.patientCode] = {};
            }
            const numericValue = parseFloat(String(matchingPrevious.time_pay).replace(/[^\d]/g, '')) || 0;
            if (numericValue > 0) {
              settingsData.value[groupIndex].timePays[patient.patientCode][sugaKey] = 
                new Intl.NumberFormat('ko-KR').format(numericValue);
              foundAnyTimePay = true;
              break; // 해당 수급자의 시급을 찾았으면 다음 수급자로
            }
          }
        }
        
        // 해당 수급자의 시급을 못 찾았으면, 같은 요양보호사의 다른 시급 사용 (fallback)
        if (!foundAnyTimePay) {
          for (const monthData of allData) {
            const anyPreviousTimePay = monthData.data.find((item: any) =>
              item.caregiver_name === caregiverName &&
              item.caregiver_birth === caregiverBirth &&
              item.time_pay
            );
            
            if (anyPreviousTimePay && anyPreviousTimePay.time_pay) {
              if (!settingsData.value[groupIndex].timePays[patient.patientCode]) {
                settingsData.value[groupIndex].timePays[patient.patientCode] = {};
              }
              const numericValue = parseFloat(String(anyPreviousTimePay.time_pay).replace(/[^\d]/g, '')) || 0;
              if (numericValue > 0) {
                settingsData.value[groupIndex].timePays[patient.patientCode][sugaKey] = 
                  new Intl.NumberFormat('ko-KR').format(numericValue);
                foundAnyTimePay = true;
                break;
              }
            }
          }
        }
      });
      
      if (foundAnyTimePay) {
        timePayAppliedCount++;
      }
    }
    
    // 수당 및 보험: 최근 1개월 데이터에서 적용
    if (recentData && recentData.data) {
      const recentCaregiver = recentData.data.find((item: any) =>
        item.caregiver_name === caregiverName && item.caregiver_birth === caregiverBirth
      );
      
      if (recentCaregiver) {
        // 국민연금 금액 포맷팅
        let yeonPay = recentCaregiver.lemi_yeon_pay || '';
        let applyNationalPension = false;
        if (yeonPay) {
          const numericValue = parseFloat(String(yeonPay).replace(/[^\d]/g, '')) || 0;
          if (numericValue > 0) {
            yeonPay = new Intl.NumberFormat('ko-KR').format(numericValue);
            applyNationalPension = true;
          }
        }
        settingsData.value[groupIndex].applyNationalPension = applyNationalPension;
        settingsData.value[groupIndex].yeonPay = yeonPay;
        
        // 건강보험, 고용보험, 퇴직금, 휴일수당, 연장수당, 식대
        settingsData.value[groupIndex].applyHealthInsurance = recentCaregiver.lemi_apply_gun === 'Y';
        settingsData.value[groupIndex].applyEmploymentInsurance = recentCaregiver.lemi_apply_go === 'Y';
        settingsData.value[groupIndex].applyRetirement = recentCaregiver.lemi_apply_out_pay === 'Y';
        settingsData.value[groupIndex].applyHoliday = recentCaregiver.lemi_apply_holiday_pay === 'Y';
        settingsData.value[groupIndex].applyOvertime = recentCaregiver.lemi_apply_overtime_pay === 'Y';
        settingsData.value[groupIndex].applyMeal = recentCaregiver.lemi_apply_lunch_pay === 'Y';
        
        // 실업급여 설정 (lemi_sil_pay에 값이 있으면 실업급여 적용)
        const silPay = recentCaregiver.lemi_sil_pay || '';
        const hasSilPay = silPay && parseFloat(String(silPay).replace(/[^\d]/g, '')) > 0;
        settingsData.value[groupIndex].applyUnemployment = 
          (recentCaregiver.lemi_apply_go === 'Y') || hasSilPay;
        
        // 장기근속수당 포맷팅 및 체크박스 설정
        let longServicePay = recentCaregiver.lemi_long_service_pay || '';
        let applyLongServicePay = false;
        if (longServicePay) {
          const numericValue = parseFloat(String(longServicePay).replace(/[^\d]/g, '')) || 0;
          if (numericValue > 0) {
            longServicePay = new Intl.NumberFormat('ko-KR').format(numericValue);
            applyLongServicePay = true;
          }
        }
        settingsData.value[groupIndex].applyLongServicePay = applyLongServicePay;
        settingsData.value[groupIndex].longServicePay = longServicePay;
        
        // 기타수당 포맷팅 및 체크박스 설정
        let etcAllowance = recentCaregiver.lemi_etc_allowance || '';
        let applyEtcAllowance = false;
        if (etcAllowance) {
          const numericValue = parseFloat(String(etcAllowance).replace(/[^\d]/g, '')) || 0;
          if (numericValue > 0) {
            etcAllowance = new Intl.NumberFormat('ko-KR').format(numericValue);
            applyEtcAllowance = true;
          }
        }
        settingsData.value[groupIndex].applyEtcAllowance = applyEtcAllowance;
        settingsData.value[groupIndex].etcAllowance = etcAllowance;
        
        // 본인부담금공제 포맷팅 및 체크박스 설정
        let boninPay = recentCaregiver.lemi_bonin_pay || '';
        let applyBoninPay = false;
        if (boninPay) {
          const numericValue = parseFloat(String(boninPay).replace(/[^\d]/g, '')) || 0;
          if (numericValue > 0) {
            boninPay = new Intl.NumberFormat('ko-KR').format(numericValue);
            applyBoninPay = true;
          }
        }
        settingsData.value[groupIndex].applyBoninPay = applyBoninPay;
        settingsData.value[groupIndex].boninPay = boninPay;
        
        // 기타공제 포맷팅 및 체크박스 설정
        let empEtc = recentCaregiver.lemi_emp_etc || '';
        let applyEmpEtc = false;
        if (empEtc) {
          const numericValue = parseFloat(String(empEtc).replace(/[^\d]/g, '')) || 0;
          if (numericValue > 0) {
            empEtc = new Intl.NumberFormat('ko-KR').format(numericValue);
            applyEmpEtc = true;
          }
        }
        settingsData.value[groupIndex].applyEmpEtc = applyEmpEtc;
        settingsData.value[groupIndex].empEtc = empEtc;
        
        appliedCount++;
      }
    }
  });
  
  // 변경사항 체크
  checkUnsavedChanges();
  
  // 결과 메시지
  let message = '';
  if (appliedCount > 0 && timePayAppliedCount > 0) {
    message = `${appliedCount}명의 과거 설정이 적용되었습니다. (시급: ${timePayAppliedCount}명)`;
  } else if (appliedCount > 0) {
    message = `${appliedCount}명의 과거 설정이 적용되었습니다.`;
  } else if (timePayAppliedCount > 0) {
    message = `${timePayAppliedCount}명의 시급이 적용되었습니다.`;
  } else {
    message = '적용할 과거 설정이 없습니다.';
  }
  
  store.commit('showSnackbar', { 
    text: message, 
    color: appliedCount > 0 || timePayAppliedCount > 0 ? 'success' : 'warning'
  });
};

// 연월 변경 시 데이터 다시 조회
watch(() => props.yearMonth, () => {
  if (props.yearMonth) {
    expandedTimePay.value.clear();
    settingsData.value = {};
    fetchMemberInfo();
  }
}, { immediate: true });

// 설정 변경 시 급여 재계산
watch(settingsData, () => {
  groupedMemberData.value.forEach((group, index) => {
    payrollDetails.value[index] = calculatePayrollDetails(group, index);
  });
}, { deep: true });

watch(groupedMemberData, () => {
  initializeSettingsData();
}, { deep: true });

onMounted(() => {
  if (props.yearMonth) {
    fetchMemberInfo();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_icon, {
          size: "32",
          color: "#1e3a8a"
        }, {
          default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
            _createTextVNode("mdi-cog", -1)
          ]))]),
          _: 1
        })
      ]),
      _cache[31] || (_cache[31] = _createElementVNode("div", { class: "panel-title-section" }, [
        _createElementVNode("h2", { class: "panel-title" }, "급여 상세 설정하기")
      ], -1)),
      _createElementVNode("div", _hoisted_4, [
        (isConfirmed.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn-header-action",
              onClick: handleRelease,
              disabled: isConfirming.value
            }, [
              (isConfirming.value)
                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                    key: 0,
                    indeterminate: "",
                    size: "16",
                    width: "2",
                    color: "#f59e0b",
                    class: "mr-1"
                  }))
                : (_openBlock(), _createBlock(_component_v_icon, {
                    key: 1,
                    size: "18"
                  }, {
                    default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                      _createTextVNode("mdi-lock-open-variant", -1)
                    ]))]),
                    _: 1
                  })),
              _cache[28] || (_cache[28] = _createElementVNode("span", null, "확정 해제", -1))
            ], 8, _hoisted_5))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn-header-action primary confirm-emphasis",
              onClick: handleConfirm,
              disabled: !stepCompleted.value || isConfirming.value || hasUnsavedChanges.value
            }, [
              (isConfirming.value)
                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                    key: 0,
                    indeterminate: "",
                    size: "16",
                    width: "2",
                    color: "#fff",
                    class: "mr-1"
                  }))
                : (_openBlock(), _createBlock(_component_v_icon, {
                    key: 1,
                    size: "18"
                  }, {
                    default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                      _createTextVNode("mdi-lock-check", -1)
                    ]))]),
                    _: 1
                  })),
              _cache[30] || (_cache[30] = _createElementVNode("span", null, "급여 설정 확정하기", -1))
            ], 8, _hoisted_6))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (isConfirmed.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_v_icon, {
              size: "20",
              color: "#f59e0b"
            }, {
              default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                _createTextVNode("mdi-lock", -1)
              ]))]),
              _: 1
            }),
            _cache[35] || (_cache[35] = _createElementVNode("span", { class: "notice-text" }, [
              _createTextVNode(" 급여 설정이 "),
              _createElementVNode("strong", null, "확정"),
              _createTextVNode("되어 수정할 수 없습니다. 수정하려면 상단의 "),
              _createElementVNode("strong", null, "확정 해제"),
              _createTextVNode(" 버튼을 눌러주세요. ")
            ], -1)),
            _createElementVNode("button", {
              class: "btn-release-inline",
              onClick: handleRelease,
              disabled: isConfirming.value
            }, [
              _createVNode(_component_v_icon, { size: "16" }, {
                default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                  _createTextVNode("mdi-lock-open-variant", -1)
                ]))]),
                _: 1
              }),
              _cache[34] || (_cache[34] = _createTextVNode(" 확정 해제 ", -1))
            ], 8, _hoisted_9)
          ]))
        : _createCommentVNode("", true),
      (showWholeVersion.value && memberInfoData.value.length > 0)
        ? (_openBlock(), _createBlock(WageWholeVersion, {
            key: 1,
            modelValue: showWholeVersion.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showWholeVersion).value = $event)),
            "grouped-member-data": groupedMemberData.value,
            "payroll-details": payrollDetails.value,
            "settings-data": settingsData.value,
            "year-month": __props.yearMonth,
            onClose: _cache[1] || (_cache[1] = ($event: any) => (showWholeVersion.value = false))
          }, null, 8, ["modelValue", "grouped-member-data", "payroll-details", "settings-data", "year-month"]))
        : _createCommentVNode("", true),
      (memberInfoData.value.length > 0)
        ? (_openBlock(), _createBlock(WageEmployeeList, {
            key: 2,
            employees: groupedMemberData.value,
            "payroll-details": payrollDetails.value,
            "settings-data": settingsData.value,
            services: individualServices.value,
            "show-whole-version": showWholeVersion.value,
            "has-unsaved-changes": hasUnsavedChanges.value,
            "is-saving": isSaving.value,
            "is-confirmed": isConfirmed.value,
            onOpenDetail: openEmployeeModal,
            onToggleWholeVersion: _cache[2] || (_cache[2] = ($event: any) => (showWholeVersion.value = !showWholeVersion.value)),
            onOpenSettings: _cache[3] || (_cache[3] = ($event: any) => (showSetModal.value = true)),
            onSaveAll: saveSettings
          }, null, 8, ["employees", "payroll-details", "settings-data", "services", "show-whole-version", "has-unsaved-changes", "is-saving", "is-confirmed"]))
        : _createCommentVNode("", true),
      _createVNode(WageEmployeeModal, {
        modelValue: showEmployeeModal.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showEmployeeModal).value = $event)),
        employee: selectedEmployee.value,
        employees: groupedMemberData.value,
        "group-index": selectedEmployeeIndex.value,
        "year-month": __props.yearMonth,
        "sisul-code": _unref(store).state.user?.m_sisul_code,
        "payroll-detail": payrollDetails.value[selectedEmployeeIndex.value],
        settings: settingsData.value[selectedEmployeeIndex.value],
        services: individualServices.value[selectedEmployeeIndex.value] || [],
        "weekly-services": combinedWeeklyServices.value[selectedEmployeeIndex.value] || [],
        "severe-care-items": getSevereCareAdditionForGroup(selectedEmployeeIndex.value),
        "severe-care-daily": severeCareAdditionDaily.value[selectedEmployeeIndex.value] || [],
        holidays: holidaysData.value,
        "is-confirmed": isConfirmed.value,
        "center-profit": selectedEmployee.value ? calculateCenterProfit(selectedEmployee.value, selectedEmployeeIndex.value) : 0,
        "cumulative-retirement": selectedEmployee.value?.name ? cumulativeRetirement.value[selectedEmployee.value.name] || 0 : 0,
        "employee-info-items": selectedEmployee.value ? getEmployeeInfoItems(selectedEmployee.value, selectedEmployeeIndex.value) : [],
        "restriction-items": selectedEmployee.value ? getRestrictionItems(selectedEmployee.value, selectedEmployeeIndex.value) : [],
        "has-changes": hasUnsavedChanges.value,
        "is-saving": isSaving.value,
        "onUpdate:groupIndex": _cache[5] || (_cache[5] = ($event: any) => {selectedEmployeeIndex.value = $event; selectedEmployee.value = groupedMemberData.value[$event]}),
        onUpdateSetting: handleUpdateSetting,
        onUpdateTimepay: handleUpdateTimepay,
        onOpenBoninModal: openBoninPayModal,
        onOpenEmploymentModal: openEmploymentModal,
        onOpenSugaHoursModal: openSugaHoursModalFromModal,
        onResetSettings: resetSingleCaregiverSettings,
        onSaveSettings: saveSettings,
        onLoadPreviousSettings: loadPreviousSettings,
        onStartDateUpdated: handleStartDateUpdated
      }, null, 8, ["modelValue", "employee", "employees", "group-index", "year-month", "sisul-code", "payroll-detail", "settings", "services", "weekly-services", "severe-care-items", "severe-care-daily", "holidays", "is-confirmed", "center-profit", "cumulative-retirement", "employee-info-items", "restriction-items", "has-changes", "is-saving"]),
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("table", _hoisted_12, [
                _cache[119] || (_cache[119] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "성명"),
                    _createElementVNode("th", { class: "time-pay-header" }, "시급"),
                    _createElementVNode("th", null, "총수가"),
                    _createElementVNode("th", null, "월급여"),
                    _createElementVNode("th", null, "기관수익"),
                    _createElementVNode("th", { class: "input-header" }, "국민연금"),
                    _createElementVNode("th", { class: "checkbox-header" }, [
                      _createTextVNode("건강보험"),
                      _createElementVNode("br"),
                      _createTextVNode("적용")
                    ]),
                    _createElementVNode("th", { class: "checkbox-header" }, [
                      _createTextVNode("고용보험"),
                      _createElementVNode("br"),
                      _createTextVNode("적용")
                    ]),
                    _createElementVNode("th", { class: "checkbox-header" }, [
                      _createTextVNode("퇴직금"),
                      _createElementVNode("br"),
                      _createTextVNode("적립")
                    ]),
                    _createElementVNode("th", { class: "checkbox-header" }, [
                      _createTextVNode("휴일수당"),
                      _createElementVNode("br"),
                      _createTextVNode("지급")
                    ]),
                    _createElementVNode("th", { class: "checkbox-header" }, [
                      _createTextVNode("연장수당"),
                      _createElementVNode("br"),
                      _createTextVNode("지급")
                    ]),
                    _createElementVNode("th", { class: "checkbox-header" }, [
                      _createTextVNode("식대"),
                      _createElementVNode("br"),
                      _createTextVNode("지급")
                    ]),
                    _createElementVNode("th", { class: "input-header" }, [
                      _createTextVNode("장기근속"),
                      _createElementVNode("br"),
                      _createTextVNode("수당")
                    ]),
                    _createElementVNode("th", { class: "input-header" }, [
                      _createTextVNode("본인부담금"),
                      _createElementVNode("br"),
                      _createTextVNode("공제")
                    ]),
                    _createElementVNode("th", { class: "input-header" }, "기타공제")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedMemberData.value, (group, groupIndex) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: groupIndex }, [
                      (settingsData.value[groupIndex])
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                            _createElementVNode("td", _hoisted_14, _toDisplayString(group.name || '-'), 1),
                            _createElementVNode("td", {
                              class: _normalizeClass(["total-cell time-pay-cell clickable", { 
                    'expanded': isTimePayExpanded(groupIndex),
                    'warning': hasMissingTimePay(groupIndex)
                  }]),
                              onClick: ($event: any) => (toggleTimePay(groupIndex))
                            }, [
                              _createElementVNode("span", null, _toDisplayString(getAverageTimePay(group)), 1),
                              (hasMissingTimePay(groupIndex))
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "time-pay-warning",
                                    onClick: _withModifiers(($event: any) => (toggleTimePay(groupIndex)), ["stop"])
                                  }, [
                                    _createVNode(_component_v_icon, {
                                      size: "16",
                                      color: "#ef4444"
                                    }, {
                                      default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                                        _createTextVNode("mdi-alert", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ], 8, _hoisted_16))
                                : _createCommentVNode("", true)
                            ], 10, _hoisted_15),
                            _createElementVNode("td", _hoisted_17, _toDisplayString(formatMoney(group.totalSugaMoney || 0)) + "원", 1),
                            _createElementVNode("td", _hoisted_18, _toDisplayString(payrollDetails.value[groupIndex] ? formatMoney(payrollDetails.value[groupIndex].basicTotal) : '0') + "원", 1),
                            _createElementVNode("td", {
                              class: _normalizeClass(["total-cell number-cell profit-cell", {
                  'positive': payrollDetails.value[groupIndex] && calculateCenterProfit(group, groupIndex) > 0,
                  'negative': payrollDetails.value[groupIndex] && calculateCenterProfit(group, groupIndex) < 0
                }])
                            }, _toDisplayString(payrollDetails.value[groupIndex] ? formatMoney(calculateCenterProfit(group, groupIndex)) : '0') + "원 ", 3),
                            _createElementVNode("td", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": ($event: any) => ((settingsData.value[groupIndex].applyNationalPension) = $event),
                                  onChange: ($event: any) => (onNationalPensionToggle(groupIndex)),
                                  disabled: isConfirmed.value,
                                  class: "pension-checkbox"
                                }, null, 40, _hoisted_21), [
                                  [_vModelCheckbox, settingsData.value[groupIndex].applyNationalPension]
                                ]),
                                (settingsData.value[groupIndex].applyNationalPension)
                                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 0,
                                      type: "text",
                                      "onUpdate:modelValue": ($event: any) => ((settingsData.value[groupIndex].yeonPay) = $event),
                                      onInput: ($event: any) => (onYeonPayInput($event, groupIndex)),
                                      onBlur: ($event: any) => (onYeonPayBlur($event, groupIndex)),
                                      onFocus: ($event: any) => (onYeonPayFocus($event, groupIndex)),
                                      class: "long-service-input",
                                      placeholder: "0",
                                      disabled: isConfirmed.value
                                    }, null, 40, _hoisted_22)), [
                                      [_vModelText, settingsData.value[groupIndex].yeonPay]
                                    ])
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_23, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": ($event: any) => ((settingsData.value[groupIndex].applyHealthInsurance) = $event),
                                onChange: checkUnsavedChanges,
                                disabled: isConfirmed.value
                              }, null, 40, _hoisted_24), [
                                [_vModelCheckbox, settingsData.value[groupIndex].applyHealthInsurance]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_25, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: settingsData.value[groupIndex].applyEmploymentInsurance,
                                onClick: _withModifiers(($event: any) => (openEmploymentModal(groupIndex)), ["prevent"]),
                                disabled: isConfirmed.value
                              }, null, 8, _hoisted_26),
                              (!settingsData.value[groupIndex].applyEmploymentInsurance && settingsData.value[groupIndex].applyUnemployment)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_27, "실"))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_28, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": ($event: any) => ((settingsData.value[groupIndex].applyRetirement) = $event),
                                onChange: checkUnsavedChanges,
                                disabled: isConfirmed.value
                              }, null, 40, _hoisted_29), [
                                [_vModelCheckbox, settingsData.value[groupIndex].applyRetirement]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_30, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": ($event: any) => ((settingsData.value[groupIndex].applyHoliday) = $event),
                                onChange: checkUnsavedChanges,
                                disabled: isConfirmed.value
                              }, null, 40, _hoisted_31), [
                                [_vModelCheckbox, settingsData.value[groupIndex].applyHoliday]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_32, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": ($event: any) => ((settingsData.value[groupIndex].applyOvertime) = $event),
                                onChange: checkUnsavedChanges,
                                disabled: isConfirmed.value
                              }, null, 40, _hoisted_33), [
                                [_vModelCheckbox, settingsData.value[groupIndex].applyOvertime]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_34, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": ($event: any) => ((settingsData.value[groupIndex].applyMeal) = $event),
                                onChange: checkUnsavedChanges,
                                disabled: isConfirmed.value
                              }, null, 40, _hoisted_35), [
                                [_vModelCheckbox, settingsData.value[groupIndex].applyMeal]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": ($event: any) => ((settingsData.value[groupIndex].applyLongServicePay) = $event),
                                  onChange: ($event: any) => (onLongServicePayToggle(groupIndex)),
                                  disabled: isConfirmed.value,
                                  class: "pension-checkbox"
                                }, null, 40, _hoisted_38), [
                                  [_vModelCheckbox, settingsData.value[groupIndex].applyLongServicePay]
                                ]),
                                (settingsData.value[groupIndex].applyLongServicePay)
                                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 0,
                                      type: "text",
                                      "onUpdate:modelValue": ($event: any) => ((settingsData.value[groupIndex].longServicePay) = $event),
                                      onInput: ($event: any) => (onLongServiceInput($event, groupIndex)),
                                      onBlur: ($event: any) => (onLongServiceBlur($event, groupIndex)),
                                      onFocus: ($event: any) => (onLongServiceFocus($event, groupIndex)),
                                      class: "long-service-input",
                                      placeholder: "0",
                                      disabled: isConfirmed.value
                                    }, null, 40, _hoisted_39)), [
                                      [_vModelText, settingsData.value[groupIndex].longServicePay]
                                    ])
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": ($event: any) => ((settingsData.value[groupIndex].applyBoninPay) = $event),
                                  onChange: ($event: any) => (onBoninPayToggle(groupIndex)),
                                  disabled: isConfirmed.value,
                                  class: "pension-checkbox"
                                }, null, 40, _hoisted_42), [
                                  [_vModelCheckbox, settingsData.value[groupIndex].applyBoninPay]
                                ]),
                                (settingsData.value[groupIndex].applyBoninPay)
                                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 0,
                                      type: "text",
                                      "onUpdate:modelValue": ($event: any) => ((settingsData.value[groupIndex].boninPay) = $event),
                                      onInput: ($event: any) => (onBoninPayInput($event, groupIndex)),
                                      onBlur: ($event: any) => (onBoninPayBlur($event, groupIndex)),
                                      onFocus: ($event: any) => (onBoninPayFocus($event, groupIndex)),
                                      onClick: ($event: any) => (openBoninPayModal(groupIndex)),
                                      class: "long-service-input",
                                      placeholder: "클릭",
                                      disabled: isConfirmed.value,
                                      readonly: ""
                                    }, null, 40, _hoisted_43)), [
                                      [_vModelText, settingsData.value[groupIndex].boninPay]
                                    ])
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_44, [
                              _createElementVNode("div", _hoisted_45, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": ($event: any) => ((settingsData.value[groupIndex].applyEmpEtc) = $event),
                                  onChange: ($event: any) => (onEmpEtcToggle(groupIndex)),
                                  disabled: isConfirmed.value,
                                  class: "pension-checkbox"
                                }, null, 40, _hoisted_46), [
                                  [_vModelCheckbox, settingsData.value[groupIndex].applyEmpEtc]
                                ]),
                                (settingsData.value[groupIndex].applyEmpEtc)
                                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 0,
                                      type: "text",
                                      "onUpdate:modelValue": ($event: any) => ((settingsData.value[groupIndex].empEtc) = $event),
                                      onInput: ($event: any) => (onEmpEtcInput($event, groupIndex)),
                                      onBlur: ($event: any) => (onEmpEtcBlur($event, groupIndex)),
                                      onFocus: ($event: any) => (onEmpEtcFocus($event, groupIndex)),
                                      class: "long-service-input",
                                      placeholder: "0",
                                      disabled: isConfirmed.value
                                    }, null, 40, _hoisted_47)), [
                                      [_vModelText, settingsData.value[groupIndex].empEtc]
                                    ])
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (settingsData.value[groupIndex] && isTimePayExpanded(groupIndex))
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_48, [
                            _createElementVNode("td", _hoisted_49, [
                              _createElementVNode("div", _hoisted_50, [
                                _createElementVNode("div", _hoisted_51, [
                                  _createElementVNode("div", _hoisted_52, [
                                    _createElementVNode("div", _hoisted_53, [
                                      _createVNode(_component_v_icon, {
                                        size: "18",
                                        color: "#1e3a8a"
                                      }, {
                                        default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                                          _createTextVNode("mdi-account-heart", -1)
                                        ]))]),
                                        _: 1
                                      }),
                                      _cache[40] || (_cache[40] = _createElementVNode("span", null, "수급자별 시급 설정", -1)),
                                      _createElementVNode("button", {
                                        class: "btn-save-single",
                                        onClick: ($event: any) => (saveSingleCaregiver(groupIndex)),
                                        disabled: isSaving.value || isConfirmed.value
                                      }, [
                                        (isSaving.value)
                                          ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                              key: 0,
                                              indeterminate: "",
                                              size: "12",
                                              width: "2",
                                              color: "#1e3a8a"
                                            }))
                                          : (_openBlock(), _createBlock(_component_v_icon, {
                                              key: 1,
                                              size: "14"
                                            }, {
                                              default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                                                _createTextVNode("mdi-content-save", -1)
                                              ]))]),
                                              _: 1
                                            })),
                                        _cache[39] || (_cache[39] = _createElementVNode("span", null, "저장", -1))
                                      ], 8, _hoisted_54)
                                    ]),
                                    _createElementVNode("div", _hoisted_55, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.patients, (patient, pIdx) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: pIdx,
                                          class: "time-pay-item"
                                        }, [
                                          _createElementVNode("div", _hoisted_56, [
                                            _createElementVNode("span", _hoisted_57, _toDisplayString(patient.patientName), 1),
                                            _createElementVNode("span", _hoisted_58, _toDisplayString(getDisplaySugaName(patient)), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_59, [
                                            _createElementVNode("span", _hoisted_60, _toDisplayString(patient.serviceDays) + "회", 1),
                                            _createElementVNode("div", {
                                              class: _normalizeClass(["hours-stepper", { 'modified': isSugaHoursManuallyChanged(groupIndex, patient.patientCode, getSugaKey(patient)) }])
                                            }, [
                                              _createElementVNode("button", {
                                                class: "step-btn",
                                                onClick: _withModifiers(($event: any) => (adjustSugaHoursInline(groupIndex, patient, -0.5)), ["stop"]),
                                                disabled: isConfirmed.value || getEffectiveSugaHours(groupIndex, patient) <= 0.5
                                              }, "−", 8, _hoisted_61),
                                              _createElementVNode("span", _hoisted_62, _toDisplayString(formatSugaHours(getEffectiveSugaHours(groupIndex, patient))), 1),
                                              _createElementVNode("button", {
                                                class: "step-btn",
                                                onClick: _withModifiers(($event: any) => (adjustSugaHoursInline(groupIndex, patient, 0.5)), ["stop"]),
                                                disabled: isConfirmed.value || getEffectiveSugaHours(groupIndex, patient) >= 24
                                              }, "+", 8, _hoisted_63),
                                              (isSugaHoursManuallyChanged(groupIndex, patient.patientCode, getSugaKey(patient)))
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    class: "reset-btn",
                                                    onClick: _withModifiers(($event: any) => (resetToAutoCalculation(groupIndex, patient)), ["stop"]),
                                                    disabled: isConfirmed.value,
                                                    title: "자동계산으로 복원"
                                                  }, "↺", 8, _hoisted_64))
                                                : _createCommentVNode("", true)
                                            ], 2)
                                          ]),
                                          _createElementVNode("div", _hoisted_65, [
                                            _createElementVNode("input", {
                                              type: "text",
                                              value: settingsData.value[groupIndex]?.timePays?.[patient.patientCode]?.[getSugaKey(patient)] || '',
                                              onInput: ($event: any) => (onTimePayInput($event, groupIndex, patient.patientCode, getSugaKey(patient))),
                                              onBlur: ($event: any) => (onTimePayBlur($event, groupIndex, patient.patientCode, getSugaKey(patient))),
                                              onFocus: ($event: any) => (onTimePayFocus($event, groupIndex, patient.patientCode, getSugaKey(patient))),
                                              class: _normalizeClass(["wage-input", { 'empty': !settingsData.value[groupIndex]?.timePays?.[patient.patientCode]?.[getSugaKey(patient)] }]),
                                              placeholder: "시급",
                                              disabled: isConfirmed.value
                                            }, null, 42, _hoisted_66),
                                            _cache[41] || (_cache[41] = _createElementVNode("span", { class: "suffix" }, "원", -1))
                                          ])
                                        ]))
                                      }), 128))
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_67, [
                                    _createElementVNode("div", _hoisted_68, [
                                      _createVNode(_component_v_icon, {
                                        size: "18",
                                        color: "#1e3a8a"
                                      }, {
                                        default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                                          _createTextVNode("mdi-account-cog", -1)
                                        ]))]),
                                        _: 1
                                      }),
                                      _cache[43] || (_cache[43] = _createElementVNode("span", null, "급여 상세 정보", -1))
                                    ]),
                                    _createElementVNode("div", _hoisted_69, [
                                      _createElementVNode("div", _hoisted_70, [
                                        _createElementVNode("div", _hoisted_71, [
                                          _createVNode(_component_v_icon, {
                                            size: "14",
                                            color: "#6b7280"
                                          }, {
                                            default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                                              _createTextVNode("mdi-clock-outline", -1)
                                            ]))]),
                                            _: 1
                                          }),
                                          _createElementVNode("span", null, _toDisplayString(formatSugaHours(getTotalSugaHours(group, groupIndex))), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_72, [
                                          _createVNode(_component_v_icon, {
                                            size: "14",
                                            color: "#6b7280"
                                          }, {
                                            default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                                              _createTextVNode("mdi-counter", -1)
                                            ]))]),
                                            _: 1
                                          }),
                                          _createElementVNode("span", null, _toDisplayString(getTotalServiceDays(group)) + "회", 1)
                                        ]),
                                        (getEmployeeFeatures(group, groupIndex).restrictions.length > 0)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: "quick-info-item warning clickable",
                                              onClick: ($event: any) => (openRestrictionsTab(groupIndex))
                                            }, [
                                              _createVNode(_component_v_icon, {
                                                size: "14",
                                                color: "#f59e0b"
                                              }, {
                                                default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                                                  _createTextVNode("mdi-alert", -1)
                                                ]))]),
                                                _: 1
                                              }),
                                              _createElementVNode("span", null, "제한사항 " + _toDisplayString(getEmployeeFeatures(group, groupIndex).restrictions.length) + "개", 1)
                                            ], 8, _hoisted_73))
                                          : _createCommentVNode("", true),
                                        (group.isBoss)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                              _createVNode(_component_v_icon, {
                                                size: "14",
                                                color: "#10b981"
                                              }, {
                                                default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                                                  _createTextVNode("mdi-account-star", -1)
                                                ]))]),
                                                _: 1
                                              }),
                                              _cache[48] || (_cache[48] = _createElementVNode("span", null, "대표자", -1))
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("button", {
                                          class: _normalizeClass(["toggle-detail-btn", { 'active': isEmployeeInfoExpanded(groupIndex) }]),
                                          onClick: ($event: any) => (toggleEmployeeInfo(groupIndex))
                                        }, [
                                          _createElementVNode("span", null, _toDisplayString(isEmployeeInfoExpanded(groupIndex) ? '급여 상세 정보 접기' : '급여 상세 정보 보기'), 1),
                                          _createVNode(_component_v_icon, { size: "16" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(isEmployeeInfoExpanded(groupIndex) ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ], 10, _hoisted_75)
                                      ]),
                                      _createVNode(_Transition, { name: "expand" }, {
                                        default: _withCtx(() => [
                                          (isEmployeeInfoExpanded(groupIndex))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                                _createVNode(_component_v_tabs, {
                                                  modelValue: detailTab.value[groupIndex],
                                                  "onUpdate:modelValue": ($event: any) => ((detailTab.value[groupIndex]) = $event),
                                                  class: "detail-tabs",
                                                  density: "compact"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_tab, { value: "payroll" }, {
                                                      default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                                                        _createTextVNode("급여 상세", -1)
                                                      ]))]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_tab, { value: "info" }, {
                                                      default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                                                        _createTextVNode("직원 정보", -1)
                                                      ]))]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_tab, { value: "services" }, {
                                                      default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                                                        _createTextVNode("서비스 내역", -1)
                                                      ]))]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_tab, { value: "weekly" }, {
                                                      default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                                                        _createTextVNode("주차별 근무", -1)
                                                      ]))]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }, 8, ["modelValue", "onUpdate:modelValue"]),
                                                _createVNode(_component_v_window, {
                                                  modelValue: detailTab.value[groupIndex],
                                                  "onUpdate:modelValue": ($event: any) => ((detailTab.value[groupIndex]) = $event)
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_window_item, { value: "payroll" }, {
                                                      default: _withCtx(() => [
                                                        (payrollDetails.value[groupIndex])
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                                              _createElementVNode("div", _hoisted_78, [
                                                                _createElementVNode("div", _hoisted_79, [
                                                                  _createVNode(_component_v_icon, {
                                                                    size: "14",
                                                                    color: "#1e3a8a"
                                                                  }, {
                                                                    default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                                                                      _createTextVNode("mdi-cash-multiple", -1)
                                                                    ]))]),
                                                                    _: 1
                                                                  }),
                                                                  _cache[54] || (_cache[54] = _createElementVNode("span", null, "급여 내역", -1))
                                                                ]),
                                                                _createElementVNode("div", _hoisted_80, [
                                                                  (payrollDetails.value[groupIndex].isFamilyOnlyCaregiver)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                                                        _cache[55] || (_cache[55] = _createElementVNode("span", { class: "label" }, "기본급 (주휴·연차 포함)", -1)),
                                                                        _createElementVNode("span", _hoisted_82, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].basicTotal)) + "원", 1)
                                                                      ]))
                                                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                        _createElementVNode("div", _hoisted_83, [
                                                                          _cache[56] || (_cache[56] = _createElementVNode("span", { class: "label" }, "기본급", -1)),
                                                                          _createElementVNode("span", _hoisted_84, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].basicPay)) + "원", 1)
                                                                        ]),
                                                                        _createElementVNode("div", _hoisted_85, [
                                                                          _cache[57] || (_cache[57] = _createElementVNode("span", { class: "label" }, "주휴수당", -1)),
                                                                          _createElementVNode("span", _hoisted_86, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].holidayPay)) + "원", 1)
                                                                        ]),
                                                                        _createElementVNode("div", _hoisted_87, [
                                                                          _cache[58] || (_cache[58] = _createElementVNode("span", { class: "label" }, "연차수당", -1)),
                                                                          _createElementVNode("span", _hoisted_88, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].vacationPay)) + "원", 1)
                                                                        ]),
                                                                        _createElementVNode("div", _hoisted_89, [
                                                                          _cache[59] || (_cache[59] = _createElementVNode("span", { class: "label" }, "식대", -1)),
                                                                          _createElementVNode("span", _hoisted_90, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].mealAllowance)) + "원", 1)
                                                                        ])
                                                                      ], 64)),
                                                                  _createElementVNode("div", _hoisted_91, [
                                                                    _cache[60] || (_cache[60] = _createElementVNode("span", { class: "label" }, "급여 소계", -1)),
                                                                    _createElementVNode("span", _hoisted_92, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].basicTotal)) + "원", 1)
                                                                  ])
                                                                ])
                                                              ]),
                                                              _createElementVNode("div", _hoisted_93, [
                                                                _createElementVNode("div", _hoisted_94, [
                                                                  _createElementVNode("div", _hoisted_95, [
                                                                    _createVNode(_component_v_icon, {
                                                                      size: "14",
                                                                      color: "#059669"
                                                                    }, {
                                                                      default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                                                                        _createTextVNode("mdi-gift", -1)
                                                                      ]))]),
                                                                      _: 1
                                                                    }),
                                                                    _cache[62] || (_cache[62] = _createElementVNode("span", null, "수당", -1))
                                                                  ]),
                                                                  _createElementVNode("div", _hoisted_96, [
                                                                    _createElementVNode("div", _hoisted_97, [
                                                                      _cache[63] || (_cache[63] = _createElementVNode("span", { class: "label" }, "장기근속수당", -1)),
                                                                      _createElementVNode("span", _hoisted_98, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].longServicePay)) + "원", 1)
                                                                    ]),
                                                                    _createElementVNode("div", _hoisted_99, [
                                                                      _cache[64] || (_cache[64] = _createElementVNode("span", { class: "label" }, "중증수급자가산", -1)),
                                                                      _createElementVNode("span", _hoisted_100, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].severeCareAddition)) + "원", 1)
                                                                    ]),
                                                                    _createElementVNode("div", _hoisted_101, [
                                                                      _cache[65] || (_cache[65] = _createElementVNode("span", { class: "label" }, "휴일수당", -1)),
                                                                      _createElementVNode("span", _hoisted_102, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].holidayAllowance)) + "원", 1)
                                                                    ]),
                                                                    _createElementVNode("div", _hoisted_103, [
                                                                      _cache[66] || (_cache[66] = _createElementVNode("span", { class: "label" }, "연장수당", -1)),
                                                                      _createElementVNode("span", _hoisted_104, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].overtimeAllowance)) + "원", 1)
                                                                    ]),
                                                                    _createElementVNode("div", _hoisted_105, [
                                                                      _cache[67] || (_cache[67] = _createElementVNode("span", { class: "label" }, "수당 합계", -1)),
                                                                      _createElementVNode("span", _hoisted_106, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].longServicePay + payrollDetails.value[groupIndex].severeCareAddition + payrollDetails.value[groupIndex].holidayAllowance + payrollDetails.value[groupIndex].overtimeAllowance)) + "원", 1)
                                                                    ])
                                                                  ])
                                                                ])
                                                              ]),
                                                              _createElementVNode("div", _hoisted_107, [
                                                                (payrollDetails.value[groupIndex].nonTaxableAmount > 0)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                                                                      _createElementVNode("div", _hoisted_109, [
                                                                        _createVNode(_component_v_icon, {
                                                                          size: "14",
                                                                          color: "#10b981"
                                                                        }, {
                                                                          default: _withCtx(() => [...(_cache[68] || (_cache[68] = [
                                                                            _createTextVNode("mdi-piggy-bank", -1)
                                                                          ]))]),
                                                                          _: 1
                                                                        }),
                                                                        _cache[69] || (_cache[69] = _createElementVNode("span", null, "비과세 효과", -1))
                                                                      ]),
                                                                      _createElementVNode("div", _hoisted_110, [
                                                                        _createElementVNode("div", _hoisted_111, [
                                                                          _cache[70] || (_cache[70] = _createElementVNode("span", { class: "label" }, "비과세 금액", -1)),
                                                                          _createElementVNode("span", _hoisted_112, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].nonTaxableAmount)) + "원", 1)
                                                                        ]),
                                                                        _createElementVNode("div", _hoisted_113, [
                                                                          _createElementVNode("span", _hoisted_114, [
                                                                            _createVNode(_component_v_icon, {
                                                                              size: "12",
                                                                              color: "#3b82f6"
                                                                            }, {
                                                                              default: _withCtx(() => [...(_cache[71] || (_cache[71] = [
                                                                                _createTextVNode("mdi-account", -1)
                                                                              ]))]),
                                                                              _: 1
                                                                            }),
                                                                            _cache[72] || (_cache[72] = _createTextVNode(" 실수령액 증가 ", -1))
                                                                          ]),
                                                                          _createElementVNode("span", _hoisted_115, "+" + _toDisplayString(formatMoney(payrollDetails.value[groupIndex].employeeTaxSavings)) + "원", 1)
                                                                        ]),
                                                                        _createElementVNode("div", _hoisted_116, [
                                                                          _createElementVNode("span", _hoisted_117, [
                                                                            _createVNode(_component_v_icon, {
                                                                              size: "12",
                                                                              color: "#10b981"
                                                                            }, {
                                                                              default: _withCtx(() => [...(_cache[73] || (_cache[73] = [
                                                                                _createTextVNode("mdi-domain", -1)
                                                                              ]))]),
                                                                              _: 1
                                                                            }),
                                                                            _cache[74] || (_cache[74] = _createTextVNode(" 인건비 절감 ", -1))
                                                                          ]),
                                                                          _createElementVNode("span", _hoisted_118, "+" + _toDisplayString(formatMoney(payrollDetails.value[groupIndex].centerTaxSavings)) + "원", 1)
                                                                        ])
                                                                      ])
                                                                    ]))
                                                                  : _createCommentVNode("", true)
                                                              ]),
                                                              _createElementVNode("div", _hoisted_119, [
                                                                _cache[75] || (_cache[75] = _createElementVNode("span", { class: "label" }, "총 급여", -1)),
                                                                _createElementVNode("span", _hoisted_120, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].totalPay)) + "원", 1)
                                                              ]),
                                                              _createElementVNode("div", _hoisted_121, [
                                                                _createElementVNode("div", _hoisted_122, [
                                                                  _createVNode(_component_v_icon, {
                                                                    size: "14",
                                                                    color: "#7c3aed"
                                                                  }, {
                                                                    default: _withCtx(() => [...(_cache[76] || (_cache[76] = [
                                                                      _createTextVNode("mdi-calculator", -1)
                                                                    ]))]),
                                                                    _: 1
                                                                  }),
                                                                  _cache[77] || (_cache[77] = _createElementVNode("span", null, "과세/비과세 구분", -1))
                                                                ]),
                                                                _createElementVNode("div", _hoisted_123, [
                                                                  _createElementVNode("div", _hoisted_124, [
                                                                    _cache[78] || (_cache[78] = _createElementVNode("span", { class: "label" }, "과세 금액", -1)),
                                                                    _createElementVNode("span", _hoisted_125, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].taxableAmount)) + "원", 1)
                                                                  ]),
                                                                  _createElementVNode("div", _hoisted_126, [
                                                                    _cache[79] || (_cache[79] = _createElementVNode("span", { class: "label" }, "비과세 금액", -1)),
                                                                    _createElementVNode("span", _hoisted_127, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].nonTaxableAmount)) + "원", 1)
                                                                  ]),
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(["payroll-item-compact profit-highlight", {
                                        'positive': calculateCenterProfit(group, groupIndex) > 0,
                                        'negative': calculateCenterProfit(group, groupIndex) < 0
                                      }])
                                                                  }, [
                                                                    _cache[80] || (_cache[80] = _createElementVNode("span", { class: "label" }, "기관 수익", -1)),
                                                                    _createElementVNode("span", _hoisted_128, _toDisplayString(formatMoney(calculateCenterProfit(group, groupIndex))) + "원", 1)
                                                                  ], 2),
                                                                  _createElementVNode("div", _hoisted_129, [
                                                                    _cache[81] || (_cache[81] = _createElementVNode("span", { class: "label" }, "누적퇴직금", -1)),
                                                                    _createElementVNode("span", _hoisted_130, _toDisplayString(formatMoney(cumulativeRetirement.value[group.name] || 0)) + "원", 1)
                                                                  ])
                                                                ])
                                                              ]),
                                                              _createElementVNode("div", _hoisted_131, [
                                                                _createElementVNode("div", _hoisted_132, [
                                                                  _createVNode(_component_v_icon, {
                                                                    size: "14",
                                                                    color: "#dc2626"
                                                                  }, {
                                                                    default: _withCtx(() => [...(_cache[82] || (_cache[82] = [
                                                                      _createTextVNode("mdi-minus-circle", -1)
                                                                    ]))]),
                                                                    _: 1
                                                                  }),
                                                                  _cache[83] || (_cache[83] = _createElementVNode("span", null, "근로자 공제", -1))
                                                                ]),
                                                                _createElementVNode("div", _hoisted_133, [
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(["payroll-item-compact", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                                    title: deductionTooltip(groupIndex, 'nationalPension')
                                                                  }, [
                                                                    _cache[84] || (_cache[84] = _createElementVNode("span", { class: "label" }, "국민연금", -1)),
                                                                    _createElementVNode("span", _hoisted_135, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].employeeDeductions.nationalPension)) + "원", 1)
                                                                  ], 10, _hoisted_134),
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(["payroll-item-compact", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                                    title: deductionTooltip(groupIndex, 'healthInsurance')
                                                                  }, [
                                                                    _cache[85] || (_cache[85] = _createElementVNode("span", { class: "label" }, "건강보험", -1)),
                                                                    _createElementVNode("span", _hoisted_137, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].employeeDeductions.healthInsurance)) + "원", 1)
                                                                  ], 10, _hoisted_136),
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(["payroll-item-compact", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                                    title: deductionTooltip(groupIndex, 'longTermCare')
                                                                  }, [
                                                                    _cache[86] || (_cache[86] = _createElementVNode("span", { class: "label" }, "장기요양보험", -1)),
                                                                    _createElementVNode("span", _hoisted_139, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].employeeDeductions.longTermCare)) + "원", 1)
                                                                  ], 10, _hoisted_138),
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(["payroll-item-compact", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                                    title: deductionTooltip(groupIndex, 'employmentInsurance')
                                                                  }, [
                                                                    _cache[87] || (_cache[87] = _createElementVNode("span", { class: "label" }, "고용보험", -1)),
                                                                    _createElementVNode("span", _hoisted_141, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].employeeDeductions.employmentInsurance)) + "원", 1)
                                                                  ], 10, _hoisted_140),
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(["payroll-item-compact", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                                    title: deductionTooltip(groupIndex, 'incomeTax')
                                                                  }, [
                                                                    _cache[88] || (_cache[88] = _createElementVNode("span", { class: "label" }, "소득세", -1)),
                                                                    _createElementVNode("span", _hoisted_143, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].employeeDeductions.incomeTax)) + "원", 1)
                                                                  ], 10, _hoisted_142),
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(["payroll-item-compact", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                                    title: deductionTooltip(groupIndex, 'localTax')
                                                                  }, [
                                                                    _cache[89] || (_cache[89] = _createElementVNode("span", { class: "label" }, "지방세", -1)),
                                                                    _createElementVNode("span", _hoisted_145, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].employeeDeductions.localTax)) + "원", 1)
                                                                  ], 10, _hoisted_144),
                                                                  (payrollDetails.value[groupIndex].boninPayAmount > 0)
                                                                    ? (_openBlock(), _createElementBlock("div", {
                                                                        key: 0,
                                                                        class: _normalizeClass(["payroll-item-compact", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                                        title: deductionTooltip(groupIndex, 'boninPay')
                                                                      }, [
                                                                        _cache[90] || (_cache[90] = _createElementVNode("span", { class: "label" }, "본인부담금", -1)),
                                                                        _createElementVNode("span", _hoisted_147, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].boninPayAmount)) + "원", 1)
                                                                      ], 10, _hoisted_146))
                                                                    : _createCommentVNode("", true),
                                                                  (payrollDetails.value[groupIndex].empEtcAmount > 0)
                                                                    ? (_openBlock(), _createElementBlock("div", {
                                                                        key: 1,
                                                                        class: _normalizeClass(["payroll-item-compact", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                                        title: deductionTooltip(groupIndex, 'empEtc')
                                                                      }, [
                                                                        _cache[91] || (_cache[91] = _createElementVNode("span", { class: "label" }, "기타공제", -1)),
                                                                        _createElementVNode("span", _hoisted_149, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].empEtcAmount)) + "원", 1)
                                                                      ], 10, _hoisted_148))
                                                                    : _createCommentVNode("", true),
                                                                  (payrollDetails.value[groupIndex].supportDeduction > 0)
                                                                    ? (_openBlock(), _createElementBlock("div", {
                                                                        key: 2,
                                                                        class: _normalizeClass(["payroll-item-compact", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                                        title: deductionTooltip(groupIndex, 'supportDeduction')
                                                                      }, [
                                                                        _cache[92] || (_cache[92] = _createElementVNode("span", { class: "label" }, "지원공제", -1)),
                                                                        _createElementVNode("span", _hoisted_151, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].supportDeduction)) + "원", 1)
                                                                      ], 10, _hoisted_150))
                                                                    : _createCommentVNode("", true),
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(["payroll-item-compact subtotal", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                                    title: deductionTooltip(groupIndex, 'totalDeduction')
                                                                  }, [
                                                                    _cache[93] || (_cache[93] = _createElementVNode("span", { class: "label" }, "공제 합계", -1)),
                                                                    _createElementVNode("span", _hoisted_153, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].totalEmployeeDeduction)) + "원", 1)
                                                                  ], 10, _hoisted_152)
                                                                ])
                                                              ]),
                                                              _createElementVNode("div", _hoisted_154, [
                                                                _createElementVNode("div", _hoisted_155, [
                                                                  _createVNode(_component_v_icon, {
                                                                    size: "14",
                                                                    color: "#ea580c"
                                                                  }, {
                                                                    default: _withCtx(() => [...(_cache[94] || (_cache[94] = [
                                                                      _createTextVNode("mdi-domain", -1)
                                                                    ]))]),
                                                                    _: 1
                                                                  }),
                                                                  _cache[95] || (_cache[95] = _createElementVNode("span", null, "기관 공제", -1))
                                                                ]),
                                                                _createElementVNode("div", _hoisted_156, [
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(["payroll-item-compact", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                                    title: centerTooltip(groupIndex, 'nationalPension')
                                                                  }, [
                                                                    _cache[96] || (_cache[96] = _createElementVNode("span", { class: "label" }, "국민연금", -1)),
                                                                    _createElementVNode("span", _hoisted_158, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].centerDeductions.nationalPension)) + "원", 1)
                                                                  ], 10, _hoisted_157),
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(["payroll-item-compact", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                                    title: centerTooltip(groupIndex, 'healthInsurance')
                                                                  }, [
                                                                    _cache[97] || (_cache[97] = _createElementVNode("span", { class: "label" }, "건강보험", -1)),
                                                                    _createElementVNode("span", _hoisted_160, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].centerDeductions.healthInsurance)) + "원", 1)
                                                                  ], 10, _hoisted_159),
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(["payroll-item-compact", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                                    title: centerTooltip(groupIndex, 'longTermCare')
                                                                  }, [
                                                                    _cache[98] || (_cache[98] = _createElementVNode("span", { class: "label" }, "장기요양보험", -1)),
                                                                    _createElementVNode("span", _hoisted_162, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].centerDeductions.longTermCare)) + "원", 1)
                                                                  ], 10, _hoisted_161),
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(["payroll-item-compact", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                                    title: centerTooltip(groupIndex, 'employmentInsurance')
                                                                  }, [
                                                                    _cache[99] || (_cache[99] = _createElementVNode("span", { class: "label" }, "고용보험", -1)),
                                                                    _createElementVNode("span", _hoisted_164, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].centerDeductions.employmentInsurance)) + "원", 1)
                                                                  ], 10, _hoisted_163),
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(["payroll-item-compact", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                                    title: centerTooltip(groupIndex, 'unemployment')
                                                                  }, [
                                                                    _cache[100] || (_cache[100] = _createElementVNode("span", { class: "label" }, "실업급여", -1)),
                                                                    _createElementVNode("span", _hoisted_166, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].centerDeductions.unemployment)) + "원", 1)
                                                                  ], 10, _hoisted_165),
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(["payroll-item-compact", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                                    title: centerTooltip(groupIndex, 'industrialAccident')
                                                                  }, [
                                                                    _cache[101] || (_cache[101] = _createElementVNode("span", { class: "label" }, "산재보험", -1)),
                                                                    _createElementVNode("span", _hoisted_168, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].centerDeductions.industrialAccident)) + "원", 1)
                                                                  ], 10, _hoisted_167),
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(["payroll-item-compact", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                                    title: centerTooltip(groupIndex, 'retirement')
                                                                  }, [
                                                                    _cache[102] || (_cache[102] = _createElementVNode("span", { class: "label" }, "퇴직금", -1)),
                                                                    _createElementVNode("span", _hoisted_170, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].centerDeductions.retirement)) + "원", 1)
                                                                  ], 10, _hoisted_169),
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(["payroll-item-compact subtotal", { 'has-deduction-tooltip': showAdminDeductionTooltip.value }]),
                                                                    title: centerTooltip(groupIndex, 'totalCenter')
                                                                  }, [
                                                                    _cache[103] || (_cache[103] = _createElementVNode("span", { class: "label" }, "공제 합계", -1)),
                                                                    _createElementVNode("span", _hoisted_172, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].totalCenterDeduction)) + "원", 1)
                                                                  ], 10, _hoisted_171)
                                                                ])
                                                              ]),
                                                              _createElementVNode("div", _hoisted_173, [
                                                                _cache[104] || (_cache[104] = _createElementVNode("span", { class: "label" }, "실수령액", -1)),
                                                                _createElementVNode("span", _hoisted_174, _toDisplayString(formatMoney(payrollDetails.value[groupIndex].netPay)) + "원", 1)
                                                              ])
                                                            ]))
                                                          : (_openBlock(), _createElementBlock("div", _hoisted_175, [
                                                              _createVNode(_component_v_icon, {
                                                                size: "32",
                                                                color: "#9ca3af"
                                                              }, {
                                                                default: _withCtx(() => [...(_cache[105] || (_cache[105] = [
                                                                  _createTextVNode("mdi-calculator-variant-outline", -1)
                                                                ]))]),
                                                                _: 1
                                                              }),
                                                              _cache[106] || (_cache[106] = _createElementVNode("p", null, "급여 정보를 계산할 수 없습니다.", -1))
                                                            ]))
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_window_item, { value: "info" }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("div", _hoisted_176, [
                                                          _createElementVNode("div", _hoisted_177, [
                                                            _createElementVNode("div", _hoisted_178, [
                                                              _createVNode(_component_v_icon, {
                                                                size: "16",
                                                                color: "#3b82f6"
                                                              }, {
                                                                default: _withCtx(() => [...(_cache[107] || (_cache[107] = [
                                                                  _createTextVNode("mdi-information", -1)
                                                                ]))]),
                                                                _: 1
                                                              }),
                                                              _cache[108] || (_cache[108] = _createElementVNode("span", null, "일반 정보", -1))
                                                            ]),
                                                            _createElementVNode("div", _hoisted_179, [
                                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getEmployeeFeatures(group, groupIndex).info, (feature, fIdx) => {
                                                                return (_openBlock(), _createElementBlock("div", {
                                                                  key: fIdx,
                                                                  class: _normalizeClass(["feature-item", feature.type])
                                                                }, [
                                                                  _createVNode(_component_v_icon, {
                                                                    size: 14,
                                                                    color: feature.iconColor
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createTextVNode(_toDisplayString(feature.icon), 1)
                                                                    ]),
                                                                    _: 2
                                                                  }, 1032, ["color"]),
                                                                  _createElementVNode("span", null, _toDisplayString(feature.text), 1)
                                                                ], 2))
                                                              }), 128))
                                                            ])
                                                          ]),
                                                          _createElementVNode("div", _hoisted_180, [
                                                            _createElementVNode("div", _hoisted_181, [
                                                              _createVNode(_component_v_icon, {
                                                                size: "16",
                                                                color: "#f59e0b"
                                                              }, {
                                                                default: _withCtx(() => [...(_cache[109] || (_cache[109] = [
                                                                  _createTextVNode("mdi-alert-circle", -1)
                                                                ]))]),
                                                                _: 1
                                                              }),
                                                              _cache[110] || (_cache[110] = _createElementVNode("span", null, "제한사항", -1))
                                                            ]),
                                                            _createElementVNode("div", _hoisted_182, [
                                                              (getEmployeeFeatures(group, groupIndex).restrictions.length > 0)
                                                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(getEmployeeFeatures(group, groupIndex).restrictions, (feature, fIdx) => {
                                                                    return (_openBlock(), _createElementBlock(_Fragment, { key: fIdx }, [
                                                                      _createElementVNode("div", {
                                                                        class: _normalizeClass(["feature-item", [feature.type, { 'clickable': feature.expandable, 'expanded': feature.expanded }]]),
                                                                        onClick: ($event: any) => (feature.expandable && toggleRestrictionDetail(groupIndex, fIdx))
                                                                      }, [
                                                                        _createVNode(_component_v_icon, {
                                                                          size: 14,
                                                                          color: feature.iconColor
                                                                        }, {
                                                                          default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(feature.icon), 1)
                                                                          ]),
                                                                          _: 2
                                                                        }, 1032, ["color"]),
                                                                        _createElementVNode("span", null, _toDisplayString(feature.text), 1),
                                                                        (feature.expandable)
                                                                          ? (_openBlock(), _createBlock(_component_v_icon, {
                                                                              key: 0,
                                                                              size: "14",
                                                                              color: "#f59e0b",
                                                                              class: "expand-icon"
                                                                            }, {
                                                                              default: _withCtx(() => [
                                                                                _createTextVNode(_toDisplayString(feature.expanded ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                                                              ]),
                                                                              _: 2
                                                                            }, 1024))
                                                                          : _createCommentVNode("", true)
                                                                      ], 10, _hoisted_183),
                                                                      (feature.details && feature.expanded)
                                                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(feature.details, (detail, dIdx) => {
                                                                            return (_openBlock(), _createElementBlock("div", {
                                                                              key: `detail-${fIdx}-${dIdx}`,
                                                                              class: "feature-detail"
                                                                            }, [
                                                                              _createVNode(_component_v_icon, {
                                                                                size: 12,
                                                                                color: detail.iconColor
                                                                              }, {
                                                                                default: _withCtx(() => [
                                                                                  _createTextVNode(_toDisplayString(detail.icon), 1)
                                                                                ]),
                                                                                _: 2
                                                                              }, 1032, ["color"]),
                                                                              _createElementVNode("span", null, _toDisplayString(detail.text), 1)
                                                                            ]))
                                                                          }), 128))
                                                                        : _createCommentVNode("", true)
                                                                    ], 64))
                                                                  }), 128))
                                                                : (_openBlock(), _createElementBlock("div", _hoisted_184, [
                                                                    _createVNode(_component_v_icon, {
                                                                      size: "20",
                                                                      color: "#10b981"
                                                                    }, {
                                                                      default: _withCtx(() => [...(_cache[111] || (_cache[111] = [
                                                                        _createTextVNode("mdi-check-circle", -1)
                                                                      ]))]),
                                                                      _: 1
                                                                    }),
                                                                    _cache[112] || (_cache[112] = _createElementVNode("span", null, "제한사항 없음", -1))
                                                                  ]))
                                                            ])
                                                          ])
                                                        ])
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_window_item, { value: "services" }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("div", _hoisted_185, [
                                                          (individualServices.value[groupIndex] && individualServices.value[groupIndex].length > 0)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_186, [
                                                                _createElementVNode("table", _hoisted_187, [
                                                                  _cache[113] || (_cache[113] = _createElementVNode("thead", null, [
                                                                    _createElementVNode("tr", null, [
                                                                      _createElementVNode("th", null, "서비스일"),
                                                                      _createElementVNode("th", null, "수급자명"),
                                                                      _createElementVNode("th", null, "서비스시간"),
                                                                      _createElementVNode("th", null, "수가명"),
                                                                      _createElementVNode("th", null, "서비스시간"),
                                                                      _createElementVNode("th", null, "수가금액")
                                                                    ])
                                                                  ], -1)),
                                                                  _createElementVNode("tbody", null, [
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(individualServices.value[groupIndex], (service, sIdx) => {
                                                                      return (_openBlock(), _createElementBlock("tr", { key: sIdx }, [
                                                                        _createElementVNode("td", null, [
                                                                          _createElementVNode("div", _hoisted_188, [
                                                                            _createTextVNode(_toDisplayString(service.service_date) + " ", 1),
                                                                            (isSunday(service.service_date))
                                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_189, "일"))
                                                                              : _createCommentVNode("", true),
                                                                            (getHolidayName(service.service_date))
                                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_190, _toDisplayString(getHolidayName(service.service_date)), 1))
                                                                              : _createCommentVNode("", true)
                                                                          ])
                                                                        ]),
                                                                        _createElementVNode("td", null, _toDisplayString(service.patient_name), 1),
                                                                        _createElementVNode("td", null, [
                                                                          _createTextVNode(_toDisplayString(service.start_time) + "~" + _toDisplayString(service.end_time) + " ", 1),
                                                                          (service.is_lunch_time)
                                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_191, "식대"))
                                                                            : _createCommentVNode("", true)
                                                                        ]),
                                                                        _createElementVNode("td", null, _toDisplayString(service.suga_name), 1),
                                                                        _createElementVNode("td", null, _toDisplayString(formatTotalMinutes(service.service_minutes)), 1),
                                                                        _createElementVNode("td", _hoisted_192, _toDisplayString(formatMoney(service.suga_money)) + "원", 1)
                                                                      ]))
                                                                    }), 128))
                                                                  ])
                                                                ])
                                                              ]))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_193, [
                                                                _createVNode(_component_v_icon, {
                                                                  size: "32",
                                                                  color: "#9ca3af"
                                                                }, {
                                                                  default: _withCtx(() => [...(_cache[114] || (_cache[114] = [
                                                                    _createTextVNode("mdi-clipboard-text-outline", -1)
                                                                  ]))]),
                                                                  _: 1
                                                                }),
                                                                _cache[115] || (_cache[115] = _createElementVNode("p", null, "서비스 내역이 없습니다.", -1))
                                                              ]))
                                                        ])
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_window_item, { value: "weekly" }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("div", _hoisted_194, [
                                                          (combinedWeeklyServices.value[groupIndex] && combinedWeeklyServices.value[groupIndex].length > 0)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_195, [
                                                                _createElementVNode("table", _hoisted_196, [
                                                                  _cache[116] || (_cache[116] = _createElementVNode("thead", null, [
                                                                    _createElementVNode("tr", null, [
                                                                      _createElementVNode("th", { class: "week-col" }, "주차"),
                                                                      _createElementVNode("th", { class: "date-col" }, "서비스일"),
                                                                      _createElementVNode("th", { class: "daily-col" }, "일일 근무시간"),
                                                                      _createElementVNode("th", { class: "total-col" }, "주간 합계")
                                                                    ])
                                                                  ], -1)),
                                                                  _createElementVNode("tbody", null, [
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(combinedWeeklyServices.value[groupIndex], (weekGroup, wIdx) => {
                                                                      return (_openBlock(), _createElementBlock(_Fragment, {
                                                                        key: `week-${wIdx}`
                                                                      }, [
                                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weekGroup.daily_items, (dailyItem, dIdx) => {
                                                                          return (_openBlock(), _createElementBlock("tr", {
                                                                            key: `daily-${wIdx}-${dIdx}`,
                                                                            class: _normalizeClass({ 'week-first': dIdx === 0 })
                                                                          }, [
                                                                            (dIdx === 0)
                                                                              ? (_openBlock(), _createElementBlock("td", {
                                                                                  key: 0,
                                                                                  rowspan: weekGroup.daily_items.length,
                                                                                  class: "week-cell"
                                                                                }, [
                                                                                  _createElementVNode("span", _hoisted_198, _toDisplayString(weekGroup.service_week) + "주차", 1)
                                                                                ], 8, _hoisted_197))
                                                                              : _createCommentVNode("", true),
                                                                            _createElementVNode("td", _hoisted_199, [
                                                                              _createElementVNode("div", _hoisted_200, [
                                                                                _createTextVNode(_toDisplayString(dailyItem.service_date) + " ", 1),
                                                                                (isSunday(dailyItem.service_date))
                                                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_201, "일"))
                                                                                  : _createCommentVNode("", true),
                                                                                (getHolidayName(dailyItem.service_date))
                                                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_202, _toDisplayString(getHolidayName(dailyItem.service_date)), 1))
                                                                                  : _createCommentVNode("", true)
                                                                              ])
                                                                            ]),
                                                                            _createElementVNode("td", {
                                                                              class: _normalizeClass(["hours-cell", { 'overtime-cell': dailyItem.daily_total_hours > 8 }])
                                                                            }, _toDisplayString(dailyItem.daily_total_hours) + "시간 ", 3),
                                                                            (dIdx === 0)
                                                                              ? (_openBlock(), _createElementBlock("td", {
                                                                                  key: 1,
                                                                                  rowspan: weekGroup.daily_items.length,
                                                                                  class: _normalizeClass(["total-cell", { 'overtime-cell': weekGroup.weekly_total_hours > 40 }])
                                                                                }, _toDisplayString(weekGroup.weekly_total_hours) + "시간 ", 11, _hoisted_203))
                                                                              : _createCommentVNode("", true)
                                                                          ], 2))
                                                                        }), 128))
                                                                      ], 64))
                                                                    }), 128))
                                                                  ])
                                                                ])
                                                              ]))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_204, [
                                                                _createVNode(_component_v_icon, {
                                                                  size: "32",
                                                                  color: "#9ca3af"
                                                                }, {
                                                                  default: _withCtx(() => [...(_cache[117] || (_cache[117] = [
                                                                    _createTextVNode("mdi-calendar-clock-outline", -1)
                                                                  ]))]),
                                                                  _: 1
                                                                }),
                                                                _cache[118] || (_cache[118] = _createElementVNode("p", null, "주차별 근무내역이 없습니다.", -1))
                                                              ]))
                                                        ])
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["modelValue", "onUpdate:modelValue"])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (isLoadingMemberInfo.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_205, [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "#1e3a8a",
              size: "32"
            }),
            _cache[120] || (_cache[120] = _createElementVNode("span", null, "사원 급여 정보를 불러오는 중입니다...", -1))
          ]))
        : _createCommentVNode("", true),
      (!isLoadingMemberInfo.value && memberInfoData.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_206, [
            _createVNode(_component_v_icon, {
              size: "32",
              color: "#9ca3af"
            }, {
              default: _withCtx(() => [...(_cache[121] || (_cache[121] = [
                _createTextVNode("mdi-file-document-alert", -1)
              ]))]),
              _: 1
            }),
            _cache[122] || (_cache[122] = _createElementVNode("p", null, "아직 등록된 사원 급여 정보가 없습니다.", -1))
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_dialog, {
        modelValue: showConfirmDialog.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((showConfirmDialog).value = $event)),
        "max-width": "440px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "confirm-dialog" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_207, [
                _createVNode(_component_v_icon, {
                  size: "48",
                  color: "#10b981"
                }, {
                  default: _withCtx(() => [...(_cache[123] || (_cache[123] = [
                    _createTextVNode("mdi-lock-check", -1)
                  ]))]),
                  _: 1
                }),
                _cache[124] || (_cache[124] = _createElementVNode("h3", null, "급여 설정 확정", -1))
              ]),
              _cache[125] || (_cache[125] = _createElementVNode("div", { class: "confirm-dialog-body" }, [
                _createElementVNode("p", null, "급여 설정을 확정하시겠습니까?"),
                _createElementVNode("p", null, "확정 후에는 급여 설정을 수정할 수 없습니다.")
              ], -1)),
              _createElementVNode("div", _hoisted_208, [
                _createElementVNode("button", {
                  class: "btn-cancel",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (showConfirmDialog.value = false))
                }, "취소"),
                _createElementVNode("button", {
                  class: "btn-confirm",
                  onClick: proceedConfirm
                }, "확정")
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: showReleaseDialog.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((showReleaseDialog).value = $event)),
        "max-width": "440px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "confirm-dialog" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_209, [
                _createVNode(_component_v_icon, {
                  size: "48",
                  color: "#f59e0b"
                }, {
                  default: _withCtx(() => [...(_cache[126] || (_cache[126] = [
                    _createTextVNode("mdi-alert-circle", -1)
                  ]))]),
                  _: 1
                }),
                _cache[127] || (_cache[127] = _createElementVNode("h3", null, "확정 해제", -1))
              ]),
              _cache[128] || (_cache[128] = _createElementVNode("div", { class: "confirm-dialog-body" }, [
                _createElementVNode("p", null, "급여 설정 확정을 해제하시겠습니까?"),
                _createElementVNode("p", null, "해제 후에는 다시 수정이 가능합니다.")
              ], -1)),
              _createElementVNode("div", _hoisted_210, [
                _createElementVNode("button", {
                  class: "btn-cancel",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (showReleaseDialog.value = false))
                }, "취소"),
                _createElementVNode("button", {
                  class: "btn-confirm warning",
                  onClick: proceedRelease
                }, "해제")
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: showBoninPayModal.value,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((showBoninPayModal).value = $event)),
        "max-width": "480px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "confirm-dialog bonin-pay-modal" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_211, [
                _createVNode(_component_v_icon, {
                  size: "48",
                  color: "#8b5cf6"
                }, {
                  default: _withCtx(() => [...(_cache[129] || (_cache[129] = [
                    _createTextVNode("mdi-cash-minus", -1)
                  ]))]),
                  _: 1
                }),
                _cache[130] || (_cache[130] = _createElementVNode("h3", null, "본인부담금공제 설정", -1))
              ]),
              _createElementVNode("div", _hoisted_212, [
                _cache[138] || (_cache[138] = _createElementVNode("p", { class: "modal-description" }, "가족요양 수가금액에서 본인부담금을 공제합니다.", -1)),
                _createElementVNode("div", _hoisted_213, [
                  _createElementVNode("div", _hoisted_214, [
                    _cache[131] || (_cache[131] = _createElementVNode("span", { class: "info-label" }, "요양보호사", -1)),
                    _createElementVNode("span", _hoisted_215, _toDisplayString(currentBoninPayCaregiver.value?.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_216, [
                    _cache[132] || (_cache[132] = _createElementVNode("span", { class: "info-label" }, "가족요양 수가금액", -1)),
                    _createElementVNode("span", _hoisted_217, _toDisplayString(formatMoney(currentBoninPayCaregiver.value?.familySugaMoney || 0)) + "원", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_218, [
                  _cache[137] || (_cache[137] = _createElementVNode("p", { class: "options-title" }, "공제 비율 선택", -1)),
                  _createElementVNode("div", _hoisted_219, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["option-btn", { 'active': selectedBoninRate.value === 15 }]),
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (selectBoninRate(15)))
                    }, [
                      _cache[133] || (_cache[133] = _createElementVNode("span", { class: "rate" }, "15%", -1)),
                      _createElementVNode("span", _hoisted_220, _toDisplayString(formatMoney(calculateBoninAmount(15))) + "원", 1)
                    ], 2),
                    _createElementVNode("button", {
                      class: _normalizeClass(["option-btn", { 'active': selectedBoninRate.value === 9 }]),
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (selectBoninRate(9)))
                    }, [
                      _cache[134] || (_cache[134] = _createElementVNode("span", { class: "rate" }, "9%", -1)),
                      _createElementVNode("span", _hoisted_221, _toDisplayString(formatMoney(calculateBoninAmount(9))) + "원", 1)
                    ], 2),
                    _createElementVNode("button", {
                      class: _normalizeClass(["option-btn", { 'active': selectedBoninRate.value === 6 }]),
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (selectBoninRate(6)))
                    }, [
                      _cache[135] || (_cache[135] = _createElementVNode("span", { class: "rate" }, "6%", -1)),
                      _createElementVNode("span", _hoisted_222, _toDisplayString(formatMoney(calculateBoninAmount(6))) + "원", 1)
                    ], 2),
                    _createElementVNode("button", {
                      class: _normalizeClass(["option-btn no-deduction", { 'active': selectedBoninRate.value === 0 }]),
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (selectBoninRate(0)))
                    }, [...(_cache[136] || (_cache[136] = [
                      _createElementVNode("span", { class: "rate" }, "0%", -1),
                      _createElementVNode("span", { class: "amount" }, "공제 안 함", -1)
                    ]))], 2)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_223, [
                _createElementVNode("button", {
                  class: "btn-cancel",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (showBoninPayModal.value = false))
                }, "취소"),
                _createElementVNode("button", {
                  class: "btn-confirm",
                  onClick: applyBoninPayRate,
                  disabled: selectedBoninRate.value === null
                }, "적용", 8, _hoisted_224)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: showEmploymentModal.value,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((showEmploymentModal).value = $event)),
        "max-width": "520px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "confirm-dialog employment-modal" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_225, [
                _createVNode(_component_v_icon, {
                  size: "48",
                  color: "#3b82f6"
                }, {
                  default: _withCtx(() => [...(_cache[139] || (_cache[139] = [
                    _createTextVNode("mdi-briefcase-check", -1)
                  ]))]),
                  _: 1
                }),
                _cache[140] || (_cache[140] = _createElementVNode("h3", null, "고용보험 설정", -1))
              ]),
              _createElementVNode("div", _hoisted_226, [
                _createElementVNode("div", _hoisted_227, [
                  _createElementVNode("div", _hoisted_228, [
                    _cache[141] || (_cache[141] = _createElementVNode("span", { class: "info-label" }, "요양보호사", -1)),
                    _createElementVNode("span", _hoisted_229, _toDisplayString(currentEmploymentCaregiver.value?.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_230, [
                    _cache[142] || (_cache[142] = _createElementVNode("span", { class: "info-label" }, "만 나이", -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass(["info-value", { 'highlight-warning': currentEmploymentCaregiver.value && currentEmploymentCaregiver.value.age >= 65 }])
                    }, [
                      _createTextVNode(_toDisplayString(currentEmploymentCaregiver.value?.age) + "세 ", 1),
                      (currentEmploymentCaregiver.value && currentEmploymentCaregiver.value.age >= 65)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_231, "(고용보험 납부 의무 없음)"))
                        : _createCommentVNode("", true)
                    ], 2)
                  ])
                ]),
                _createElementVNode("div", _hoisted_232, [
                  _cache[152] || (_cache[152] = _createElementVNode("p", { class: "options-title" }, "적용할 항목을 선택하세요", -1)),
                  _createElementVNode("button", {
                    class: _normalizeClass(["employment-option-btn", { 'active': selectedEmploymentOption.value === 'both' }]),
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (selectedEmploymentOption.value = 'both'))
                  }, [
                    _createElementVNode("div", _hoisted_233, [
                      _createVNode(_component_v_icon, {
                        size: "24",
                        color: selectedEmploymentOption.value === 'both' ? '#3b82f6' : '#9ca3af'
                      }, {
                        default: _withCtx(() => [...(_cache[143] || (_cache[143] = [
                          _createTextVNode("mdi-check-all", -1)
                        ]))]),
                        _: 1
                      }, 8, ["color"])
                    ]),
                    _cache[145] || (_cache[145] = _createElementVNode("div", { class: "option-content" }, [
                      _createElementVNode("p", { class: "option-name" }, "고용보험 + 실업급여 모두 적용"),
                      _createElementVNode("p", { class: "option-desc" }, "근로자: 고용보험료 공제 / 기관: 고용보험료 + 실업급여 공제")
                    ], -1)),
                    _createElementVNode("div", _hoisted_234, [
                      (selectedEmploymentOption.value === 'both')
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            size: "20",
                            color: "#3b82f6"
                          }, {
                            default: _withCtx(() => [...(_cache[144] || (_cache[144] = [
                              _createTextVNode("mdi-check-circle", -1)
                            ]))]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ], 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["employment-option-btn", { 'active': selectedEmploymentOption.value === 'unemployment-only' }]),
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (selectedEmploymentOption.value = 'unemployment-only'))
                  }, [
                    _createElementVNode("div", _hoisted_235, [
                      _createVNode(_component_v_icon, {
                        size: "24",
                        color: selectedEmploymentOption.value === 'unemployment-only' ? '#f59e0b' : '#9ca3af'
                      }, {
                        default: _withCtx(() => [...(_cache[146] || (_cache[146] = [
                          _createTextVNode("mdi-domain", -1)
                        ]))]),
                        _: 1
                      }, 8, ["color"])
                    ]),
                    _cache[148] || (_cache[148] = _createElementVNode("div", { class: "option-content" }, [
                      _createElementVNode("p", { class: "option-name" }, "실업급여만 적용 (고용보험 미적용)"),
                      _createElementVNode("p", { class: "option-desc" }, "근로자: 공제 없음 / 기관: 실업급여만 공제")
                    ], -1)),
                    _createElementVNode("div", _hoisted_236, [
                      (selectedEmploymentOption.value === 'unemployment-only')
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            size: "20",
                            color: "#f59e0b"
                          }, {
                            default: _withCtx(() => [...(_cache[147] || (_cache[147] = [
                              _createTextVNode("mdi-check-circle", -1)
                            ]))]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ], 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["employment-option-btn", { 'active': selectedEmploymentOption.value === 'none' }]),
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (selectedEmploymentOption.value = 'none'))
                  }, [
                    _createElementVNode("div", _hoisted_237, [
                      _createVNode(_component_v_icon, {
                        size: "24",
                        color: selectedEmploymentOption.value === 'none' ? '#ef4444' : '#9ca3af'
                      }, {
                        default: _withCtx(() => [...(_cache[149] || (_cache[149] = [
                          _createTextVNode("mdi-close-circle", -1)
                        ]))]),
                        _: 1
                      }, 8, ["color"])
                    ]),
                    _cache[151] || (_cache[151] = _createElementVNode("div", { class: "option-content" }, [
                      _createElementVNode("p", { class: "option-name" }, "모두 미적용"),
                      _createElementVNode("p", { class: "option-desc" }, "고용보험, 실업급여 모두 적용하지 않음")
                    ], -1)),
                    _createElementVNode("div", _hoisted_238, [
                      (selectedEmploymentOption.value === 'none')
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            size: "20",
                            color: "#ef4444"
                          }, {
                            default: _withCtx(() => [...(_cache[150] || (_cache[150] = [
                              _createTextVNode("mdi-check-circle", -1)
                            ]))]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ], 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_239, [
                _createElementVNode("button", {
                  class: "btn-cancel",
                  onClick: cancelEmploymentModal
                }, "취소"),
                _createElementVNode("button", {
                  class: "btn-confirm",
                  onClick: applyEmploymentInsurance,
                  disabled: !selectedEmploymentOption.value
                }, "적용", 8, _hoisted_240)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: showSugaHoursModal.value,
        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((showSugaHoursModal).value = $event)),
        "max-width": "400px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "confirm-dialog suga-hours-modal" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_241, [
                _createVNode(_component_v_icon, {
                  size: "48",
                  color: "#1e3a8a"
                }, {
                  default: _withCtx(() => [...(_cache[153] || (_cache[153] = [
                    _createTextVNode("mdi-clock-edit-outline", -1)
                  ]))]),
                  _: 1
                }),
                _cache[154] || (_cache[154] = _createElementVNode("h3", null, "수가시간 조정", -1))
              ]),
              _createElementVNode("div", _hoisted_242, [
                _createElementVNode("div", _hoisted_243, [
                  _createElementVNode("div", _hoisted_244, [
                    _cache[155] || (_cache[155] = _createElementVNode("span", { class: "info-label" }, "수급자", -1)),
                    _createElementVNode("span", _hoisted_245, _toDisplayString(currentSugaHoursPatient.value?.patientName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_246, [
                    _cache[156] || (_cache[156] = _createElementVNode("span", { class: "info-label" }, "수가명", -1)),
                    _createElementVNode("span", _hoisted_247, _toDisplayString(currentSugaHoursPatient.value?.sugaName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_248, [
                    _cache[157] || (_cache[157] = _createElementVNode("span", { class: "info-label" }, "원래 시간", -1)),
                    _createElementVNode("span", _hoisted_249, _toDisplayString(formatSugaHours(currentSugaHoursPatient.value?.originalHours || 0)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_250, [
                  _cache[162] || (_cache[162] = _createElementVNode("p", { class: "selector-title" }, "수가시간 선택 (30분 단위)", -1)),
                  _createElementVNode("div", _hoisted_251, [
                    _createElementVNode("button", {
                      class: "hours-btn minus",
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (adjustSugaHours(-0.5))),
                      disabled: selectedSugaHours.value <= 0.5
                    }, [
                      _createVNode(_component_v_icon, { size: "24" }, {
                        default: _withCtx(() => [...(_cache[158] || (_cache[158] = [
                          _createTextVNode("mdi-minus", -1)
                        ]))]),
                        _: 1
                      })
                    ], 8, _hoisted_252),
                    _createElementVNode("div", _hoisted_253, [
                      _createElementVNode("span", _hoisted_254, _toDisplayString(formatSugaHours(selectedSugaHours.value)), 1),
                      (selectedSugaHours.value !== currentSugaHoursPatient.value?.originalHours)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass(["hours-diff", { 'positive': selectedSugaHours.value > (currentSugaHoursPatient.value?.originalHours || 0), 'negative': selectedSugaHours.value < (currentSugaHoursPatient.value?.originalHours || 0) }])
                          }, _toDisplayString(selectedSugaHours.value > (currentSugaHoursPatient.value?.originalHours || 0) ? '+' : '') + _toDisplayString(formatSugaHours(selectedSugaHours.value - (currentSugaHoursPatient.value?.originalHours || 0))), 3))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("button", {
                      class: "hours-btn plus",
                      onClick: _cache[21] || (_cache[21] = ($event: any) => (adjustSugaHours(0.5))),
                      disabled: selectedSugaHours.value >= 24
                    }, [
                      _createVNode(_component_v_icon, { size: "24" }, {
                        default: _withCtx(() => [...(_cache[159] || (_cache[159] = [
                          _createTextVNode("mdi-plus", -1)
                        ]))]),
                        _: 1
                      })
                    ], 8, _hoisted_255)
                  ]),
                  _createElementVNode("div", _hoisted_256, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3, 4, 5, 6, 7, 8], (hours) => {
                      return _createElementVNode("button", {
                        key: hours,
                        class: _normalizeClass(["preset-btn", { 'active': selectedSugaHours.value === hours }]),
                        onClick: ($event: any) => (selectedSugaHours.value = hours)
                      }, _toDisplayString(hours) + "시간 ", 11, _hoisted_257)
                    }), 64))
                  ]),
                  _createElementVNode("button", {
                    class: "reset-btn",
                    onClick: _cache[22] || (_cache[22] = ($event: any) => (selectedSugaHours.value = currentSugaHoursPatient.value?.originalHours || 0)),
                    disabled: selectedSugaHours.value === currentSugaHoursPatient.value?.originalHours
                  }, [
                    _createVNode(_component_v_icon, { size: "16" }, {
                      default: _withCtx(() => [...(_cache[160] || (_cache[160] = [
                        _createTextVNode("mdi-refresh", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[161] || (_cache[161] = _createTextVNode(" 원래 시간으로 복원 ", -1))
                  ], 8, _hoisted_258)
                ])
              ]),
              _createElementVNode("div", _hoisted_259, [
                _createElementVNode("button", {
                  class: "btn-cancel",
                  onClick: _cache[23] || (_cache[23] = ($event: any) => (showSugaHoursModal.value = false))
                }, "취소"),
                _createElementVNode("button", {
                  class: _normalizeClass(["btn-confirm", { 'changed': selectedSugaHours.value !== currentSugaHoursPatient.value?.originalHours }]),
                  onClick: applySugaHoursChange
                }, _toDisplayString(selectedSugaHours.value !== currentSugaHoursPatient.value?.originalHours ? '변경 적용' : '확인'), 3)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(SetModal, {
        modelValue: showSetModal.value,
        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((showSetModal).value = $event)),
        "leb-ym": __props.yearMonth,
        "sisul-code": _unref(store).state.user?.m_sisul_code,
        "current-data": memberInfoData.value,
        onApplyBulkTimePay: handleBulkTimePay,
        onApplyBulkTimePayFamily: handleBulkTimePayFamily,
        onApplyBulkTimePayFamily60: handleBulkTimePayFamily60,
        onApplyBulkTimePayFamily90: handleBulkTimePayFamily90,
        onApplyBulkHolidayAllowance: handleBulkHolidayAllowance,
        onApplyBulkOvertimeAllowance: handleBulkOvertimeAllowance,
        onApplyBulkRetirement: handleBulkRetirement,
        onApplyBulkMealAllowance: handleBulkMealAllowance,
        onApplyBulkLongServiceAutoCalculate: handleBulkLongServiceAutoCalculate,
        onApplyBulkLongServiceClear: handleBulkLongServiceClear,
        onApplyBulkLaborDayAllowance: handleBulkLaborDayAllowance,
        onApplyAllPreviousSettings: handleApplyAllPreviousSettings,
        onResetAllSettings: handleResetAllSettings
      }, null, 8, ["modelValue", "leb-ym", "sisul-code", "current-data"])
    ])
  ]))
}
}

})